import menu from "framework7-vue/components/menu";

const messages = {
    es: {
        atras: 'Atrás',
        cerrar: 'Cerrar',
        aceptar: 'Aceptar',
        searchBarBuscar: 'Buscar...',
        searchBarSinResultados: 'Sin Resultados...',
        Enero: 'Enero',
        Febrero: 'Febrero',
        Marzo: 'Marzo',
        Abril: 'Abril',
        Mayo: 'Mayo',
        Junio: 'Junio',
        Julio: 'Julio',
        Agosto: 'Agosto',
        Septiembre: 'Septiembre',
        Octubre: 'Octubre',
        Noviembre: 'Noviembre',
        Diciembre: 'Diciembre',
        common: {
            acciones: 'Acciones',
            borrarContenido: 'Borrar contenido',
            nueva: 'Nueva',
            nuevo: 'Nuevo',
            cerrar: 'Cerrar',
            campoVacio: 'Campo Vacío',
            campoRelleno: 'Campo Relleno',
            descargar: 'Descargar',
            fechaVacia: 'Fecha Vacía',
            fechaRellena: 'Fecha Rellena',
            mesActual: 'Mes Actual',
            semanaActual: 'Semana Actual',
            anyoActual: 'Año Actual',
            diaActual: 'Día Actual',
            anterior: 'Anterior',
            siguiente: 'Siguiente',
            yes: 'Sí',
            no: 'No',
            desde: 'Desde',
            hasta: 'Hasta',
            buscar: 'Buscar',
            anadir: 'Añadir',
            cargar: 'Cargar',
            ver: 'Ver',
            editar: 'Editar',
            duplicar: 'Duplicar',
            guardar: 'Guardar',
            aceptar: 'Aceptar',
            guardarComo: 'Guardar Como',
            eliminar: 'Eliminar',
            expandir: 'Expandir',
            borrar: 'Borrar',
            cancelar: 'Cancelar',
            compartir: 'Compartir',
            filtro: 'Filtro',
            guardado_ok: 'Guardado correctamente',
            // #59 · Lo que se dice cuando un diálogo de acción se acepta con otra cuenta dentro
            // (ver `src/js/utils/accionDeLaSesion.js`). Va en `common` porque la regla no es de
            // vacaciones: vale para cualquier diálogo que mande una acción al servidor.
            sesionCambiada: 'Se ha cambiado de cuenta desde que se abrió esta ventana, así que la acción NO se ha enviado. Vuelve a abrirla con la sesión de ahora.',
            // #69 · Lo mismo cuando lo que ha cambiado es la pantalla o la ventana: se ha salido de
            // ella, o se ha cerrado y abierto sobre otra solicitud, con el diálogo todavía abierto.
            ventanaCambiada: 'La ventana desde la que se abrió esta confirmación se ha cerrado o ahora muestra otra solicitud, así que la acción NO se ha enviado. Vuelve a abrirla desde la solicitud que quieras resolver.',
            // #59 · Y lo que se dice cuando ya se está resolviendo eso mismo: el diálogo no se abre
            // —o no manda nada al aceptarlo— y hay que decir por qué, o parece que no ha pasado
            // nada. También en `common`: el cerrojo no es de vacaciones (ver `unaAccionALaVez.js`).
            accionEnVuelo: 'Eso se está resolviendo ahora mismo y todavía no ha contestado el servidor, así que NO se ha enviado nada. Espera a que termine.',
            nombre: 'Nombre',
            todas: 'Todas',
            todos: 'Todos',
            limpiar: 'Limpiar',
            operacion_ok: 'Operación realizada correctamente',
            bloqueado: 'Bloqueado',
            desbloqueado: 'Desbloqueado',
            move: 'Mover',
            copy: 'Copiar',
            paste: 'Pegar',
            any: 'Cualquiera',
            actualizarTabla: 'Actualizar datos de tabla',
            exportarExcel: 'Exportar a Excel',
            consultasFavoritas: 'Consultas Favoritas',
            firstSearch: 'Realice una búsqueda para obtener resultados',
            firstSearchTipoEstatico: 'Elija una consulta para obtener resultados',
            noResults: 'La búsqueda no ha dado resultados',
            configurarColumnas: 'Configurar columnas',
            consultaGuardada: 'Consulta Guardada correctamente',
            consultaBorrada: 'Consulta Borrada correctamente',
            consultaCompartida: 'Consulta Compartida correctamente',
            empleados: 'Empleados',
            personas: 'Personas',
            persona: 'Persona',
            empresa: 'Empresa',
            filtrar: 'Filtrar',
            cleanFilter: 'Limpiar Filtro',
            configurarFiltros: 'Configurar Filtros',
            guardarConsulta: 'Guardar Consulta',
            sharedConsulta: 'Compartir Consulta',
            sobreescribir: 'Sobreescribir',
            cambiosmasivos: 'Cambios Masivos',
            actualizarMasivamente: 'Actualizar masivamente',
            desmarcarSeleccionados: 'Desmarcar Seleccionados',
            enviar: 'Enviar',
            enviar_email: 'Enviar Email',
            remitente: 'Remitente',
            destinatarios: 'Destinatarios',
            en_copia: 'En copia',
            en_copia_oculta: 'En copia oculta',
            opciones_disponibles: 'Opciones disponibles',
            datos_usuario: 'Datos del usuario',
            datos_empleado_asignado: 'Datos del Empleado asignado',
            entrada_manual: 'Entrada manual',
            plantilla_email: 'Plantilla Email',
            sin_plantilla: 'Sin plantilla',
            asunto: 'Asunto',
            cuerpo_email: 'Cuerpo del email',
            adjuntar_archivos: 'Adjuntar archivos',
            documentacion_a_adjuntar: 'Documentación a adjuntar',
            enviar_como_enlaces: 'Enviar como enlaces',
            emails_enviados: 'Emails enviados',
            error_enviando_emails: 'Error enviando emails',
            agrupar_por_pedido: 'Agrupar por pedido',
            eliminar_valor_lista: '¿Desea eliminar el valor de la lista?',
            anadir_valor: 'Añadir valor...',
            ingrese_valor: 'Ingrese un valor:',
            ingrese_numero: 'Ingrese un número:',
            ingrese_email: 'Ingrese un email:',
            valor_requerido: 'Valor requerido',
            valor_numerico_requerido: 'Se requiere un valor numérico',
            email_invalido: 'Email inválido',
            valor_duplicado: 'Este valor ya existe',
            maximo_items_alcanzado: 'Máximo de {max} elementos alcanzado',
            marcarTodos: 'Marcar todos los visibles',
            configurarAgregaciones: 'Configurar Agregaciones',
            ver: 'Ver',
            sin: 'Sin',
            borrarFiltro: "Borrar Filtro",
            today: "Hoy",
            cambiarFiltros: "Cambiar Filtros",
            consultasComandos: "Elija una consulta",
            seleccionar: "Seleccionar",
            tipo: "Tipo",
            abono: "Abono",
        },
        main_menu: {
            inventarios: 'Inventario',
            tareas: 'Tareas',
            tipostarea: 'Tipos de Tarea',
            planificacioninspectores: 'Planif. Inspectores',
            restriccionesplanificacion: 'Restricciones planificación',
            mapaaprobacion: 'Mapa de aprobación',
            reglascoincidencia: 'Reglas de coincidencia',
            normasvacaciones: 'Normas de vacaciones',
            novedades: 'Novedades',
            puestostrabajo: 'Puestos de trabajo',
            funciones: 'Funciones',
            vacaciones: 'Vacaciones',
            gastos: 'Gastos',
            incidenciasplanificacion: 'Incidencias planificación',
            festivosboletin: 'Festivos · Boletines',
            ajustes: 'Ajustes',
            inicio: 'Inicio',
            clientes: 'Clientes',
            proveedores: 'Proveedores',
            items: 'Items',
            itemsgrupo: 'Items',
            itemsenriquecidos: 'Items enriquecidos',
            itemcaracteristicas: 'Características de items',
            itemclasificacion: 'Clasificación de items',
            itemtipoclasificacion: 'Tipos de clasificación',
            equipos: 'Equipos',
            materias: 'Materias',
            properties: 'Properties',
            componentesproteccion: 'Componentes Protección',
            provincias: 'Provincias',
            municipios: 'Municipios',
            comunidades: 'Comunidades Autónomas',
            paises: 'Paises',
            ofertas: 'Ofertas',
            pedidos: 'Pedidos',
            calendario: 'Calendario',
            listadocalendarioDIA: 'Resumen Día',
            listadocalendarioSEMANA: 'Resumen Semana',
            listadocalendarioMES: 'Resumen Mes',
            planificaciones: 'Planificaciones',
            lineaspedidos: 'Líneas de Pedidos',
            inspecciones: 'Expedientes',
            formatos: 'Formatos',
            albaranes: 'Albaranes',
            facturas: 'Facturas',
            marcas: 'Marcas',
            modelos: 'Modelos',
            coches: 'Coches',
            conflictos: 'Incidencias',
            usuarios: 'Usuarios',
            configuracion: 'Configuración',
            gruposcliente: 'Grupos de Clientes',
            gruposproveedor: 'Grupos de Proveedores',
            empresas: 'Empresas',
            tiposequipo: 'Tipos de Equipo',
            tipositem: 'Tipos de Item',
            lineasnegocio: 'Líneas de Negocio',
            tipodocumento: 'Tipos de Documentos',
            delegaciones: 'Delegaciones',
            centrostrabajo: 'Centros de Trabajo',
            evaluadorjs: 'Evaluador JS',
            servicios: 'Servicios',
            combos: 'Opciones personalizadas',
            documentos: 'Documentos',
            facturas: 'Facturas',
            fichaje: 'Fichajes',
            agenteia: 'Agente IA',
            departamentos: 'Departamentos',
            empleados: 'Empleados',
            empresasmantenedoras: 'Empresas Mantenedoras',
            condicionespago: 'Condiciones de Pago',
            viaspago: 'Formas de Pago',
            listasprecios: 'Listas de Precios',
            cerrar_sesion: 'Cerrar sesión',
            notificaciones: 'Notificaciones',
            informes: 'Informes',
            email_data: 'Emails',
            documentacion: 'Documentación',
            cuentasbancarias: 'Cuentas Bancarias',
            plazodias: 'Plazos Días',
            ayudas: 'Ayudas de pantallas',
            festivos: 'Festivos',
            tareasprogramadas: 'Tareas Programadas',
            dashboard: 'Panel de control',
            // #326 · título de la entrada de menú que da de alta el lote
            // `fase-menu-control-planificacion-2026-10`. Sin esta clave el menú lateral y su
            // buscador pintarían «main_menu.controlplanificacion», que es lo que se ve cuando se
            // añade la entrada en Mongo y se olvida el literal.
            // #1133 · Dirección la renombra «ACEL PLANIFICACIÓN», en mayúsculas. Es el único sitio
            // del nombre: de aquí lo toman también el título de la pantalla, la tarjeta de OEB
            // Producción y el botón del calendario, para que no digan cosas distintas.
            controlplanificacion: 'ACEL PLANIFICACIÓN',
            // #815 · título de la entrada de menú que da de alta el lote `fase-ia-gasto-2026-10` de
            // movilidad (solo ADMIN). Sin esta clave, el menú lateral pintaría la clave en crudo.
            gastoia: 'Gasto de IA',
            // #905 · títulos de las dos entradas de menú que da de alta el lote
            // `fase-acel-condiciones-facturacion-2026-10` de movilidad (02-905 y 03-905).
            autorizacionescondiciones: 'Autorizaciones de condiciones de facturación',
            oeeautorizaciones: 'OEE · Autorizaciones',
            // #1044 · título de la entrada de menú que da de alta el lote `fase-m365-empleados-2026-10`
            // de movilidad (ADMIN y DIRECTOR). Sin esta clave, el menú lateral pintaría la clave en crudo.
            microsoft365: 'Microsoft 365',
        },
        tarifas: {
            tarifas: 'Tarifas',
            nuevo: 'Nueva tarifa',
            editar: 'Editar tarifa',
            ver: 'Ver tarifa',
            familia: 'Familia',
            estado: 'Estado',
            activar: 'Activar',
            anular: 'Anular',
            codigo: 'Código',
            nombre: 'Nombre',
            descripcion: 'Descripción',
            formulaTPC: 'Fórmula TPC',
            formulaTPO: 'Fórmula TPO',
            formulaPrecio: 'Fórmula Precio',
            porcSegunda: '% Segunda',
            factorTiempoCampo2: 'Factor Tiempo Campo 2',
            factorTiempoOficina2: 'Factor Tiempo Oficina 2',
            calculador: 'Calculador',
            seleccionarTarifa: 'Seleccionar tarifa',
            camposEntrada: 'Campos de entrada',
            gastos: 'Gastos',
            kilometros: 'Kilómetros',
            peajes: 'Peajes',
            parking: 'Parking',
            desayunos: 'Desayunos',
            comidas: 'Comidas',
            cenas: 'Cenas',
            hotel: 'Hotel',
            finDeSemana: 'Fin de semana',
            horasNocturnas: 'Horas nocturnas',
            calcular: 'Calcular',
            guardarLinea: 'Guardar en línea',
            sinResultado: 'Realice un cálculo para ver resultados',
            resultado: 'Resultado',
            primeraInspeccion: 'Primera Inspección',
            segundaInspeccion: 'Segunda Inspección',
            precio1a: 'Precio 1ª',
            tiempoCampo1a: 'Tiempo Campo 1ª',
            tiempoOficina1a: 'Tiempo Oficina 1ª',
            precio2a: 'Precio 2ª',
            tiempoCampo2a: 'Tiempo Campo 2ª',
            tiempoOficina2a: 'Tiempo Oficina 2ª',
            gastos1a: 'Gastos 1ª Inspección',
            gastos2a: 'Gastos 2ª Inspección',
            importeKm: 'Importe Km',
            totalGastos: 'Total Gastos',
            resumenCalculo: 'Resumen del cálculo',
            tiempoCampo: 'Tiempo Campo (min)',
            tiempoOficina: 'Tiempo Oficina (min)',
            precio: 'Precio',
            calcularAntesGuardar: 'Debe calcular antes de guardar',
            guardadoOK: 'Guardado correctamente',
            addCampo: 'Añadir campo',
            sinCampos: 'No hay campos definidos',
            campoClave: 'Clave',
            campoEtiqueta: 'Etiqueta',
            campoTipo: 'Tipo',
            campoOrden: 'Orden',
            campoValorDefecto: 'Valor por defecto',
            campoOpciones: 'Opciones',
            opcionesPlaceholder: 'op1, op2, op3',
            subtipos: 'Subtipos',
            addSubtipo: 'Añadir subtipo',
            sinSubtipos: 'No hay subtipos definidos',
            subtipoCodigo: 'Código',
            subtipoNombre: 'Nombre',
            tarifasConfig: 'Tarifas Configuracion',
            configGlobal: 'Configuracion Global',
            editorHerramientas: 'Editor Herramientas',
            historialVersiones: 'Historial Versiones',
            cambiarTarifa: 'Cambiar',
            tipoInstalacion: 'Tipo de Instalación',
            trabajo: 'Trabajo',
            copiarGastos: 'Copiar de 1a',
            calculadoOK: 'Cálculo realizado',
            sinContenido: 'Sin contenido disponible',
            tutorPlaceholder: 'Escribe tu pregunta...'
        },
        agenteia: {
            relationships: 'Relaciones',
            queryRules: 'Reglas de consulta',
            examples: 'Ejemplos',
            promptRules: 'Reglas de prompt',
            documents: 'Documentos IA',
            documentId: 'Document ID',
            versionId: 'Version ID',
            tipo: 'Tipo',
            estado: 'Estado',
            title: 'T\u00edtulo',
            origen: 'Origen',
            vigenteDesde: 'Vigente desde',
            vigenteHasta: 'Vigente hasta',
            descripcion: 'Descripci\u00f3n',
            comentarioAgente: 'Comentario para agente',
            tags: 'Tags',
            servicios: 'Servicios',
            formatos: 'Formatos',
            comunidades: 'Comunidades',
            path: 'Ruta',
            filename: 'Fichero',
            pageCount: 'P\u00e1ginas',
            chunkCount: 'Chunks',
            selectedFile: 'Fichero seleccionado',
            noFileSelected: 'Ninguno',
            folder: 'Carpeta',
            selectFile: 'Seleccionar fichero',
            open: 'Abrir',
            download: 'Descargar'
        },
        notificaciones: {
            notificaciones: 'Notificaciones',
            nuevo: 'Nueva notificación',
            usuario: 'Usuario',
            titulo: 'Título',
            mensaje: 'Mensaje',
            urlInterna: 'URL Interna',
            urlExterna: 'URL Externa',
            enviarATodos: 'Enviar a todos'

        },
        tipostarea: {
            nuevo: 'Nuevo Tipo de Tarea',
            nombre: 'Nombre',
            guardado_ok: 'Tipo de Tarea guardada correctamente',
            tipostarea: 'Tipo de Tarea',
            editar: 'Editar',
            codigo: 'Código'

        },
        tarea: {
            nuevo: 'Nueva Tarea',
            guardado_ok: 'Tarea guardada correctamente',
            editar: 'Editar',
            tarea: 'Tarea',
            codigo: 'Código',
            codigoExpediente: 'Código Expediente',
            codigoFactura: 'Códigos de Factura',
            descripcion: 'Descripción',
            empleado: 'Empleado',
            empleados: 'Empleados',
            comentarios: 'Comentarios',
            comentariosPlanificacion: 'Comentarios Planificación',
            tipoTarea: 'Tipo de Tarea',
            fecha: 'Fecha',
            hora_inicio: 'Hora Inicio',
            hora_final: 'Hora Final',
            estado: 'Estado',
            tiempoEstimado: 'Tiempo Estimado (Minutos)',
            importe: 'Importe',
            numeroPedido: 'Nº Pedido',
            numeroLineaPedido: 'Nº Línea Pedido',
            numeroFactura: 'Nº Factura',
            numeroLineaFactura: 'Nº Línea Factura',
            numeroOferta: 'Nº Oferta',
            codigoCliente: 'Cod. Cliente',
            codigoOportunidad: 'Cod. Oportunidad',
            codigoCampania: 'Cod. Campaña',
            ver_emails: 'Ver emails',
            mostrar_tareas: 'Mostrar tareas',
            sesiones: 'Sesiones',
            sesiones_add: 'Añadir sesión'
        },
        crontask: {
            tareasprogramadas: 'Tareas Programadas',
            ejecutar: 'Ejecutar',
            lanzar: 'Ejecución manual',
            lanzarAhora: 'Lanzar ahora',
            lanzarAviso: 'Se ejecuta en este momento, con los parámetros guardados que hay arriba.',
            lanzarGuardaPrimero: 'Se ejecutaría con los parámetros guardados, no con lo que estás escribiendo. Guarda los cambios con el botón «Guardar» de arriba y el botón se activa.',
            lanzarEnCurso: 'Ejecutándose… puede tardar, no cierres la pantalla.',
            confirmarEjecucion: '¿Desea ejecutar la tarea programada?',
            ejecucionLanzada: 'Ejecución lanzada correctamente',
            ejecucionOk: 'La ejecución ha terminado correctamente (OK)',
            ejecucionKo: 'La ejecución ha terminado con error (KO). Lo que falló está en los registros del servicio.',
            datos: 'Parámetros de la tarea',
            datosAyuda: 'Los lee la propia tarea; cada una tiene los suyos y la mayoría no necesita ninguno. El cierre nocturno de vacaciones admite «fechaSimulada» (aaaa-mm-dd) para que haga como si hoy fuera ese día; se deja de simular dejando el valor en blanco.',
            datosClave: 'Nombre del parámetro',
            datosValor: 'Valor',
            datosVacio: 'Sin parámetros: la tarea se ejecuta con su comportamiento por defecto.',
            datosAnadir: 'Añadir parámetro',
            datosClaveRepetida: 'Este nombre está repetido. Cada parámetro se llama de una forma: cambia el nombre o borra la fila que sobra, o al guardar se perdería uno de los dos valores.',
            datosNoSeGuarda: 'No se ha guardado. Hay nombres de parámetro repetidos y cada parámetro se llama de una forma: cambia el nombre o borra la fila que sobra. Repetidos: ',
            ayudaCron: 'Plantillas CRON rápidas',
            nuevo: 'Nueva Tarea Programada',
            editar: 'Editar Tarea Programada',
            tareaprogramada: 'Tarea Programada',
            guardado_ok: 'Tarea programada guardada correctamente',
            descripcion: 'Descripción',
            beanName: 'Bean',
            cronExpression: 'Expresión CRON',
            orden: 'Orden',
            ejecutarSola: 'Ejecutar sola',
            estado: 'Estado',
            limiteIntentos: 'Límite de intentos',
            resultadoUltimaEjecucion: 'Resultado última ejecución',
            observacionesEjecucion: 'Observaciones de ejecución',
            fechaUltimaEjecucion: 'Fecha última ejecución',
            fechaCalculadaProximaEjecucion: 'Próxima ejecución calculada',
            ejecucionAyuda: 'Estos campos no se escriben a mano: los rellena cada ejecución, tanto la programada como la del botón «Lanzar ahora» de abajo, y en las observaciones queda quién la lanzó y qué hizo. El «Estado» dice si la tarea está esperando su turno (PENDIENTE), no si se ha ejecutado: eso lo dicen el resultado y la fecha de la última ejecución.',
            proximaAyuda: '«Próxima ejecución calculada» la escribe el servidor con la expresión CRON de arriba: el planificador cuando la tarea entra en turno, y «Lanzar ahora» al terminar. Si está en blanco es que no hay ninguna fecha que calcular: o la tarea no ha entrado en turno todavía, o la expresión CRON no se entiende o ya no vuelve a cumplirse —y entonces lo dicen las observaciones de arriba—. No es algo que se desbloquee desde esta pantalla: para cambiar a qué hora corre se edita la expresión CRON.'
        },
        campania: {
            nuevo: 'Nueva Campaña',
            add: 'Añadir',
            guardado_ok: 'Campaña guardada correctamente',
            editar: 'Editar',
            campania: 'Campaña',
            codigo: 'Código',
            nombre: 'Nombre',
            estrategia: 'Estrategia',
            fechaInicial: 'Fecha Inicial',
            fechaFinal: 'Fecha Final',
            responsable: 'Responsable',
            clientes: 'Clientes',
            ofertas: 'Ofertas',
            pedidos: 'Pedidos',
            lineasPedidos: 'Lineas de pedido',
            procesos: 'Procesos de venta',
            objetivosComercial: 'Objetivos por comercial',
            documentos: 'Documentos',
            cargarClientes: 'Cargar clientes',
            cargarOfertas: 'Cargar ofertas',
            cargarPedidos: 'Cargar pedidos',
            cargarLineasPedidos: 'Cargar líneas de pedidos',
            cerrar: 'Cerrar',
            orden: 'Orden',
            tipoTarea: 'Tipo de tarea',
            numeroTareas: 'Número de tareas',
            ponderacion: 'Ponderación',
            comercial: 'Comercial',
            numOportunidades: 'Nº Oportunidades',
            vntc: 'VNTC',
            vntoc: 'VNTOC',
            vntcc: 'VNTCC',
            vntocr: 'VNTOCR',
            vntccr: 'VNTCCR',
            tareasRealizadas: 'Tareas Realizadas',
            oportunidades: 'Oportunidades',
            updateData: 'Actualizar datos',
        },
        oportunidad: {
            nuevo: 'Nueva Oportunidad',
            guardado_ok: 'Oportunidad guardada correctamente',
            editar: 'Editar',
            oportunidad: 'Oportunidad',
            codigo: 'Código',
            gestor: 'Gestor',
            estado: 'Estado',
            cliente: 'Cliente',
            oferta: 'Oferta',
            pedido: 'Pedido',
            lineaPedido: 'Línea de pedido',
            documentos: 'Documentos',
            documentosOrigen: 'Documentos origen',
            cargarCliente: 'Cargar cliente',
            cargarOferta: 'Cargar oferta',
            numOferta: 'Nº oferta',
            cargarPedido: 'Cargar pedido',
            numPedido: 'Nº pedido',
            cargarLineaPedido: 'Cargar línea de pedido',
            numLinea: 'Nº línea',
            doo: 'Detección de oportunidades (D.O.O.)',
        },
        textos: {
            forzarPaginaNueva: 'Forzar texto en nueva página',
            alInicio: 'Mostrar al inicio',
        },
        inventario: {
            nuevo: 'Nuevo Inventario',
            guardado_ok: 'Inventario guardado correctamente',
            editar: 'Editar',
            inventario: 'Inventario',
            codigo: 'Código',
            lineanegocio: 'Línea Negocio',
            nombre: 'Nombre',
            marca: 'Marca',
            modelo: 'Modelo',
            descripcion: 'Descripción',
            empleados: 'Empleados',
            fechaalta: 'Fecha de alta',
            fechabaja: 'Fecha de baja'
        },
        componentes: {
            direccion: {
                codigo_postal: 'Código Postal',
                direccion: 'Dirección',
                poblacion: 'Población',
                provincia: 'Provincia',
                comunidad: 'Comunidad Autónoma',
                pais: 'País',
            },
            cuenta: {
                pais: 'País',
                nombreBanco: 'Nombre Banco',
                bic: 'BIC / SWIFT',
                nombreCuenta: 'Nombre Cuenta',
                codigoBanco: 'Código Banco',
                sucursal: 'Sucursal',
                claveControl: 'Clave Control',
                cuenta: 'Cuenta',
                iban: 'IBAN',
                idMandato: 'Id Mandato',
                fechaFirma: 'Fecha Firma',
            },
            comprobacion: {
                instrucciones: 'Escribe aquí las instrucciones...',
                peso: "Peso",
            },
            caracteristicas: {
                opciones: 'Opciones',
                vincularValorInspeccion: 'Vincular valor de inspección',
                valorVinculado: 'Valor vinculado',
                importarOpciones: 'Importar opciones',
                importar: 'Importar',
                grupoOpciones: 'Grupo de opciones'
            }
        },
        perfil: {
            perfil: 'Perfil',
            cambiar_pass: 'Cambiar Contraseña',
            new_pass: 'Nueva Contraseña',
            repeat_new_pass: 'Repita Nueva Contraseña',
            actual_pass: 'Contraseña Actual',
            cliente_contacto: 'Contacto',
            nombre: 'Nombre',
            firma: 'Añadir firma',
        },
        usuarios: {
            login: {
                usuario: 'Usuario',
                contrasena: 'Contraseña',
                entrar: 'Entrar',
                olvide_mi_contrasena: 'Olvidé mi contraseña'
            },
            usuarios: {
                usuarios: 'Usuarios'
            },
            usuario_form: {
                username: 'Username',
                nombre: 'Nombre',
                apellidos: 'Apellidos',
                telefono: 'Teléfono',
                email: 'Email',
                iniciales: 'Iniciales',
                roles: 'Roles',
                usuario: 'Usuario',
                editar_usuario: 'Editar usuario',
                nuevo_usuario: 'Nuevo usuario',
                usuario_guardado: 'Usuario guardado',
                rol: 'Rol',
                clientes_asociados: 'Clientes asociados',
                cliente: 'Cliente',
                add: 'Añadir',
                inspector_data: 'Datos de inspector',
                foto: 'Seleccionar Foto',
                firma: 'Firma',
                select_firma: 'Seleccionar Firma'
            }
        },
        facturas: {
            facturas: 'Facturas',
            codigo: 'Cód Factura',
            numero: 'Nº Factura',
            numeroFactura: 'Número Factura',
            documentoFactura: 'Documento Factura',
            numeroPedido: 'Nº Pedido',
            numeroLineaPedido: 'Número de Línea de Pedido',
            idPedido: 'ID del Pedido',
            fechaEnvio: 'Fecha Envío',
            totalPendienteConIVA: 'Total Pendiente con IVA',
            estado: 'Estado',
            responsable: 'Responsable',
            responsableGestionCobro: 'Responsable Gestión Cobro',
            estadoGestionCobro: 'Estado Gestión Cobro',
            historicoEstadosGestionCobro: 'Histórico de Estados de Gestión de Cobros',
            historicoResponsablesGestionCobro: 'Histórico de Responsables de Gestión de Cobros',
            // Las columnas de los dos cuadros de histórico de gestión de cobro (#188). Son un
            // registro de auditoría y tienen que decir QUÉ contienen: «Username» no decía si era
            // el responsable asignado o quien hizo la asignación, y son dos personas distintas.
            historicoResponsableAsignado: 'Responsable asignado',
            historicoAsignadoPor: 'Asignado por',
            historicoCambiadoPor: 'Cambiado por',
            historicoFechaHora: 'Fecha y hora',
            descripcionEstadoOtros: 'Descripción (Estado: Otros)',
            estadoGestionCobroValores: {
                SIN_GESTIONAR: 'Sin gestionar',
                EN_GESTION_DE_RECLAMACION: 'En gestión de reclamación',
                COMPROMISO_DE_PAGO: 'Compromiso de pago',
                COBRADO_PARCIAL: 'Cobrado parcial',
                COBRADO_TOTAL: 'Cobrado total',
                EN_CONCURSO_DE_ACREEDORES_EN_ABOGADOS: 'En concurso de acreedores, en abogados',
                EN_MONITORIO: 'En monitorio',
                PENDIENTE_RESPONSABLE_PEDIDO: 'Pendiente responsable pedido',
                EMPRESA_EXTINTA: 'Empresa extinta',
                BUROFAX_ENVIADO: 'Burofax enviado',
                OTROS: 'Otros'
            },
            tipoValores: {
                FACTURA: 'Factura',
                ABONO: 'Abono'
            },
            estadoValores: {
                ABIERTA: 'Abierta',
                CERRADA: 'Cerrada',
                CANCELADA: 'Cancelada'
            },
            cod_cliente: 'Cod. Cliente',
            cliente: 'Cliente',
            forma_pago: 'Forma de pago',
            fecha_emision: 'Fecha Emisión',
            fecha_envio_factura: 'Fecha Envío',
            fecha_prevista_cobro: 'Fecha Prevista Cobro',
            historicoEnviosEmail: 'Histórico de Envios por Email',
            fecha_vencimiento: 'Fecha Vencimiento',
            fecha_cobro: 'Fecha Cobro',
            fecha_ultimo_cobro: 'F. Últ. Cobro',
            ultimoCobro: 'Último cobro',
            subtotal: 'Subtotal',
            totalIva: 'Total IVA',
            totalFactura: 'Total Factura',
            lineas: 'Líneas',
            desde: 'Desde',
            hasta: 'Hasta',
            no_documento: 'Seleccionar documento factura',
            generar: 'Generar Factura',
            a_quien_facturar: 'A Quién realizar las facturas',
            facturar_hasta_dia: 'Facturar hasta el día:',
            que_facturar: 'Qué Facturar',
            comoFacturar: 'Facturar a nombre de:',
            envio_email_automatico: 'Enviar email con la factura automáticamente a los clientes',
            factura_guardada: 'Factura Guardada',
            concepto: 'Concepto',
            codigo_inspeccion: 'Expediente',
            codigo_pedido: 'Pedido',
            matricula: 'Matrícula',
            bastidor: 'Bastidor',
            total: 'Total',
            tipoIva: 'Tipo IVA',
            precio_unitario: 'Precio Unitario',
            cantidad: 'Cantidad',
            factura: 'Factura',
            abono: 'Abono',
            editar_factura: 'Editar Factura',
            motivo_cancel: 'Motivo Cancelación',
            facturas_generadas: 'Facturas Generadas',
            abierta: 'Abierta',
            cerrada: 'Cerrada',
            cancelada: 'Cancelada',
            fechaEmision: 'F. Emisión',
            fechaVencimiento: 'F. Vencimiento',
            fechaFactura: 'F. Factura',
            editar: 'Editar',
            eliminar: 'Eliminar',
            cancelar: 'Cancelar',
            importeaplicado: 'Importe aplicado',
            saldovencido: 'Saldo vencido',
            importeAplicado: 'Importe Aplicado',
            saldoVencido: 'Saldo Vencido',
            importeRetencion: 'Importe Retención',
            suplidos: 'Suplidos',
            pregunta_cancelar: "¿Está seguro de que desea cancelar esta factura?",
            guardado_ok: 'Factura guardada correctamente',
            no_documentos_encontrados: 'No se encontraron documentos',
            ruta_no_configurada: 'Ruta de documentos no configurada',
            seleccionar_documento: 'Seleccionar documento',
            crear_tarea: 'Crear tarea',
            crear_oportunidad: 'Crear oportunidad',
            creando_tarea: 'Creando tarea para la factura',
            creando_oportunidad: 'Creando oportunidad para la factura',
            enviar_email: 'Enviar email',
            mostrar_tareas: 'Mostrar tareas',
            mostrar_oportunidades: 'Mostrar oportunidades',
            mostrar_emails: 'Mostrar emails',
            enviando_email: 'Enviando email para la factura',
            mostrando_tareas: 'Mostrando tareas de la factura',
            mostrando_oportunidades: 'Mostrando oportunidades de la factura',
            mostrando_emails: 'Mostrando emails de la factura',
            crear_documento_factura: 'Crear documento factura',
            actualizar_documento_factura: 'Actualizar documento factura',
            facturas: 'Facturas',
            crear_pdf: 'Crear PDF',
            asignar_pdf: 'Asignar PDF',
            pdfs_generados_correctamente: 'Factura actualizada correctamente',
            opciones_pdf: 'Opciones de PDF',
            pdf_asignado_correctamente: 'PDF asignado correctamente',
            no_documento: 'Seleccionar documento factura',
            no_documentos_encontrados: 'No se encontraron documentos',
            ruta_no_configurada: 'Ruta de documentos no configurada',
            seleccionar_documento: 'Seleccionar documento',
            crear_tarea: 'Crear tarea',
            crear_oportunidad: 'Crear oportunidad',
            creando_tarea: 'Creando tarea para la factura',
            creando_oportunidad: 'Creando oportunidad para la factura',
            enviar_email: 'Enviar email',
            mostrar_tareas: 'Mostrar tareas',
            mostrar_oportunidades: 'Mostrar oportunidades',
            mostrar_emails: 'Mostrar emails',
            enviando_email: 'Enviando email para la factura',
            mostrando_tareas: 'Mostrando tareas de la factura',
            mostrando_oportunidades: 'Mostrando oportunidades de la factura',
            mostrando_emails: 'Mostrando emails de la factura',
            descargasFactura: 'Descargas Factura'
        },
        finanzas: {
            viaPago: 'Vía de pago',
            cuenta: 'Cuenta',
            plazoDias: 'Plazo de días',
            condicionPago: 'Condición de pago',
            adelantoCobro: 'Adelanto de cobro',
        },
        itemcaracteristicas: {
            importar: 'Importar Excel',
            exportar: 'Exportar Excel',
            import_resultado_titulo: 'Resultado de la importación',
            creadas: 'Creadas',
            actualizadas: 'Actualizadas',
            errores: 'Errores',
            import_mode_pregunta: '¿Cómo quieres importar? UPSERT actualiza o crea; REPLACE_ALL borra todo lo existente antes de importar.',
            import_replace_confirm: 'REPLACE_ALL eliminará TODAS las fichas existentes antes de importar. ¿Continuar?'
        },
        items: {
            items: 'Items',
            equipos: 'Equipos',
            item: 'Item',
            equipo: 'Equipo',
            editar: 'Editar',
            nuevo: 'Nuevo',
            codigo: 'Código',
            nombre: 'Nombre',
            cliente: 'Cliente',
            instalacion: 'Instalación',
            formato: 'Formato',
            desde: 'Desde',
            hasta: 'Hasta',
            fecha_ultima_revision: 'Fecha Últ. Rev.',
            fecha_proxima_revision: 'Fecha Próx. Rev.',
            fechaProximaVerificacion: 'Fecha Prox. Verif.',
            fechaProximaCalibracion: 'Fecha Prox. Calib.',
            fechaBaja: 'Fecha Baja',
            fechaAlta: 'Fecha Alta',
            delegacion: 'Delegación',
            empleadosAsignados: 'Empleados Asignados',
            tipo: 'Tipo',
            materia: 'Materia',
            materiaAplica: 'Materia a la que aplica',
            formatosAplica: 'Formatos a los que aplica',
            item_guardado: 'Item guardado correctamente',
            equipo_guardado: 'Equipo guardado correctamente',
            icAdministrador: 'IC Administrador',
            icInstalador: 'IC Instalador',
            icMantenedor: 'IC Mantenedor',
            icAsociacion: 'IC Asociación',
            administrador: 'Administrador',
            instalador: 'Instalador',
            mantenedor: 'Mantenedor',
            asociacion: 'Asociación',
            unidad_movil: 'Unidad Móvil',
            mostrarSiCaducado: 'Mostrar al inspector aunque este caducado',
            diasAvisoEmail: 'Días para Avisar por email',
            tipoEquipo: 'Tipo Equipo',
        },
        equipos: {
            nuevo: 'Nuevo'

        },
        gastos: {
            gastos: 'Gastos',
            gasto: 'Gasto',
            nuevo: 'Nuevo gasto',
            editar: 'Editar gasto',
            justificante: 'Justificante (ticket o factura)',
            adjuntar_foto: 'Adjuntar foto del ticket o la factura',
            leer_ticket: 'Leer con IA',
            leyendo: 'Leyendo el ticket...',
            leido_ok: 'Datos leídos del ticket. Revísalos antes de guardar.',
            varios_tickets_en_edicion: 'La foto tiene {total} tickets. Como este gasto ya existe, se queda con el primero ({establecimiento}). Para registrar los demás, crea un gasto nuevo con la misma foto.',
            error_lectura_generico: 'No se ha podido leer el justificante. Rellena los datos a mano.',
            error_leer_fichero: 'No se ha podido leer el fichero elegido.',
            hacer_foto: 'Hacer foto',
            elegir_archivo: 'Elegir archivo o imagen',
            lote_titulo: '{total} tickets en la foto',
            lote_intro: 'La IA ha encontrado {total} tickets en la foto. Revisa cada línea y pulsa «Guardar todos»: se crea un gasto por ticket, cada uno con su recorte.',
            lote_ver_foto: 'Ver la foto original',
            lote_guardar_todos: 'Guardar todos',
            lote_guardando: 'Guardando {hechos} de {total}…',
            lote_guardado: 'Guardado',
            lote_quitar: 'Quitar',
            lote_quitar_confirmar: '¿Quitar este ticket del lote? No se creará su gasto.',
            lote_vacio: 'No queda ningún ticket en el lote.',
            lote_todos_guardados: 'Guardados {total} gastos.',
            lote_con_errores: '{fallidas} tickets no se han podido guardar. Corrige lo que marcan en rojo y vuelve a pulsar «Guardar todos».',
            lote_error_generico: 'No se ha podido guardar este gasto.',
            lote_recorte: 'Recorte del ticket',
            mes_anterior: 'Mes anterior',
            mes_siguiente: 'Mes siguiente',
            este_mes: 'Volver al mes actual',
            un_gasto: '1 gasto',
            n_gastos: '{n} gastos',
            total_mes: 'Total del mes',
            sin_gastos_mes: 'No hay gastos en {mes}.',
            error_cargar: 'No se han podido cargar los gastos.',
            reintentar: 'Reintentar',
            modo_fichas: 'Ver como fichas',
            modo_tabla: 'Ver como tabla',
            lote_empleado_todos: 'Empleado para todas las líneas',
            lote_empleado_nota: 'Se aplica a todas las líneas sin guardar. Dentro de cada línea se puede cambiar para una sola.',
            lote_foto_original: 'Foto original',
            confianza: 'confianza',
            historico: 'Correcciones',
            corregido: 'Este gasto tiene valores corregidos respecto a lo que leyó la IA.',
            foto_obligatoria: 'La foto del ticket o la factura es obligatoria.',
            total_obligatorio: 'El importe total es obligatorio y tiene que ser mayor que cero.',
            fecha_obligatoria: 'La fecha del gasto es obligatoria.',
            reconocimiento: {
                RECONOCIDO: 'Leído por la IA',
                ERROR: 'Error de reconocimiento',
                SIN_RECONOCER: 'Sin pasar por la IA'
            },
            campos: {
                empleado: 'Empleado',
                tipoDocumento: 'Tipo de justificante',
                categoria: 'Categoría',
                fecha: 'Fecha',
                hora: 'Hora',
                establecimiento: 'Establecimiento',
                datosEstablecimiento: 'Datos del establecimiento (dirección, teléfono, web)',
                cif: 'CIF',
                numeroFactura: 'Nº factura / ticket',
                matricula: 'Matrícula',
                baseImponible: 'Base imponible',
                iva: 'IVA',
                tipoIva: '% IVA',
                importeTotal: 'Total',
                moneda: 'Moneda',
                idExpediente: 'Expediente',
                codigoExpediente: 'Expediente',
                observaciones: 'Observaciones'
            }
        },
        properties: {
            properties: 'Properties',
            property: 'Property',
            nueva_property: 'Nueva Property',
            editar_property: 'Editar Property',
            nombre: 'Nombre',
            valor: 'Valor',
            descripcion: 'Descripción',
            tipoCifrado: 'Cifrado',
            cifrado_none: 'Sin cifrar',
            cifrado_aes: 'Cifrado (AES-256-GCM)',
            aviso_cifrado_nueva: 'El valor se guardará cifrado y no volverá a mostrarse en esta pantalla. Anótalo si lo necesitas en otro sitio.',
            aviso_cifrado_editar: 'El valor está cifrado y no se muestra. Déjalo vacío para conservar el actual, o escribe uno nuevo para reemplazarlo.',
            editable: 'Editable',
            activo: 'Activo'
        },
        materias: {
            materias: 'Materias',
            materia: 'Materia',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            codigoExpediente: 'Código Expediente',
            nombre: 'Nombre',
            percentilAuditoria: 'Porcentaje de auditoría Manual',
            materia_guardada: 'Materia guardada correctamente'
        },
        gruposcliente: {
            gruposcliente: 'Grupos de Cliente',
            grupocliente: 'Grupo de Cliente',
            editar: 'Editar',
            nuevo: 'Nuevo',
            codigo: 'Código',
            nombre: 'Nombre',
            guardado_ok: 'Grupo guardado correctamente'
        },
        gruposproveedor: {
            gruposproveedor: 'Grupos de Proveedores',
            grupoproveedor: 'Grupo de Proveedor',
            editar: 'Editar',
            nuevo: 'Nuevo',
            codigo: 'Código',
            nombre: 'Nombre',
            guardado_ok: 'Grupo guardado correctamente'
        },
        empresas: {
            empresas: 'Empresas',
            empresa: 'Empresa',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            importelimiteautoaprobacion: 'Importe máximo para autoaprobación',
            datos_fiscales: 'Datos Fiscales',
            logo: 'Logo',
            guardado_ok: 'Empresa guardada correctamente'
        },
        tipositem: {
            tipositem: 'Tipos de Item',
            tipoitem: 'Tipo de Item',
            tiposequipo: 'Tipos de Equipo',
            tipoequipo: 'Tipo de Equipo',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            guardado_ok: 'Tipo guardado correctamente',
            plazoCalibrado: 'Plazo Calibrado (Dias)',
            plazoVerificacion: 'Plazo Verificación (Dias)',
            plazoRevision: 'Plazo Revisión (Dias)',
        },
        lineas: {
            subservicio: 'Sub-Servicio'
        },
        lineasnegocio: {
            lineasnegocio: 'Líneas de Negocio',
            lineanegocio: 'Línea de Negocio',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            guardado_ok: 'Línea de Negocio guardada correctamente',
            empresaasociada: 'Empresa Asociada'
        },
        condicionespago: {
            condicionespago: 'Condiciones de Pago',
            condicionpago: 'Condición de Pago',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            guardado_ok: 'Condición de Pago guardada correctamente',
            viaPago: 'Vía de pago',
            cuenta: 'Cuenta',
            plazoDias: 'Plazo (días)',
            activa: 'Activa',
        },
        viaspago: {
            viaspago: 'Vías de Pago',
            viapago: 'Vía de Pago',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            tipo: 'Tipo',
            cuentaNecesaria: 'Cuenta Necesaria',
            cuentaClienteNecesaria: 'Cuenta Cliente Necesaria',
            codigoBC: 'Código BC',
            plazoNecesario: 'Plazo Necesario',
            cobro: 'Cobro',
            pago: 'Pago',
            guardar: 'Guardar',
            eliminar: 'Eliminar',
            guardado_ok: 'Vía de Pago guardada correctamente'
        },
        listasprecios: {
            listasprecios: 'Listas de Precios',
            listaprecios: 'Lista de Precios',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            tipo: 'Tipo',
            guardado_ok: 'Lista de Precios guardada correctamente'
        },
        delegaciones: {
            delegaciones: 'Delegaciones',
            delegacion: 'Delegación',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            descripcion: 'Descripción',
            guardado_ok: 'Delegación guardada correctamente',
            empresaasociada: 'Empresa Asociada',
            responsableequipos: 'Responsable de los equipos',
            preavisoverificacion: 'Preaviso para verificación equipos (días)',
            preavisocalibrado: 'Preaviso para calibrado de equipos (días)'
        },
        centrostrabajo: {
            centrostrabajo: 'Centros de Trabajo',
            centrotrabajo: 'Centro de Trabajo',
            add: 'Añadir',
            editar: 'Editar',
            nuevo: 'Nuevo',
            codigo: 'Código',
            nombre: 'Nombre',
            direccion: 'Dirección',
            guardado_ok: 'Centro de Trabajo guardado correctamente',
            delegacion: 'Delegacion Asociada',
            canalescomunicacion: 'Canales de Comunicación',
            tipo: 'Tipo',
            valor: 'Valor',
            telefono: 'Teléfono',
            telefono_movil: 'Teléfono Móvil',
            fax: 'Fax',
            email: 'Email',
            web: 'Web',
            provincia: 'Provincia'
        },
        evaluadorjs: {
            evaluadoresjs: 'Evaluadores JS',
            evaluadorjs: 'Evaluador JS',
            add: 'Añadir',
            editar: 'Editar',
            nuevo: 'Nuevo',
            nombre: 'Nombre',
            js: 'Código JS',
            ambito: 'Ámbito',
            guardado_ok: 'Evaluador JS guardado correctamente'
        },
        empleados: {
            activo: 'Activo',
            empleados: 'Empleados',
            empleado: 'Empleado',
            fecha_alta: 'Fecha de alta',
            fecha_baja: 'Fecha de baja',
            add: 'Añadir',
            editar: 'Editar Empleado',
            nuevo: 'Nuevo',
            username: 'Username',
            nombre: 'Nombre',
            email: 'Email',
            activo: 'Activo',
            fecha_alta: 'Fecha Alta',
            fecha_baja: 'Fecha Baja',
            dni: 'DNI',
            telefono: 'Teléfono',
            rol: 'Rol',
            oficina: 'Oficina',
            codEmpresa: 'Empresa',
            codLineaNegocio: 'Línea Negocio',
            codDelegacion: 'Delegación',
            codCentroTrabajo: 'Centro Trabajo',
            codDepartamento: 'Departamento',
            servicios: 'Servicios',
            crearuser: 'Crear Usuario de aplicación',
            createdUser: 'Usuario de App',
            guardado_ok: 'Empleado guardado correctamente',
            auditoria_manual: 'Auditar manualmente',
            colegas: 'También se ocupa de lo de ...',
            // #932 · el rol y el acceso a la ERP son solo de ADMIN (Dirección, 26/10/2026). Va junto
            // a los controles que apaga y dice por qué, quién lo desbloquea y dónde (§9).
            acceso: {
                soloAdminEdicion: 'El rol y el usuario de aplicación solo los cambia un administrador '
                    + '(rol ADMIN): son con lo que esta persona entra en la ERP. Si hay que cambiarlos, '
                    + 'pídeselo a un ADMIN; lo hace aquí mismo, en la ficha de esta persona en Empleados.',
                soloAdminAlta: 'El rol y el usuario de aplicación solo los pone un administrador (rol '
                    + 'ADMIN). Guarda la ficha sin ellos y pídeselo a un ADMIN: se los asigna después en '
                    + 'esta misma ficha, en Empleados.',
                soloAdminEliminar: 'Esta persona tiene usuario de aplicación, y eliminar su ficha le '
                    + 'quita el acceso a la ERP: eso solo lo hace un administrador (rol ADMIN). Pídeselo '
                    + 'a un ADMIN desde Empleados. Si lo que quieres es darla de baja, desmarca «Activo» '
                    + 'o pon la fecha de baja y guarda.',
                tituloEliminar: 'Eliminar empleado'
            },
            // #864 · el perfil de CRM de la ficha, la única llave del CRM. Los motivos de las opciones
            // que no se pueden elegir los manda la API, con la misma regla con la que guarda.
            perfilCrm: {
                titulo: 'Perfil de CRM',
                label: 'Perfil de CRM',
                queEs: 'Lo que esta persona puede hacer en el CRM, y solo ahí: no cambia nada de lo que ve '
                    + 'en expedientes, ofertas, pedidos ni OEA, ni su rol en la ERP. Comercial ve lo suyo; '
                    + 'Dirección ve toda la cartera; Administrador ve toda la cartera y además administra la '
                    + 'configuración del CRM. Sin acceso, no entra al CRM.',
                noDisponible: 'no puedes elegirlo',
                historial: 'Historial del perfil de CRM',
                historialVacio: 'Nunca ha tenido perfil de CRM.',
                historialAlta: 'El historial aparece al guardar la ficha.',
                cuando: 'Cuándo',
                cambio: 'Cambio',
                quien: 'Quién',
                sinCargar: 'No se ha podido cargar el perfil de CRM de esta ficha.',
                reintentar: 'Reintentar',
                valores: {
                    SIN_ACCESO: 'Sin acceso',
                    COMERCIAL: 'Comercial',
                    DIRECCION: 'Dirección',
                    ADMINISTRADOR: 'Administrador'
                },
                origenes: {
                    migracion: 'migración inicial',
                    altaFicha: 'alta de la ficha',
                    bajaFicha: 'baja de la ficha',
                    bajaSap: 'baja de la ficha desde SAP',
                    cambioUsuario: 'cambio de usuario, antes {antes}'
                }
            },
            // #329 · el aviso de códigos huérfanos que acompaña a la lista de «Servicios» de la
            // ficha de inspector. Dice POR QUÉ está ahí, QUIÉN lo resuelve y DÓNDE, que es lo que
            // exige §9 del CLAUDE.md del orquestador: «3 códigos huérfanos» a secas no se puede
            // accionar. El texto no promete ninguna corrección desde esta pantalla porque no la
            // hay: sanear las fichas es una decisión de datos aparte.
            huerfanos: {
                tituloUno: 'Hay 1 código huérfano en esta lista de servicios',
                tituloVarios: 'Hay {n} códigos huérfanos en esta lista de servicios',
                porque: 'No corresponden a ningún servicio del catálogo: o el servicio se borró, o se '
                    + 'renombró, o la entrada se guardó con un código que nunca estuvo. Mientras sigan '
                    + 'así no habilitan ningún trabajo, aunque aparezcan en la lista.',
                quien: 'Los revisa dirección técnica en «Servicios», que es donde se ve si el código '
                    + 'existió. Quitarlos de la ficha o recuperar el servicio no se hace desde aquí: '
                    + 'es una corrección de datos que se decide aparte.',
                sinCodigo: '(entrada sin código)',
                repetidoUno: 'Además, 1 servicio está repetido en la lista:',
                repetidosVarios: 'Además, {n} servicios están repetidos en la lista:',
                noComprobado: 'No se ha podido comprobar si esta lista tiene códigos huérfanos.'
            },
            // #305 · el aviso del número de servicios marcados, que sale AL GUARDAR. Dice las dos
            // cosas que exige §9 del CLAUDE.md del orquestador —por qué está ahí y quién lo
            // resuelve y dónde— y una tercera que aquí hace falta: que la ficha SÍ se ha guardado.
            // Es un aviso y no un impedimento, y si no lo dijera, quien lo lea después de pulsar
            // Guardar daría por hecho que su cambio no ha entrado.
            avisoServicios: {
                masivoTitulo: 'Se han guardado {n} servicios marcados, de {catalogo} que tiene el catálogo',
                masivoPlantilla: 'El resto de la plantilla tiene una mediana de {mediana} servicios y un '
                    + 'máximo de {maximo}, sobre {fichas} fichas con servicios.',
                masivoPorque: 'Un número así suele ser un marcado masivo y no una decisión. Mientras la ficha '
                    + 'esté así, la cualificación por servicio no distingue qué trabajo puede hacer esta '
                    + 'persona y cuál no. La ficha SÍ se ha guardado: esto es un aviso, no un impedimento.',
                masivoQuien: 'Lo revisa dirección técnica: si es una cuenta técnica o genérica, se dice en su '
                    + 'rol; si es un inspector real, su lista tiene que reflejar la cualificación que se le '
                    + 'puede acreditar. Se corrige en esta misma lista de «Servicios».',
                sinServiciosTitulo: 'Esta ficha de inspector se ha guardado sin ningún servicio',
                sinServiciosPorque: 'Sin servicios marcados, el planificador no le propone ninguna línea: la '
                    + 'cualificación por servicio no habilita nada. La ficha SÍ se ha guardado: esto es un '
                    + 'aviso, no un impedimento.',
                sinServiciosQuien: 'Los completa dirección técnica en esta misma lista de «Servicios».'
            }
        },
        servicios: {
            servicios: 'Servicios',
            exclusiones: 'Exclusiones',
            vigencia: 'Vigencia (meses)',
            servicio: 'Servicio',
            objeto: 'Objeto',
            alcance: 'Alcance',
            normativa: 'Normativa',
            preparacionitem: 'Preparación del Item',
            adicional1: 'Texto adicional 1',
            adicional2: 'Texto adicional 2',
            add: 'Añadir',
            editar: 'Editar Servicio',
            nuevo: 'Nuevo Servicio',
            userText: 'Texto de usuario (Campo que se muestra en líneas de oferta, pedido y factura)',
            codigo: 'Código',
            nombre: 'Nombre',
            materia: 'Materia',
            precios: 'Precios',
            precioBasico: 'Precio Básico',
            porcSegunda: '% Segunda',
            blocPorcSegundas: 'Bloquea % Segunda',
            segundasIncluidas: 'Segundas incluidas en la primera',
            segundasIncluidasAyuda: 'Si se marca, en ofertas y pedidos la segunda inspección de este servicio se puede dejar incluida en la primera, a 0 €. Sin marcar, la segunda se factura aparte y hay que ponerle precio.',
            porcMinSegunda: '% Mínima Segunda',
            unidadInspeccion: 'Unidad Inspección',
            servicioUnidadExtra: 'Servicio de la Unidad Extra',
            tiempo: 'Tiempo Estimado (Minutos)',
            tiempoCampo: 'Tiempo Estimado Campo (Minutos)',
            tiempoOficina: 'Tiempo Estimado Oficina  (Minutos)',
            tiempoCampo2: 'Tpo. Estimado Campo 2ª Insp. (%)',
            tiempoOficina2: 'Tpo. Estimado Oficina 2ª Insp. (%)',
            formatos: 'Formatos',
            formato: 'Formato',
            listaPrecios: 'Lista de Precios',
            precio: 'Precio',
            moneda: 'Moneda',
            tasas: 'Tasas',
            subservicios: 'Sub-Servicios',
            textos: 'Textos',
            orden: 'Orden del texto',
            titulo: 'Título',
            html: 'Texto',
            obligatorio: 'Obligatorio',
            sololectura: 'No modificable',
            tasaDefecto: 'Tasa Defecto',
            tasaDefecto2: 'Tasa Defecto 2as',
            comunidad: 'Comunidad',
            valor: 'Valor',
            valor2as: 'Valor 2as',
            cualificaciones: 'Cualificaciones',
            tiempoEstimado: 'Tiempo Estimado (Minutos)',
            codCuentaMayor: 'Código Cuenta Mayor',
            guardado_ok: 'Servicio guardado correctamente',
            textoDocumentacionDefecto: 'Texto Documentación Defecto',
            textoDocumentacion: 'Texto Documentación',
            textosDocumentacion: 'Textos Documentación',
            exportarTexto: {
                title: 'Exportar Texto a otros servicios',
                exportar: 'Enviar a',
                eliminar: 'Eliminar de',
                servicios: 'Servicios',
                confirmar: '¿Está seguro de que desea exportar el texto a los servicios seleccionados?',
                confirmacion: 'Dar a OK para enviar el texto a los servicios seleccionados. Se reemplazará el texto actual si existe o se creará en caso de no existir.',
                confirmarEliminar: '¿Está seguro de que desea eliminar el texto de los servicios seleccionados?',
                confirmacionEliminar: 'Dar a OK para eliminar el texto de los servicios seleccionados.',
                exportado: 'Texto exportado correctamente',
                errorServicios: 'Debe seleccionar al menos un servicio para exportar el texto',
            }

        },
        combos: {
            combos: 'Opciones personalizadas',
            combo: 'Grupo de opciones',
            editar: 'Editar',
            nuevo: 'Nuevo grupo',
            nombre: 'Nombre de grupo',
            tipo: 'Tipo',
            tipos: {
                simple: 'Simple',
                texto: 'Texto',
                html: 'HTML',
                numero: 'Número'
            },
            cantidad_opciones: 'Cantidad de opciones',
            accion_opcion: 'Acción de la opción en back (solo asignaciones)',
            opciones: 'Opciones',
            nombre_opcion: 'Texto',
            codigo_opcion: 'Código',
            sin_opciones: '** No hay ninguna opción definida en el grupo',
            nueva_opcion: 'Nueva opción',
            combo_guardado: 'Grupo de opciones guardado correctamente',
            comentario_opcion: 'Comentarios sobre la opción'
        },
        documentos: {
            documentos: 'Documentos',
            documento: 'Documento',
            editar: 'Editar',
            nuevo: 'Nuevo documento',
            tiposDocumento: 'Tipos de documento',
            tipoDocumento: 'Tipo de documento',
            path: 'Ruta',
            nombre: 'Nombre',
            archivo: 'Archivo',
            plantilla: 'Plantilla',
            importarPlantilla: 'Importar plantilla',
            descargarPDFReferencias: 'Descargar PDF de referencias',
            expedientePrueba: 'Expediente de prueba',
            ofertaPrueba: 'Oferta de prueba',
            lineaPrueba: 'Linea de pedido de prueba',
            pruebaOfertaCorreo: 'Enviar correo de prueba de oferta',
            pruebaOportunidadCorreo: 'Enviar correo de prueba de oportunidad',
            probarPlantilla: 'Probar plantilla',
            fichero_existe_confirmacion: 'Guardar el fichero sobreescribirá el fichero que existe actualmente en la ruta indicada. ¿Desea continuar?',
            alerta_sin_fichero: 'No se puede guardar sin haber incluido un archivo.',
            correoPruebaEnviado: 'Se ha enviado el correo de prueba a la dirección: ',
            nueva_opcion: 'Nueva opción',
            documento_guardado: 'Documento guardado correctamente',
            camposPdf: {
                tipo: 'Tipo',
                nombre: 'Campo',
                valor: 'Valor',
                valoresEspeciales: 'Valores especiales',
            }
        },
        departamentos: {
            departamentos: 'Departamentos',
            departamento: 'Departamento',
            editar: 'Editar',
            nuevo: 'Nuevo',
            codigo: 'Código',
            nombre: 'Nombre',
            responsable: 'Responsable',
            guardado_ok: 'Departamento guardado correctamente',
            centrotrabajo: 'Centro de Trabajo'
        },
        empresasmantenedoras: {
            empresasmantenedoras: 'Empresas Mantenedoras',
            empresamantenedora: 'Empresa Mantenedora',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            direccion: 'Dirección',
            guardado_ok: 'Empresa Mantenedora guardada correctamente'
        },
        formatos: {
            formatos: 'Formatos',
            formato: 'Formato',
            editar: 'Editar',
            nuevo: 'Nuevo',
            version: 'Versión',
            versionSi: "Versión",
            versionNo: "Original",
            inspeccionable: 'Inspeccionable',
            tipomedida: 'Indicar Tipo de Medida a Adoptar',
            faltaMantenimiento: "Indicar falta de mantenimiento",
            condicionado: 'Condicionado',
            nuevoFormato: 'Nuevo Formato',
            codigo: 'Código',
            nombre: 'Nombre',
            fechaDesde: 'Aplica desde',
            fechaHasta: 'Aplica hasta',
            materia: 'Materia',
            descripcion: 'Descripción',
            auditoria: 'Auditoría',
            duplicar: 'Duplicar',
            nuevoCodigo: 'Nuevo Código',
            comprobaciones: 'Comprobaciones',
            condiciones: 'Condiciones',
            anexos: 'Anexos',
            anexo: 'Anexo',
            add: 'Añadir',
            ARITMETICO: 'Aritméticos',
            COMPARACION: 'Comparación',
            LOGICO: 'Lógicos',
            PARENTESIS: 'Paréntesis',
            valores: 'Valores',
            funciones: 'Funciones',
            cuando: 'Cuando',
            entonces: 'Entonces',
            tipo: 'Tipo',
            aplicaEn: 'Aplica en',
            activa: 'Activa',
            datosGenerales: 'Datos Generales',
            textoCategoriasDefectos: 'Texto Categorías Defectos',
            defectoLeve: 'Defecto Leve',
            defectoGrave: 'Defecto Grave',
            defectoMuyGrave: 'Defecto Muy Grave',
            codigoExpediente: 'Código Expediente',
            mensajeAMostrar: 'Mensaje a mostrar cuando NO cumple',
            formato_guardado: 'Formato guardado correctamente',
            precargas: 'Precargas',
            subformatos: 'Subformatos',
            nombre_precarga: 'Nombre de la precarga',
            comprobacion: 'Comprobación',
            valores: 'Valores',
            mensaje_nueva_precarga: '** No se ha configurado ningún perfil de precargas',
            nueva_precarga: 'Nueva precarga',
            modelosPlantilla: 'Modelos de informe',
            nueva_plantilla: 'Nuevo  modelo informe',
            nombre_plantilla: 'Nombre del informe',
            mensaje_nueva_plantilla: '** Elija documentos de plantilla de informe y toma de datos',
            noCondicionesPlantilla: '** No hay comprobaciones de características asociadas al informe',
            noAnexosPlantilla: '** No hay anexos asociados al informe',
            resultadoInspeccion: 'Resultado de inspección',
            calificacion: 'Calificación',
            resultadoInspeccionFavorable: 'Favorable',
            resultadoInspeccionNoFavorable: 'No favorable',
            tipoInspeccion: 'Tipo de inspección',
            tipoInspeccionPrimera: 'Primeras',
            tipoInspeccionSegundas: 'Segundas',
            anadirValor: 'Añadir valor',
            anadirCondicion: 'Añadir condición',
            anadirAnexo: 'Añadir anexo',
            certificado: 'Certificado',
            tomaDatos: 'Toma de datos',
            exportarComprobaciones: 'Exportar comprobaciones y defectos',
            importarComprobaciones: 'Importar comprobaciones y defectos',
            importacionComprobaciones: 'Fichero a importar',
            periodicidadMeses: 'Periodicidad (Meses)',
            provincias: 'Provincias',
            formatosCompatibles: 'Formatos compatibles',
            comprobacionesEnPlantillas: 'Copiar comprobaciones en plantilla',
            materiaEnItem: 'Usar materia en el ID del item',
            tiempoInspMin: 'Tiempo de inspección mínima (minutos)',
            tiempoInspMax: 'Tiempo de inspección máxima (minutos)',
        },
        componenteproteccion: {
            componentesproteccion: 'Componentes Protección',
            componenteproteccion: 'Componente Protección',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            tipo: 'Tipo',
            nombre: 'Nombre',
            componenteproteccion_guardado: 'Componente Protección guardado correctamente'
        },
        provincias: {
            provincias: 'Provincias',
            provincia: 'Provincia',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            provincia_guardada: 'Provincia guardada correctamente'
        },
        informeProp: {
            titulo: 'Informe de Propuesta de Planificación',
            verInforme: 'Ver informe →',
            inspector: 'Inspector',
            ventana: 'Ventana',
            solicitadaPor: 'Solicitada por',
            resuelta: 'Resuelta',
            determinista: 'Determinista · ENAC',
            kpiVisitas: 'Visitas propuestas',
            // #460 · La unidad de TODA la pantalla, dicha una vez: la elige `RecuentoPropuesta` y
            // es la misma con la que el servicio decide si la corrida quedó aceptada entera.
            kpiVisitasAyuda: 'La misma unidad que «Aceptadas»: las altas que crea el Aceptar, tal como la propia propuesta dejó escrito que las iba a crear. El proceso deductivo sí enseña cada bloque del planificador, y cada fila dice si es un tramo de una visita partida o si no llega a crear alta.',
            kpiImporte: 'Importe propuesto',
            kpiNoColocadas: 'No colocadas',
            kpiAntiguas: 'Líneas antiguas',
            kpiHoras: 'Horas de campo',
            // #460 · Estos km los ESTIMÓ la propuesta (línea recta × 1,3 sobre centroides de código
            // postal); los de la ruta real de Google no están en esta pantalla. El rótulo lo dice
            // porque leerlos como «la ruta» hizo dudar de la medida entera en la prueba del 15/10.
            kpiRuta: 'Ruta estimada',
            kpiRutaAyuda: 'Lo que estimó la propuesta (línea recta entre códigos postales), no la ruta de Google. La ruta real se calcula al Aceptar y se compara aparte.',
            estCorto: 'est.',
            campoCorto: 'campo',
            tdCorto: 'TD',
            kpiAceptadas: 'Aceptadas',
            // #460 · El texto decía que las continuaciones de una misma línea cuentan una sola vez,
            // y no es así: la unidad incluye el DÍA, porque el Aceptar crea un alta por cada día de
            // una visita que ocupa varios. Describir otra métrica que la que enseña el KPI es el
            // mismo defecto que enseñar dos cifras distintas, contado con palabras.
            kpiAceptadasAyuda: 'Las dos cifras son altas del Aceptar, no bloques del planificador: la propuesta deja escrito qué altas iba a crear —los tramos de una visita del mismo día se consolidan en una, una visita de campo repartida en varios días se crea una vez, una continuación se crea una vez por día y un informe de oficina una vez aunque salga en dos días— y la cifra de la izquierda son las que de verdad se crearon. Lo que falta se ve en «4 · Resolución», unidad por unidad. Las corridas anteriores a esta medida no guardaron ese detalle y se cuentan por bloques del planificador, y la pantalla lo dice.',
            // #460 (opción A) · Con qué se está contando, cuando no es el plan de la corrida. Un
            // recuento histórico se presenta como lo que es en vez de disimularse.
            recuentoLegado: 'corrida anterior a esta medida: contada por bloques del planificador',
            recuentoSinPlan: 'esta corrida no tiene registrado qué altas iba a crear: no se puede decir cuántas faltan',
            // #460 (opción A) · Una corrida resuelta con descartes no está aceptada del todo, pero
            // tampoco le falta nada por decidir. El cociente solo no distingue las dos cosas, así
            // que se dice: cuántas se quitaron a mano y que por eso el total no se alcanza.
            recuentoConDescartes: '{n} unidad(es) se descartaron a mano, así que no llega al total: no quedan pendientes',
            // #460 · Y si además queda algo sin decidir, no se puede decir «no quedan pendientes»:
            // el KPI estaría contradiciendo a las píldoras pendientes de la sección Resolución.
            recuentoConDescartesPendientes: '{n} unidad(es) se descartaron a mano, así que no llega al total; quedan {p} por decidir',
            enDia: 'en {n} día',
            enDias: 'en {n} días',
            repartoVisitas: 'reparto de las visitas',
            porMotivo: 'por {n} motivo',
            porMotivos: 'por {n} motivos',
            aRevisar: 'a revisar',
            porUsuario: 'por {u}',
            s1: '1 · Parámetros de la propuesta',
            s1hint: 'tal como se lanzó el Proponer',
            s2: '2 · Restricciones del inspector',
            snapshot: '📌 Snapshot congelado',
            s2nota: 'Condiciones exactas bajo las que se calculó esta propuesta. Se congelan porque las fichas cambian — el informe conserva las vigentes ese día.',
            s3: '3 · Proceso deductivo — visita a visita',
            s3hint: 'por qué ESE día y ESA hora',
            s4: '4 · Resolución',
            s4hint: 'quién decidió y qué se aceptó',
            s4hintTrabajos: 'una fila por alta creada, y en gris lo que queda pendiente',
            porqueNo1: 'Por qué NO se colocó {n} línea',
            porqueNo: 'Por qué NO se colocaron {n} líneas',
            fueraPropuesta: '{eur} fuera de esta propuesta',
            historico: 'Histórico de propuestas',
            historicoHint: 'consulta global · trazabilidad ENAC',
            selloCorrida: 'cifras, proceso y resolución de esta corrida',
            selloHistorico: 'histórico de propuestas',
            horizonte: 'Horizonte',
            alcance: 'Alcance',
            modo: 'Modo',
            comida: 'Comida',
            inicioJornada: 'Inicio de jornada',
            pernocta: 'Pernocta',
            proponerInformes: 'Proponer informes',
            sueloAntiguedad: 'Suelo de antigüedad',
            base: 'Base / salida',
            radioMax: 'Radio máximo',
            jornadaTope: 'Jornada tope',
            zonaPreferente: 'Zona preferente',
            prefInformes: 'Preferencia informes',
            provinciasCubre: 'Provincias que cubre',
            provinciasVetadas: 'Provincias vetadas',
            notas: 'Notas',
            visita: 'visita',
            visitas: 'visitas',
            colocado: 'colocado',
            dia: 'día',
            dias: 'días',
            mes: 'mes',
            meses: 'meses',
            si: 'Sí',
            no: 'No',
            noLimite: 'Sin límite',
            pedidoLinea: 'Pedido / línea',
            cliente: 'Cliente',
            poblacion: 'Población',
            motivo: 'Motivo',
            importe: 'Importe',
            irAlPedido: 'Ir al pedido →',
            propuestaGenerada: 'Propuesta generada',
            visitaPropuesta: '{n} visita propuesta',
            visitasPropuestas: '{n} visitas propuestas',
            aceptadaDe: '{n} de {t} pasada a “pendiente de confirmar”',
            aceptadasDe: '{n} de {t} pasadas a “pendiente de confirmar”',
            confirmadaEl: 'Confirmada',
            descartadaEl: 'Descartada',
            // #460 · Decía «las visitas no aceptadas no dejaron ningún rastro» mientras la sección
            // de al lado pinta en gris las que alguien descartó, con su motivo: dos partes de la
            // misma pantalla diciendo lo contrario (prueba de dirección del 16/10/2026, §9 del
            // CLAUDE.md del orquestador). Lo que no deja rastro es el DATO DE NEGOCIO; la auditoría
            // de la corrida sí lo guarda, y es de donde sale lo que se ve aquí.
            integridad: '🔒 Integridad: una visita no aceptada no crea ni modifica nada en el ERP — no hay expediente, ni albarán, ni cita en el calendario. Sí queda anotada en el histórico de la propuesta, con su motivo, y es lo que se ve arriba en gris. Los cambios canónicos (expediente, fecha de inspección) solo se escriben al Confirmar; aceptar es puramente aditivo y descartar revierte al 100 %.',
            fecha: 'Fecha',
            usuario: 'Usuario',
            estado: 'Estado',
            pctAcept: '% acept.',
            ver: 'Ver →',
            todas: 'Todas',
            estadoPROPUESTA: 'Propuesta',
            estadoACEPTADA: 'Aceptada',
            estadoACEPTADA_PARCIAL: 'Aceptada parcial',
            estadoCONFIRMADA: 'Confirmada',
            estadoDESCARTADA: 'Descartada',
            tpip: 'Producción de informes (TPI)',
            continuacion: 'Continuación de producción en campo (T0004)',
            continuacionCorta: 'continuación',
            // #460 · Un tramo del día en el que el planificador partió una visita larga. La fila lo
            // dice para que la cabecera del día («2 visitas») no parezca equivocada con 3 filas.
            tramoDe: 'tramo {i} de {n}',
            // #460 (opción A) · Lo que el plan de la corrida hace con un bloque que no crea alta: se
            // dice en su propia fila y con su motivo, porque un bloque omitido y una visita sin
            // aceptar no son lo mismo y antes se leían igual.
            bloqueSinAlta: 'no crea alta',
            bloqueSinAltaPorque: 'no crea alta: {motivo}',
            pendienteAyuda: 'Unidad de esta propuesta que todavía no tiene alta creada. Una aceptación parcial las conserva pendientes: se pueden aceptar después.',
            descartadaAyuda: 'Unidad que alguien quitó a mano de la propuesta antes de aceptarla. No se creó ni se va a crear, así que no cuenta como aceptada; pero tampoco queda pendiente.',
            descartadaPorEl: 'descartada por {usuario} el {fecha}',
            // #460 · Los minutos del informe son los PROPUESTOS. Cuando el alta se creó con otros
            // —la planificadora editó la duración antes de aceptar— se dice, con los dos lados: si
            // no, el informe enseña 1 h 30 y el calendario 2 h 14 sin que nada lo explique.
            // La medición y el veredicto de jornada no cambian: se dan con lo que vio el
            // planificador (decisión de dirección del 10/10/2026).
            colocadoAyuda: 'Minutos de trabajo que la propuesta colocó en ese día. Son los que estimó el planificador: si alguien editó una duración al aceptar, el alta del calendario puede tener otra y el día lo avisa aquí al lado.',
            duracionEditada: 'duración editada al aceptar: propuesta {prop}, aceptada {acep}',
            duracionEditadaAyuda: 'En este día hay trabajo cuyo alta se creó con otra duración que la propuesta. Los minutos de arriba son los propuestos, que son los que mide este informe; la duración real de la cita está en el calendario. El veredicto de jornada se da con la que vio el planificador.',
            diaConDuracionEditada: '1 duración editada al aceptar',
            diaConDuracionesEditadas: '{n} duraciones editadas al aceptar',
            // Una aceptada sin pedido ni línea ya no se pinta muda: se nombra con la identidad que
            // le dio el solver, y si tampoco la trae se dice eso mismo.
            bloqueDeLaCorrida: 'bloque {id}',
            sinIdentidad: 'sin pedido ni línea registrados',
            sinMotivo: 'sin motivo registrado',
            cargando: 'Cargando informe…',
            sinRegistros: 'No hay corridas registradas todavía.',
            criterioCorrida: 'criterio de la corrida:',
        },
        // #282 · Rótulos del diálogo de «Limpiar pendientes» del calendario. Nombran la CONSECUENCIA, no
        // el ámbito: «Todo el horizonte» sonaba a alcance y son seis meses de trabajo aceptado de ese
        // empleado a un clic. El cuerpo del diálogo se sigue construyendo en línea, porque son frases
        // con cifras calculadas y dos alcances variables.
        // #282 ronda 3 · El título decía «visitas» y lo que se borra puede ser una tarea de informe TPI
        // o de continuación multidía: el rótulo no nombra el tipo, que lo reparte el cuerpo con su cifra.
        limpiarPendientes: {
            titulo: 'Se van a borrar propuestas que has aceptado',
            cancelar: 'Cancelar, no borrar nada',
            borrarVentana: 'Borrar {n} aceptadas sin confirmar',
            borrarHorizonte: 'Borrar {n} en ±90 días',
            segundaTitulo: '¿Seguro? Son los ±90 días completos',
            segundaNo: 'No, dejarlo como está',
            segundaSi: 'Sí, borrar las {n} y su ruta',
        },
        proponerDrawer: {
            titulo: 'Proponer planificación',
            subtitulo: 'Configura la corrida y revisa el resumen antes de lanzar',
            abrir: 'Proponer planificación…',
            inspector: 'Inspector',
            sinInspector: 'Selecciona un empleado en el filtro del calendario',
            parametros: 'Parámetros de la corrida',
            ventana: 'Ventana / horizonte',
            desde: 'Desde',
            unaSemana: '1 semana',
            dosSemanas: '2 semanas',
            alcance: 'Alcance',
            alcanceHorizonte: 'Todo el horizonte',
            alcanceUnDia: 'Un día',
            alcanceCompletarDia: 'Completar día',
            modo: 'Modo',
            modoCubrir: 'Cubrir huecos',
            modoReplan: 'Replanificar días',
            modoHint: 'Cubrir huecos: respeta lo ya planificado/confirmado',
            diasReplan: 'Días a replanificar',
            semana: 'Semana',
            comida: 'Comida (ventana · preferente · duración)',
            conComida: 'Planificar con comida',
            jornada: 'Inicio de jornada (preferente · mínimo)',
            jornadaHint: 'El mínimo solo se usa en viajes largos',
            sueloAntiguedad: 'Suelo de antigüedad',
            meses: '{n} meses',
            pernocta: 'Permitir pernocta',
            pernoctaHint: 'Según ficha del inspector',
            informes: 'Proponer informes (TPI)',
            informesHint: 'Incluye producción de informes en gabinete',
            antesDeLanzar: 'Antes de lanzar',
            previewTitulo: 'Esto es lo que vas a proponer',
            previewCargando: 'Calculando el resumen…',
            previewError: 'No se pudo calcular el resumen',
            candidatas: 'líneas a proponer en esta corrida',
            colocables: 'Colocables {n}',
            segundas: '2ª próximas {n}',
            antiguas: 'Antiguas {n}',
            sinCoords: 'Sin coordenadas {n}',
            informesN: 'Informes {n}',
            chipBase: 'Base',
            chipRadio: 'Radio',
            chipTope: 'Tope',
            chipProvincias: 'Provincias',
            chipZonaPref: 'Zona pref.',
            chipPernocta: 'Pernocta',
            si: 'Sí',
            no: 'No',
            fichaOk: 'Ficha del inspector configurada y vigente',
            fichaIncompleta: 'Ficha del inspector incompleta — el solver usará los valores por defecto',
            fichaSinConfigurar: 'Inspector sin ficha de restricciones — configúrala en Restricciones',
            // #296 (dirección 07/10/2026). El texto anterior —«El inspector no tiene servicios
            // habilitados — el pool de campo saldrá vacío»— decía el POR QUÉ a medias y no decía ni
            // QUIÉN lo desbloquea ni DÓNDE, que es lo que exige §9 del CLAUDE.md del orquestador. Y
            // era anónimo: quien planifica tiene varios inspectores delante, así que un aviso sin
            // nombre no se puede accionar. Los servicios de la ficha salen de las cualificaciones
            // vigentes del inspector (ServiciosInspectorSyncService los sincroniza desde
            // `personalcualificado`), por eso la pantalla a la que se dirige es «Personal cualificado».
            sinServicios: 'La ficha de {inspector} no tiene ningún servicio habilitado, así que no se le '
                + 'propondrá ninguna línea de campo. Lo desbloquean RRHH o dirección técnica completando su '
                + 'ficha de inspector: los servicios salen de sus cualificaciones, en «Personal cualificado».',
            // Misma información, condensada para la línea que acompaña al botón de Proponer.
            sinServiciosPie: '{inspector} no recibirá líneas de campo: su ficha no tiene servicios '
                + 'habilitados. Lo desbloquean RRHH o dirección técnica en «Personal cualificado».',
            // Fallback nominal: si el aviso llegara sin usuario y el filtro del calendario tampoco lo
            // tuviera, se dice «este inspector» antes que dejar un hueco o un guion suelto.
            sinServiciosInspectorAnonimo: 'Este inspector',
            recorteTope: '{n} candidatas — el solver considera las {tope} más prioritarias',
            sinCoordsAviso: '{n} líneas sin coordenadas — no entrarán hasta geocodificar',
            cerradasSapAviso: '{n} cerradas en SAP (excluidas de la propuesta) — revísalas en el pedido',
            cobradoSinRealizarAviso: '{n} cobradas/facturadas sin realizar a revisar ({importe})',
            // #760 · la medida de la puerta del bloque vivo (#670). «Ninguna» se dice con esa palabra:
            // una línea que desaparece al ser cero no demuestra que se midió.
            puertaSoloHistorico: 'De las {n} candidatas de campo, {x} entran porque solo tienen trabajo '
                + 'realizado detrás (importe {importe})',
            puertaSoloHistoricoUna: 'De las {n} candidatas de campo, 1 entra porque solo tiene trabajo '
                + 'realizado detrás (importe {importe})',
            puertaSoloHistoricoNinguna: 'De las {n} candidatas de campo, ninguna entra por tener solo trabajo '
                + 'realizado detrás',
            puertaBloqueVivo: '{z} líneas quedan fuera por bloque vivo',
            puertaBloqueVivoUna: '1 línea queda fuera por bloque vivo',
            puertaBloqueVivoNinguna: 'Ninguna línea queda fuera por bloque vivo',
            puertaHint: 'Bloque vivo: la línea ya está en un calendario, planificada o pendiente de confirmar. '
                + 'Cuenta lo que se anuncia aquí; al lanzar, la corrida aún puede retirar alguna por otros motivos.',
            puertaVerLista: 'Ver la lista',
            puertaOcultarLista: 'Ocultar la lista',
            puertaColPedido: 'Pedido',
            puertaColLinea: 'Línea',
            puertaColCliente: 'Cliente',
            puertaColImporte: 'Importe',
            puertaColUltimo: 'Último trabajo realizado',
            puertaColBloque: 'Bloque vivo',
            puertaColMotivo: 'Motivo',
            puertaSinFecha: 'sin fecha',
            puertaPlanificada: 'Planificada',
            puertaPendiente: 'Pendiente de confirmar',
            motivoSoloHistorico: 'Solo tiene trabajo realizado detrás',
            motivoBloqueVivo: 'Tiene un bloque vivo',
            cancelar: 'Cancelar',
            proponerN: '⚡ Proponer {n} líneas',
            proponer: '⚡ Proponer planificación',
            // ENCARGO-021c · fases del /proponer/async (canal SSE proponer-planificacion).
            // La etiqueta se pinta en el drawer mientras la pasada avanza. EN_COLA es la única
            // fase que puede alargarse: refleja el hueco real en el ExecutorService del backend
            // (el solver es 1 worker; ver ProponerJobService en simecal-api-movilidad).
            faseEnCola: '⏳ En cola, hay otra propuesta calculándose',
            faseConstruyendo: '📦 Preparando la carga de trabajo…',
            faseResolviendo: '🧮 Enviando al solver…',
            faseMapeando: '🗺️ Mapeando la propuesta…',
            faseFin: '✅ Propuesta lista',
            faseError: '⚠️ La propuesta ha fallado',
            faseDesconocida: '…',
            reengancheViva: 'Reengancho: hay una propuesta en curso lanzada por ti; sigue avanzando aquí.',
            reengancheTerminada: 'La última propuesta ya terminó. ¿Ver su resultado?',
            reengancheTerminadaAccion: 'Ver resultado',
            reengancheDescartar: 'Descartar y lanzar otra',
            timeoutSinEventos: 'Sin respuesta del solver desde hace 15 minutos. Vuelve a lanzar la propuesta o revisa con el equipo si el solver está caído.',
            // #283 · aquí vivía `timeoutBoton: 'Cerrar'`. El aviso de timeout se cierra ahora con
            // el mismo ✕ que el resto de la banda flotante, así que no hay un segundo rótulo de
            // cerrar que pueda quedarse diciendo otra cosa: todos usan `cerrar`, al final.
            ocupadoDeOtro: 'Ya hay una propuesta en curso para {inspector}, lanzada por {usuario}. Espera a que termine.',
            error503: 'El cálculo en segundo plano no está disponible. Vuelve a intentarlo en unos minutos o avisa al equipo.',
            errorLanzar: 'No se pudo lanzar la propuesta. Vuelve a intentarlo.',
            // #460 (opción A) · decía «{n} visitas propuestas» contando los BLOQUES que el
            // planificador ha dejado en el calendario, que no son las visitas que el Aceptar crea:
            // una visita partida en dos tramos son dos bloques y un alta. El informe de la corrida
            // cuenta altas, así que el mismo número con la misma palabra decía dos cosas distintas
            // en dos pantallas. Aquí se dice lo que de verdad se está contando, que es lo que hay
            // pintado; cuántas altas saldrán lo dice el diálogo del Aceptar.
            finResumen: '{n} bloques en el calendario',
            verInforme: 'Ver informe completo',
            // #460 · el informe es otra pantalla y la propuesta que hay en el calendario es
            // provisional: no se persiste y el salto la destruye. Se avisa antes de pulsar, no
            // después, que es cuando ya no hay nada que aceptar.
            informeSaleDelCalendario: 'Al abrir el informe se pierde esta propuesta: si la vas a aceptar, acéptala antes.',
            aceptarDeprecado: 'Aceptar (usa el informe)',
            // ENCARGO-023 §2 · vista reducida cuando /resultado devuelve 410.
            reducidaTitulo: '👀 Vista reducida',
            reducidaDefault: 'Vista reducida: el resultado completo ha caducado. Faltan desplazamientos, banco y avisos. Vuelve a lanzar para verlo entero.',
            // ENCARGO-025 · botón "Cerrar" para descartar bandas terminales (FIN, ERROR,
            // "ocupado por otro") desde la banda flotante fuera del drawer.
            // #283 · ahora es además el rótulo del ✕ de TODOS los bloques de esa banda (title y
            // aria-label): el icono solo no dice nada a quien navega con lector de pantalla.
            cerrar: 'Cerrar',
        },
        // PALANCA C FASE 2: sección "Anomalías a revisar" del Dashboard de Control
        anomaliasRevisar: {
            titulo: 'Anomalías a revisar',
            hint: 'control de deuda y saneamiento · ámbito: global',
            // #544 · con el rango de fechas puesto esta sección YA no es del todo global, y el rótulo
            // tiene que decirlo: las tarjetas y los chips cuentan el mismo rango que las cifras de
            // arriba, pero siguen sin mirar Planificadora, Provincia, Materia ni Planificable.
            hintConFechas: 'control de deuda y saneamiento · ámbito: global, dentro del rango de fechas',
            // #619 · sin rango en la cabecera la sección ya no es del todo global: cuenta la ventana
            // por defecto, y el rótulo del ámbito lo dice con los años que ha aplicado el servidor.
            hintVentanaDefecto: 'control de deuda y saneamiento · ámbito: global, últimos {n} años',
            // #619 · la línea que dice, JUNTO a las tres tarjetas, qué ventana se está contando y
            // cuánto se queda fuera. Lo de fuera va siempre: si al acotar el número baja mucho, no
            // puede leerse como que el problema se ha arreglado, sino como que se ha dejado de mirar.
            ventanaDefecto: 'Se muestran las líneas de los últimos {n} años: pedidos con fecha de ejecución desde el {desde}.',
            ventanaRango: 'Se muestran las líneas del rango de «Desde» y «Hasta»: pedidos con fecha de ejecución {rango}.',
            ventanaFuera: 'Fuera quedan {n} líneas ({importe}){sinFecha}; no se ha borrado ni cerrado ninguna.',
            // El pedido sin fecha de ejecución completa lleva el 01/01/1970: no lo alcanza un «Desde»
            // de los años de la aplicación, pero sí un «Hasta» solo. Se dice cómo llegar a ellas.
            ventanaFueraSinFecha: ', {n} de ellas de pedidos sin fecha de ejecución, que se ven dejando «Desde» vacío y poniendo solo «Hasta»',
            ventanaFueraNinguna: 'Fuera no queda ninguna línea.',
            // Solo cuando hay anteriores con fecha: las de pedidos sin fecha ya llevan su camino en
            // la frase de arriba, y «las anteriores» no serían ellas.
            ventanaAmpliar: 'Para ver las anteriores, amplía el rango con «Desde» y «Hasta», arriba.',
            // Las cifras de arriba siguen sin ventana cuando no hay rango: el panel lo dice junto a
            // las suyas para que las dos partes de la pantalla no se lean como si contaran lo mismo.
            ventanaArriba: 'Las cifras de la parte de arriba de la pantalla no llevan esta ventana.',
            // Ronda 1 de revisión de la #544 · lo que se lee junto a las tarjetas cuando la recarga
            // del rango nuevo no llegó: las cifras que se ven son del rango con el que se pidieron,
            // y hay que decirlo ahí mismo en vez de dejarlas bajo un rótulo que anuncia el nuevo.
            // Dos frases porque los dos casos se arreglan igual pero NO dicen lo mismo: venir de un
            // rango anterior no es lo mismo que venir de todas las fechas.
            rangoAnterior: 'Estas tres cifras y los recuentos de los botones de estado son del rango de fechas ANTERIOR: la recarga no se completó. Vuelve a intentarlo con «Reintentar», debajo de la tabla.',
            rangoSinFechas: 'Estas tres cifras y los recuentos de los botones de estado son de TODAS las fechas, sin el rango que hay puesto: la recarga no se completó. Vuelve a intentarlo con «Reintentar», debajo de la tabla.',
            // #619 · desde que hay ventana por defecto, «sin rango» ya no es «todas las fechas».
            rangoVentanaDefecto: 'Estas tres cifras y los recuentos de los botones de estado son de la ventana por defecto (últimos {n} años), sin el rango que hay puesto: la recarga no se completó. Vuelve a intentarlo con «Reintentar», debajo de la tabla.',
            lead: 'Líneas que no se planifican pero conviene revisar: trabajo cobrado o facturado sin realizar (deuda a la vista) y líneas cerradas en SAP que el planificador excluye automáticamente. Todas tienen TPC = No (campo pendiente).',
            tileCobrado: 'Cobrado / facturado sin realizar',
            tileCobradoSub: 'líneas · TPC No',
            tileSap: 'Cerradas en SAP',
            tileSapSub: 'excluidas de planificación',
            tileSapProponibles: 'de ellas, {n} proponibles bloqueadas',
            tileTotal: 'Total a revisar',
            tileTotalSub: 'líneas en estados anómalos',
            chipTodas: 'Todas',
            chipCobradas: 'Cobradas',
            chipFacturadas: 'Facturadas',
            chipEjecutadas: 'Ejecutadas',
            chipSap: 'Cerradas SAP',
            thPedido: 'Pedido / línea',
            thCliente: 'Cliente',
            thPoblacion: 'Población',
            thEstado: 'Estado',
            thTpc: 'TPC',
            thImporte: 'Importe',
            badgeCobrada: 'Cobrada',
            badgeFacturada: 'Facturada',
            badgeEjecutada: 'Ejecutada',
            badgeSap: 'Cerrada SAP',
            tpcNo: 'No',
            irPedido: 'Ir al pedido →',
            cargando: 'Cargando…',
            vacio: 'Sin anomalías para el filtro actual.',
            mostradas: '{n} líneas mostradas',
            // #543 · «Cargar más»: el control nunca se queda mudo. Cuando no se puede usar, el
            // motivo va A SU LADO (§9 del CLAUDE.md del orquestador) y no en un aviso de pantalla.
            cargarMas: 'Cargar más',
            cargarMasQuedan: 'quedan {n}',
            cargandoMas: 'cargando más líneas…',
            cargarMasCompleto: 'ya se ven todas las líneas de este estado',
            cargarMasCompletoTodas: 'ya se ven todas las líneas',
            cargarMasSinTotal: 'no se sabe si quedan más líneas: {causa}',
            // Ronda 1 de revisión · una página vacía PRUEBA el final del recorrido, aunque no se
            // sepa el total. Se dice con sus palabras y no con el «ya se ven todas» del total, que
            // afirmaría algo que en este caso no se ha medido.
            cargarMasFin: 'no quedan más líneas: la última página ya ha venido vacía',
            cargarMasError: 'la última carga no se completó: {causa}',
            reintentar: 'Reintentar',
            // Ronda 2 de revisión · la tabla se queda vacía cuando falla la PRIMERA página de un
            // estado (sus filas son del estado anterior y no se pueden dejar pintadas), y el pie
            // tiene que decir que está vacía por el fallo y no porque no haya nada.
            pieError: 'no se han podido cargar las líneas de este estado: {causa}',
        },
        vacaciones: {
            titulo: 'Vacaciones',
            gestiona: 'Gestiona vacaciones en este usuario',
            mismaPersonaQue: 'Misma persona que (usuario principal)',
            mismaPersona: 'Misma persona:',
            siGestiona: 'gestiona vacaciones',
            noGestiona: 'no gestiona',
            aprobador: 'Le aprueba las vacaciones',
            suplente: 'Aprobador suplente',
            apruebaA: 'Aprueba las vacaciones de',
            diasAnuales: 'Días anuales',
            saldo: 'Saldo',
            saldoPendiente: 'El saldo se rellena cuando entre el servicio de vacaciones.',
            motivo: 'Motivo del cambio',
            guardar: 'Guardar vacaciones',
            guardado: 'Tarjeta de vacaciones guardada',
            cuspide: 'Cúspide · decisión D18.',
            cuspideNota: 'Sus vacaciones las puede aprobar cualquier otro usuario con rol ADMIN. El aviso de cada solicitud va a su aprobador y a su suplente de esta tarjeta, si tienen rol ADMIN; si no hay ninguno, a todos los ADMIN.',
            avisoMismoDni: 'Hay otros usuarios activos con el mismo DNI sin vincular:',
            pie: 'Solo un usuario por persona gestiona las vacaciones: al marcar el check aquí se desmarca en los demás usuarios de esa persona. Todo cambio queda registrado.',
            cargando: 'Cargando la tarjeta de vacaciones de este usuario…',
            errorCargando: 'No se ha podido cargar la tarjeta de vacaciones',
            errorGuardando: 'No se ha podido guardar la tarjeta de vacaciones',
            estados: {
                CARGANDO: 'Cargando…',
                NO_DISPONIBLE: 'Sin datos',
                CORRECTO: 'Correcto',
                SIN_APROBADOR: 'Sin aprobador · no puede solicitar',
                APROBADOR_INACTIVO: 'Aprobador inactivo',
                SE_APRUEBA_A_SI_MISMO: 'Se aprueba a sí mismo',
                NO_GESTIONA_VACACIONES: 'No gestiona vacaciones',
                CUSPIDE: 'Cúspide · decisión D18'
            }
        },
        mapaaprobacion: {
            titulo: 'Mapa de aprobación',
            recargar: 'Recargar',
            noAutorizado: 'No está autorizado para ver el Mapa de aprobación (solo ADMIN y DIRECTOR)',
            buscar: 'Buscar persona…',
            incluirInactivos: 'Incluir personas de baja',
            total: 'Total',
            persona: 'Persona',
            gestiona: 'Gestiona',
            leAprueba: 'Le aprueba',
            suplente: 'Suplente',
            apruebaA: 'Aprueba a',
            estado: 'Estado',
            si: 'Sí',
            no: 'No',
            deBaja: 'De baja: no puede aprobar',
            asignacionBloque: 'Asignación en bloque',
            marcadas: 'Marcadas',
            marcadasOcultas: '({n} fuera del filtro)',
            confirmarOcultas: 'Hay {n} persona(s) marcadas que el filtro no está mostrando y a las que también se les cambiará el aprobador: {quienes}. ¿Continuar?',
            aprobador: 'Aprobador',
            motivo: 'Motivo del cambio',
            asignar: 'Asignar a las marcadas',
            pieBloque: 'Se asigna el aprobador a todas las personas marcadas. Dejar el aprobador vacío se lo quita. Cada cambio queda registrado con su motivo.',
            resultado: '{actualizados} actualizadas, {sinCambios} sin cambios',
            sinResultados: 'Ninguna persona con esos filtros',
            sinFicha: 'No se ha encontrado la ficha de esa persona',
            errorCargando: 'No se ha podido cargar el Mapa de aprobación',
            errorAsignando: 'No se ha podido asignar el aprobador',
            avisos: {
                USUARIOS_SIN_VINCULAR: 'Usuarios sin vincular'
            }
        },
        festivosboletin: {
            titulo: 'Festivos · Leer boletines',
            leerBoletines: 'Leer boletines',
            noAutorizado: 'No está autorizado para gestionar los festivos de RRHH',
            explicacion: 'Sube el PDF del boletín oficial y la IA propone los festivos de los municipios donde vive la plantilla. Nada queda publicado: todo lo propuesto hay que validarlo a mano.',
            municipiosEnUso: 'Municipios donde vive la plantilla',
            sinMunicipios: 'Todavía no hay ninguna persona con municipio de residencia informado, así que no hay municipios que buscar en el boletín.',
            // Los dos estados que le faltaban a la lista: mientras el GET está en vuelo y cuando
            // ha fallado. Decir «no hay ninguna persona con municipio» sin haberlo preguntado es
            // el defecto que la #262 encontró en la tabla de Ajustes · Festivos.
            cargandoMunicipios: 'Cargando los municipios donde vive la plantilla…',
            municipiosSinCargar: 'No se ha podido cargar la lista de municipios.',
            reintentar: 'Reintentar',
            personas: '{n} persona | {n} personas',
            resultadoLectura: 'Última lectura',
            fuente: 'Boletín',
            documento: 'Documento',
            modelo: 'Modelo de IA',
            discrepancias: 'Avisos de discrepancia',
            discrepanciasAyuda: 'El boletín dice algo distinto de lo que ya estaba validado. No se ha cambiado nada: decide tú si mantienes lo validado o lo corriges.',
            validadoDice: 'Validado: {fecha} · {nombre} ({fuente})',
            boletinDice: 'El boletín dice: {fecha} · {nombre} ({fuente})',
            propuestos: 'Festivos propuestos',
            estadoPropuesto: 'Propuesto',
            segunBoletin: 'Según el boletín: «{texto}»',
            avisoLectura: 'Aviso de la lectura',
            yaExistentes: 'Ya estaban en el catálogo',
            faltanLocales: 'Municipios a los que faltan festivos locales',
            noReconocidos: 'No reconocidos (descartados)',
            historial: 'Lecturas anteriores',
            sinLecturas: 'Todavía no se ha leído ningún boletín.',
            cargandoLecturas: 'Cargando las lecturas anteriores…',
            // Sin enlace de reintento: el botón «Actualizar lecturas anteriores» de debajo ya lo es.
            lecturasSinCargar: 'No se ha podido cargar el historial de lecturas. Pulse «Actualizar '
                + 'lecturas anteriores» para volver a intentarlo.',
            actualizarHistorial: 'Actualizar lecturas anteriores',
            actualizando: 'Actualizando…',
            ambitoNacional: 'Nacional',
            ambitoAutonomico: 'Autonómico',
            ambitoAutonomicoDe: 'Autonómico · comunidad {comunidad}',
            ambitoLocal: 'Local',
            dialogoAyuda: 'Solo se admite el PDF del boletín: el enlace se guarda como referencia, pero no se descarga.',
            anio: 'Año de los festivos',
            fuenteRef: 'Referencia del boletín',
            fuenteRefEjemplo: 'BOCM 12/12/2025',
            fuenteUrl: 'Enlace al boletín (solo referencia)',
            fuenteUrlEjemplo: 'https://www.bocm.es/…',
            pdf: 'PDF del boletín',
            sinFichero: 'Sin elegir',
            elegirPdf: 'Elegir PDF…',
            leer: 'Leer el boletín',
            // El botón se apagaba sin decir qué le falta. Misma regla que en la tarjeta del
            // municipio: un control que no se puede usar dice por qué, y junto al control
            // (§9 del CLAUDE.md del orquestador).
            faltaParaLeer: 'Para leer el boletín falta: {falta}.',
            faltaAnio: 'el año',
            faltaFuenteRef: 'la referencia del boletín',
            faltaPdf: 'elegir el PDF',
            leyendo: 'Se está leyendo el boletín: espere a que termine.'
        },
        // El bloque `vacaciones` de arriba es el de la tarjeta Vacaciones de la ficha del
        // empleado (#52). Estas son las pantallas del solicitante (#58) y necesitan clave
        // propia: repetir `vacaciones` no da error, la segunda gana en silencio y la ficha
        // se queda sin ni una etiqueta (Sonar javascript:S1534).
        misVacaciones: {
            titulo: 'Mis vacaciones',
            misSolicitudes: 'Mis solicitudes',
            recargar: 'Recargar',
            noAutorizado: 'No tienes permiso para ver esta pantalla.',
            errorCargando: 'No se han podido cargar tus vacaciones.',

            totales: 'Totales',
            disfrutadas: 'Disfrutadas',
            confirmadas: 'Confirmadas',
            solicitadas: 'Solicitadas',
            disponibles: 'Disponibles',
            pieDisfrutadas: 'ya pasadas',
            pieConfirmadas: 'aprobadas · por disfrutar',
            pieSolicitadas: 'sin aprobar todavía',
            pieDisponibles: 'para solicitar',
            // Con el botón apagado la tarjeta no puede decir «para solicitar»: §9 del CLAUDE.md
            // del orquestador, dos partes de la misma pantalla no pueden decir lo contrario.
            pieDisponiblesBloqueado: 'todavía no se pueden solicitar',
            // Y por debajo de cero manda esto (#70): un «para solicitar» debajo de un −2 es el
            // mismo defecto de §9 contado al revés.
            pieDisponiblesNegativo: 'días de más ya disfrutados',
            noPuedesSolicitar: 'No puedes solicitar vacaciones todavía:',
            loDesbloquea: 'Lo desbloquea {quien}',
            deConvenio: '{dias} de convenio',
            // El saldo de partida que confirmó Laboral (#682): no son los 23 del convenio, así
            // que no se puede llamar «de convenio» (§9 del CLAUDE.md del orquestador).
            deSaldoPartida: '{dias} de saldo de partida confirmado',
            deAnioAnterior: '{dias} de {anio}',
            // #1158 · Lo que mueve la bolsa del año desde su cifra de partida, una línea por cosa y
            // con su signo. Lo explica junto a la tarjeta, que es donde está el número.
            movPuestosEnElCorte: '{signo} {dias} que ya tenías puestos el {fecha}',
            movDevueltosTrasElCorte: '{signo} {dias} que tenías puestos el {fecha} y te han devuelto',
            movReservadosAnioSiguiente: '{signo} {dias} que ya usan tus vacaciones de {anio}',
            movAjusteRrhh: '{signo} {dias} de ajuste de RRHH',
            movRetiradaIt: '{signo} {dias} que pasaron a incapacidad temporal',
            movApuntadosTrasElCorte: '{signo} {dias} apuntados en el calendario después del corte',
            movAjuste: '{signo} {dias} de ajuste',
            deAjustes: '{dias} de ajustes de RRHH',
            deExcepcionales: '{dias} excepcionales de RRHH',
            prorrateado: 'parte proporcional del año',
            excepcionales: '{dias} día(s) excepcionales reconocidos por RRHH, hasta {hasta}',
            // La respuesta a «¿por qué tengo 6 y no 23?»: se dice una vez y con la fecha a la
            // que se refiere el número, que es lo que lo hace comprobable.
            saldoPartidaConfirmado: 'Tu saldo de partida lo confirmó Laboral: a {fecha} te quedaban {dias} día(s) por disfrutar, ya descontado todo lo disfrutado y lo que tenías puesto a futuro. Desde esa fecha solo baja lo que pidas por aquí.',
            sinCaducidad: 'sin fecha de caducidad',
            tituloBarra: 'Disfrutadas {disfrutadas} · Confirmadas {confirmadas} · Solicitadas {solicitadas} · Disponibles {disponibles}',

            lista_solicitadas: 'Solicitadas sin aprobar',
            lista_confirmadas: 'Confirmadas por disfrutar',
            lista_disfrutadas: 'Disfrutadas en {anio}',
            listaVacia_solicitadas: 'No tienes ninguna solicitud sin aprobar.',
            listaVacia_confirmadas: 'No tienes vacaciones aprobadas por disfrutar.',
            listaVacia_disfrutadas: 'Todavía no has disfrutado vacaciones este año.',
            nDias: '{dias} día(s)',
            nDiasDisfrutados: '{dias} día(s) disfrutados',
            solicitadaEl: 'solicitada el {fecha}',
// La marca de la #70, punto 6: se ve en la solicitud y en el histórico de la persona.
            registradaPor: 'registrada por {quien}',
            aprobadaPor: 'aprobada por {quien}',
            anular: 'Anular solicitud',
            anulando: 'Anulando…',
            anulada: 'Solicitud anulada.',
            confirmaAnular: '¿Anular la solicitud {codigo}? Los días desaparecerán de tu calendario y recuperarás el saldo.',
            errorAnulando: 'No se ha podido anular la solicitud.',

            aniosAnteriores: 'Años anteriores',
            anio: 'Año',
            // #1119 · En el selector de año, cuántas de tu equipo esperan respuesta en ese año.
            anioConPendientes: '{anio} ({n} por resolver)',
            devengadas: 'Devengadas',
            disfrutadasEseAnio: 'Disfrutadas ese año',
            noDisfrutadas: 'No disfrutadas',
            usadasDespues: 'Usadas después',
            pendientes: 'Pendientes',
            retiradosPorDeuda: '{dias} retirados para cuadrar un saldo negativo posterior',
            sePuedenUsarHasta: 'Se pueden usar hasta',
            caducado: 'caducados',
            caducidadExtra: 'y {dias} hasta el {hasta}',
            caducidadPerdida: 'y {dias} caducados el {hasta}',
            porBajaMedica: 'por baja médica',
            sinAniosAnteriores: 'No hay años anteriores que mostrar.',

            historial: 'Historial de solicitudes',
            solicitud: 'Solicitud',
            fechas: 'Fechas',
            dias: 'Días',
            estado: 'Estado',
            ultimoMovimiento: 'Último movimiento',
            sinSolicitudes: 'Todavía no has pedido vacaciones este año.',

            estado_PENDIENTE: 'Pendiente de confirmar',
            estado_CONFIRMADA: 'Confirmada',
            estado_REALIZADA: 'Realizada',
            estado_DENEGADA: 'Denegada',
            estado_ANULADA: 'Anulada',
            estado_ANULADA_SOLICITANTE: 'Anulada por ti',
            accion_SOLICITUD_VACACIONES: 'Solicitada por {quien}',
            accion_APROBACION_VACACIONES: 'Aprobada por {quien}',
            accion_DENEGACION_VACACIONES: 'Denegada por {quien}',
            accion_ANULACION_VACACIONES: 'Anulada por {quien}',
            accion_REGISTRO_VACACIONES_EN_NOMBRE: 'Registrada por {quien} en tu nombre',
            // #69 · las cinco acciones del flujo de anulación de unas ya aprobadas. Sin ellas, el
            // «Último movimiento» del historial enseñaba la clave en crudo.
            accion_PETICION_ANULACION_VACACIONES: 'Anulación pedida por {quien}',
            accion_ACEPTACION_ANULACION_VACACIONES: 'Anulación aceptada por {quien}',
            accion_RECHAZO_ANULACION_VACACIONES: 'Anulación rechazada por {quien}',
            accion_ANULACION_DIRECTA_VACACIONES: 'Días anulados por {quien}',
            accion_CADUCIDAD_PETICION_ANULACION: 'Petición de anulación caducada',

            pieAprobador: 'Tus vacaciones las aprueba {quien}.',
            // Sin `pieSinAprobador`: ese caso lo cuenta el impedimento de al lado del botón, con
            // quién lo desbloquea y dónde. La causa se dice una vez (§9).
            pieAutoconfirma: 'No tienes aprobador superior: tus solicitudes se confirman solas y hay que escribir el motivo.',

            solicitar: 'Solicitar vacaciones',
            solicitarTitulo: 'Solicitar vacaciones',
            tramos: 'Fechas',
            desde: 'Desde',
            hasta: 'Hasta',
            anadirTramo: 'Añadir otro periodo',
            quitarTramo: 'Quitar',
            diasQueSeDescuentan: 'Días que se descuentan',
            sinDias: 'Elige unas fechas para ver qué días se descuentan.',
            tramoIncompleto: 'Hay un periodo con una sola fecha. Complétalo o quítalo: solo se envían los periodos con «Desde» y «Hasta».',
            saldoInsuficiente: 'No te llega el saldo para esas fechas: pides {dias} día(s) y te faltan {faltan}.',
            trabajoPlanificado: 'Tienes trabajo planificado esos días',
            trabajoPlanificadoPie: 'Si se aprueba, planificación lo reprogramará.',
            comentarioAprobador: 'Comentario para quien aprueba (opcional)',
            comentarioPlaceholder: 'Lo que quieras contarle a quien tiene que aprobarlo',
            motivoAutoconfirma: 'Motivo (obligatorio)',
            motivoPlaceholder: 'Por qué se confirma sin aprobador superior',
            normas: 'Normas de vacaciones',
            version: 'versión {version}',
            heLeido: 'He leído las normas de vacaciones (versión {version})',
            sinNormas: 'Todavía no hay normas de vacaciones publicadas.',
            cargandoNormas: 'Cargando las normas de vacaciones…',
            errorNormas: 'No se han podido leer las normas de vacaciones. Hay que leerlas y marcarlas antes de enviar.',
            reintentarNormas: 'Volver a intentarlo',
            calculando: 'Calculando los días de estas fechas…',
            disponiblesAhora: 'Disponibles ahora',
            volver: 'Volver',
            enviar: 'Enviar solicitud',
            // Lo que falta para poder enviar, junto al botón (§9). Son frases de lo que hay que
            // HACER: la explicación de cada aviso se queda donde está, en su sitio de la pantalla.
            noSePuedeEnviar: 'Todavía no se puede enviar:',
            faltaElegirFechas: 'elige las fechas que quieres pedir',
            faltaCompletarPeriodo: 'completa o quita el periodo que tiene una sola fecha',
            faltaCorregirFechas: 'corrige las fechas: el aviso en rojo dice qué pasa con ellas',
            faltaEsperarElCalculo: 'espera a que termine el cálculo de esos días',
            faltaEsperarElEnvio: 'espera a que termine el envío que ya está en marcha',
            faltaSaldo: 'no te llega el saldo para esas fechas',
            faltanDiasQueDescontar: 'esas fechas no descuentan ningún día de vacaciones',
            faltaCargarNormas: 'espera a que carguen las normas de vacaciones',
            faltaReintentarNormas: 'vuelve a intentar leer las normas de vacaciones',
            faltaMarcarNormas: 'marca que has leído las normas de vacaciones',
            faltaElMotivo: 'escribe el motivo, que es obligatorio',
            enviada: 'Solicitud {codigo} enviada. Quien la aprueba ya tiene el aviso.',
            errorCalculando: 'No se han podido calcular los días.',
            errorEnviando: 'No se ha podido enviar la solicitud.',

            mes_1: 'ene',
            mes_2: 'feb',
            mes_3: 'mar',
            mes_4: 'abr',
            mes_5: 'may',
            mes_6: 'jun',
            mes_7: 'jul',
            mes_8: 'ago',
            mes_9: 'sep',
            mes_10: 'oct',
            mes_11: 'nov',
            mes_12: 'dic',

            verEnModulo: 'Ver en Vacaciones',
            diaCompleto: 'día completo',
            detalleSolicitud: 'Solicitud',
            detalleSinSolicitud: 'Estas vacaciones no pertenecen a ninguna solicitud del módulo: se cargaron a mano antes de ponerlo en marcha.',
            detalleErrorSolicitud: 'No se ha podido leer a qué solicitud pertenece este día. Vuelve a abrirlo.'
        },
        // #59 · la bandeja del aprobador: las pestañas de aprobación del menú Vacaciones y las
        // acciones de aprobar y denegar, también desde el calendario.
        bandejaVacaciones: {
            titulo: 'Vacaciones · solicitudes de mi equipo',
            subtitulo: 'Personas que te tienen como aprobador: {nombres}',
            subtituloTodos: 'Ves las solicitudes de toda la plantilla.',
            subtituloNadie: 'No apruebas las vacaciones de nadie.',

            pestana_PENDIENTES: 'Pendientes',
            pestana_ANULACIONES: 'Anulaciones',
            pestana_CONFIRMADAS: 'Confirmadas',
            pestana_TODAS: 'Todas',

            persona: 'Persona',
            fechas: 'Fechas',
            dias: 'Días',
            solicitada: 'Solicitada',
            saldo: 'Saldo',
            trabajoPlanificado: 'Trabajo planificado',
            acciones: 'Acciones',
            nTrabajos: '{n} trabajo(s)',
            vencida: 'Vencida',
            comentarioSolicitante: 'Dice quien lo pide',

            aprobar: 'Aprobar',
            denegar: 'Denegar',
            verCalendario: 'Ver calendario',
            confirmaAprobar: '¿Apruebas las vacaciones de {quien} ({fechas})?',
            pideMotivo: 'Escribe por qué se deniegan las vacaciones de {quien} ({fechas}). Es lo que va a leer.',
            motivoObligatorio: 'Hay que escribir un motivo: sin él no se puede denegar.',
            aprobada: 'Vacaciones aprobadas',
            denegada: 'Vacaciones denegadas',
            // #59 · Lo que explica los dos botones apagados mientras la resolución viaja (§9: un
            // control que no se puede usar dice por qué y quién lo desbloquea). Se ve sobre todo al
            // volver a la pestaña con el POST aún en vuelo: el cerrojo es de la solicitud y sigue
            // puesto, así que sin esta frase los botones estarían apagados sin explicación.
            resolviendo: 'Se está resolviendo: esperando al servidor.',

            // #69 · la pestaña «Anulaciones»: la columna de la petición y sus dos acciones.
            peticionAnulacion: 'Petición de anulación',
            anulacionPedida: 'Anulación pedida · {n} día(s)',
            pedidaEl: 'pedida el {fecha}',
            aceptarAnulacion: 'Aceptar anulación',
            rechazarAnulacion: 'Rechazar',
            anularDirectamente: 'Anular',
            confirmaAceptarAnulacion: '¿Aceptas anular {n} día(s) de las vacaciones de {quien} ({dias})? Esos días desaparecen de su calendario y vuelven a su saldo. No se puede deshacer.',
            pideMotivoAnulacion: 'Escribe por qué se rechaza la anulación que ha pedido {quien}. Es lo único que le explica por qué sigue teniendo esos días.',
            anulacionAceptada: 'Anulación aceptada: esos días ya no están en su calendario.',
            anulacionRechazada: 'Anulación rechazada: los días siguen confirmados.',

            cargando: 'Cargando las solicitudes de tu equipo…',
            vacia_PENDIENTES: 'No tienes ninguna solicitud esperando.',
            vacia_ANULACIONES: 'Nadie ha pedido anular unas vacaciones ya aprobadas.',
            vacia_CONFIRMADAS: 'Todavía no has aprobado ninguna solicitud este año.',
            vacia_TODAS: 'No hay ninguna solicitud de tu equipo este año.',

            errorCargando: 'No se han podido cargar las solicitudes de tu equipo.',
            errorResolviendo: 'No se ha podido resolver la solicitud.',

            // Cuando no se ha podido comprobar de quién es el calendario o a quién se aprueba, la
            // pantalla NO decide por su cuenta: lo dice y deja volver a intentarlo.
            reintentar: 'Volver a intentarlo',
            errorNoSeSabeQuien: 'No se ha podido comprobar a quién apruebas. Vuelve a intentarlo.',
            errorAbrirVacaciones: 'No se ha podido comprobar de quién es este calendario, así que no se abre Vacaciones: te llevaría a las solicitudes equivocadas. ¿Volver a intentarlo?',
            errorEquipoDia: 'No se ha podido comprobar si apruebas las vacaciones de esta persona, así que no se enseña su solicitud.',

            // El reintento del campo «Empleado» del calendario: si la consulta del equipo falla no
            // hay opciones que ofrecer, el campo no se enseña y en el calendario propio no queda
            // ninguna otra acción que vuelva a pedirlo.
            reintentarEquipo: 'Cargar mi equipo',
            reintentarEquipoAyuda: 'No se ha podido comprobar a quién apruebas, así que el campo «Empleado» no se puede enseñar. Pulsa para volver a intentarlo.',

            // Las acciones desde el calendario de la persona
            diaPendiente: 'Pendiente de confirmar',
            resolverDesdeCalendario: 'Esta solicitud está esperando tu decisión.',
            afectaALaSolicitudEntera: 'Aprobar o denegar afecta a la solicitud entera ({dias} día(s), {fechas}), no solo a este día.'
        },

        // Registrar vacaciones en nombre de otra persona (#70). Solo lo ven ADMIN y DIRECTOR.
        registrarVacaciones: {
            abrir: 'Registrar en nombre de…',
            // §9, regla 2: el botón no se queda mudo. El resto de las frases se reutilizan del
            // bloque `misVacaciones`, que son las mismas faltas que el formulario de solicitud.
            noSePuedeRegistrar: 'Para registrar falta:',
            faltaEsperarElRegistro: 'Espera: se está registrando.',
            faltaElegirPersona: 'Elige a quién se le registran.',
            titulo: 'Registrar vacaciones en nombre de otra persona',
            explicacion: 'Para vacaciones ya disfrutadas o comunicadas por otra vía (de palabra, por correo, en papel). Se aprueban en el acto, quedan marcadas «registrada por» y es el único sitio donde se admiten fechas pasadas.',
            persona: 'Persona',
            elegirPersona: 'Elige a quién se le registran',
            // Regla permanente de dirección (18/10/2026): todo selector de personas se busca
            // escribiendo. El rótulo dice por qué tres cosas, que son las tres por las que busca.
            buscarPersona: 'Busca escribiendo nombre, apellidos o código',
            sinCoincidencias: 'Nadie de la plantilla coincide con «{texto}».',
            quitarBusqueda: 'Ver la plantilla entera',
            cargandoPlantilla: 'Cargando la plantilla…',
            errorPlantilla: 'No se ha podido cargar la plantilla.',
            reintentar: 'Volver a intentarlo',
            tramos: 'Fechas (pueden ser pasadas)',
            saldoAhora: 'Saldo ahora',
            saldoDespues: 'Saldo después',
            de: 'de',
            // Para enumerar los cuadros de mando de un mes: «octubre de 2026 (OEA y OEB)». El mes
            // no se repite por cada cuadro (dirección, 18/10/2026).
            y: 'y',
            avisoSaldo: 'El saldo de {persona} quedará en {saldo} días. Se puede registrar igual —son días que ya se disfrutaron—, pero hay que confirmarlo.',
            avisoNoCaben: 'A esta persona le faltan {faltan} día(s) de derecho para esas fechas, aunque el saldo de hoy no quede en negativo: los días del año anterior solo valen hasta el 31 de marzo.',
            avisoMesTitulo: 'Hay días en un mes ya cerrado',
            avisoMes: 'Afecta a {meses}. Al guardar se pedirá confirmación.',
            confirmaMes: 'Esto cambia el D.R y el objetivo de {meses}. ¿Continuar?',
            confirmaSaldo: 'El saldo de {persona} quedará en {saldo} días. ¿Continuar?',
            motivo: 'Motivo (obligatorio)',
            motivoPlaceholder: 'Por qué se registran así y no por el camino normal de solicitud',
            pieConfirmada: 'Se guardará ya aprobada, con los días confirmados en el calendario.',
            registrar: 'Registrar vacaciones',
            registrada: 'Vacaciones {codigo} registradas a {persona}. Ya están confirmadas en su calendario.',
            errorRegistrando: 'No se han podido registrar las vacaciones.',

            // Enteros y no los `mes_N` abreviados de «Mis vacaciones»: estos salen en el aviso y
            // en el diálogo de confirmación, que es una frase que se lee, no una etiqueta.
            mesLargo_1: 'enero',
            mesLargo_2: 'febrero',
            mesLargo_3: 'marzo',
            mesLargo_4: 'abril',
            mesLargo_5: 'mayo',
            mesLargo_6: 'junio',
            mesLargo_7: 'julio',
            mesLargo_8: 'agosto',
            mesLargo_9: 'septiembre',
            mesLargo_10: 'octubre',
            mesLargo_11: 'noviembre',
            mesLargo_12: 'diciembre'
        },
        // #268 · el camino manual del calendario: poner una vacación a mano sigue siendo posible,
        // pero avisa ANTES de crearla de que no es la forma de pedirlas y dice dónde está la buena
        // (un aviso que señala el error sin señalar la salida no vale: lo pidió dirección). Y la
        // papelera de un día de vacaciones dice por qué no está cuando no está.
        vacacionAMano: {
            avisoTitulo: 'Así no se piden vacaciones',
            aviso: 'Poner aquí una vacación no es pedirla. El día queda pendiente de confirmar, marcado como puesto a mano, y no descuenta del saldo.',
            dondeOficial: 'Las vacaciones se piden en «Mis vacaciones» → «Solicitar vacaciones»: en el menú Vacaciones o con el botón de la palmera de este calendario.',
            dondeOficialSinAcceso: 'Las vacaciones se piden en «Mis vacaciones» → «Solicitar vacaciones», en el menú Vacaciones. Si no lo tienes en tu menú, pídele acceso a RRHH.',
            enNombreDeOtro: 'Para ponérselas a otra persona: «Mis vacaciones» → «Registrar en nombre de…».',
            irAMisVacaciones: 'Ir a Mis vacaciones',
            ponerlaIgualmente: 'Ponerla a mano igualmente',
            cancelar: 'Cancelar',
            detalle: 'Puesta a mano desde el calendario: está pendiente de confirmar y no descuenta del saldo. Para que cuente, hay que pedirla en «Mis vacaciones».',
            etiqueta: 'a mano',
            leyenda: 'Vacaciones puestas a mano (pendientes de confirmar, no descuentan saldo)',
            papeleraError: 'No se ha podido comprobar si este día se puede quitar desde aquí. Vuelve a abrirlo.',
            comprobacionError: 'No se ha guardado nada: no se ha podido comprobar si la tarea escrita en «Tarea» es de vacaciones. Vuelve a pulsar Guardar; si sigue fallando, revisa la conexión o avisa a informática.',
            // Lo que se dice si se acepta el aviso con «Crear planificación» ya cerrado: cerrarlo es
            // cancelar el alta (revisión CODEX del PR #1842).
            formularioCerrado: 'No se ha guardado nada: «Crear planificación» se ha cerrado antes de terminar. Vuelve a abrirlo pulsando en el calendario si quieres crearla.'
        },
        // #271 · el interruptor del camino manual: lo que dice el calendario cuando Dirección lo ha
        // cerrado, y la tarjeta de Ajustes · Normas de vacaciones desde la que se acciona.
        caminoManual: {
            cerrado: 'Las vacaciones ya no se ponen a mano desde el calendario: Dirección ha cerrado ese camino.',
            reabrir: 'Si hace falta volver a abrirlo, lo hace Dirección en Ajustes · Normas de vacaciones.',
            titulo: 'Camino manual de vacaciones',
            explicacion: 'Decide si se pueden seguir poniendo vacaciones a mano desde el calendario, fuera de «Mis vacaciones». Se acciona aquí, sin fecha y sin despliegue, y se puede volver atrás en cualquier momento. Cada cambio queda apuntado con quién lo hizo y cuándo.',
            cargando: 'Comprobando la posición…',
            errorCarga: 'No se ha podido comprobar la posición del camino manual.',
            reintentar: 'Reintentar',
            permitido: 'Permitido',
            apagado: 'Apagado',
            explicacionPermitido: 'Cualquiera que hoy pone vacaciones a mano desde el calendario puede seguir haciéndolo, con el aviso de que ese no es el camino oficial. Quedan pendientes de confirmar y no descuentan saldo.',
            explicacionApagado: 'Nadie —tampoco RRHH ni ADMIN— puede poner vacaciones a mano desde el calendario: se piden en «Mis vacaciones». Las que ya estaban puestas a mano se siguen viendo y se pueden quitar con la papelera.',
            apagar: 'Apagar el camino manual',
            permitir: 'Volver a permitirlo',
            confirmarApagarTitulo: '¿Apagar el camino manual?',
            confirmarApagar: 'Desde ahora nadie podrá poner vacaciones a mano desde el calendario. Las que ya estén puestas a mano se quedan como están y se pueden seguir quitando. Se puede volver a permitir desde aquí en cualquier momento.',
            confirmarPermitirTitulo: '¿Volver a permitir el camino manual?',
            confirmarPermitir: 'Se podrán volver a poner vacaciones a mano desde el calendario, con el aviso de que no es el camino oficial.',
            confirmar: 'Sí, cambiarlo',
            cancelar: 'Cancelar',
            errorAccionar: 'No se ha cambiado: {motivo}',
            enVuelo: 'Se está cambiando: esperando al servidor. El botón vuelve en cuanto conteste.',
            historial: 'Cambios',
            sinCambios: 'Nadie lo ha accionado todavía: está en «Permitido», que es como nace.',
            cambioApagado: 'lo apagó',
            cambioPermitido: 'lo volvió a permitir',
            noCoincide: 'Ojo: la posición que aplica ahora el servidor no es la que dejó el último cambio de esta lista. O se ha cambiado por otra vía —Ajustes · Properties o la configuración del servidor— que no deja apunte de quién ni cuándo, o el servidor no está pudiendo leer la posición guardada. Si no lo esperabas, avisa a informática.'
        },
        // #69 · anular unas vacaciones YA APROBADAS: la ventana «Pedir anulación» del solicitante,
        // la de «Anular» del aprobador, y lo que se enseña de una petición en «Mis vacaciones».
        //
        // Bloque propio y no dentro de `misVacaciones` porque lo comparten las dos ventanas y las
        // dos pantallas, y porque es un flujo con nombre: en la incidencia, en los avisos y en el
        // rastro se llama igual.
        anularVacaciones: {
            pedirTitulo: 'Pedir anulación · {quien}',
            anularTitulo: 'Anular vacaciones · {quien}',
            soloFuturos: 'Solo se pueden anular días que aún no han pasado.',
            diasAAnular: 'Días a anular',
            yaPasado: 'ya ha pasado',
            sinDias: 'Esta solicitud no tiene días que anular.',
            eligeAlgunDia: 'Hay que marcar al menos un día.',
            motivoObligatorio: 'Motivo (obligatorio)',
            motivoPlaceholder: 'p. ej. Cambio de fechas por motivos familiares',
            siguenConfirmados: 'Tus días siguen confirmados (azul) hasta que {quien} acepte la anulación.',
            quienApruebe: 'quien aprueba tus vacaciones',
            volver: 'Volver',
            enviarPeticion: 'Enviar petición',
            pedirAnulacion: 'Pedir anulación',
            peticionEnviada: 'Petición enviada. Tus días siguen confirmados hasta que la acepten.',
            errorPidiendo: 'No se ha podido enviar la petición de anulación.',

            // La ventana del aprobador: anular sin que nadie lo haya pedido.
            avisoDirecta: 'Esto quita días del calendario de {quien} sin que los haya pedido. Recibirá un aviso con el tipo y el motivo.',
            tipoObligatorio: 'Tipo de anulación (obligatorio)',
            eligeTipo: 'Elige el tipo…',
            notaIncapacidad: 'Los días vuelven a su saldo con plazo de 18 meses desde el final del año (art. 38.3 del Estatuto): no caducan el 31 de marzo como el resto.',
            cargandoTipos: 'Leyendo los tipos de anulación…',
            errorTipos: 'No se han podido leer los tipos de anulación. Sin tipo no se puede anular.',
            reintentarTipos: 'Volver a intentarlo',
            motivoDirectaPlaceholder: 'Por qué se anulan estos días',
            sinDiagnostico: 'No escribas aquí ningún diagnóstico ni dato médico: no se pide y no se guarda. Con «incapacidad temporal» basta el tipo.',
            cerraraLaPeticion: 'Esta persona ya había pedido anular días de esta solicitud. Al anular, su petición se cierra y recibirá el aviso.',
            anular: 'Anular días',
            confirmaAnular: '¿Anular {n} día(s) de las vacaciones de {quien} ({codigo})? Esos días desaparecen de su calendario. No se puede deshacer.',
            anuladas: '{n} día(s) anulados. {quien} ya tiene el aviso.',
            errorAnulando: 'No se han podido anular los días.',

            // Lo que se enseña de una petición en «Mis vacaciones», según cómo haya acabado.
            peticionPendiente: 'Has pedido anular {n} día(s): esperando respuesta. Siguen confirmados.',
            peticionAceptada: 'Anulación aceptada: {n} día(s) se quitaron de tu calendario.',
            peticionRechazada: 'Anulación rechazada: «{motivo}». Los días siguen confirmados.',
            peticionCaducada: 'Tu petición de anulación caducó sin respuesta: esos días ya han pasado y el calendario no ha cambiado.',
            peticionPorAnulacionDirecta: 'Tu petición quedó cerrada porque esos días se anularon directamente.',

            // El enlace de «cambiar fechas»: anular + volver a pedir (punto 5).
            sustituyeA: 'Sustituye a {codigo}',
            sustituidaPor: 'Sustituida por {codigo}',

            // Los días que volvieron por una incapacidad temporal, con su plazo propio.
            // «De los disponibles» no es adorno: estos días SON parte del número grande de la
            // tarjeta, y la frase suelta que pidió dirección se leía como un sumando aparte.
            diasPorIncapacidad: 'De los días disponibles, {dias} son por incapacidad temporal y valen hasta {hasta} (art. 38.3 del Estatuto)',
            // Y cuando vienen de años distintos no caducan a la vez: una línea por vencimiento,
            // porque una sola fecha para el total diría que todos valen hasta la más lejana.
            diasPorIncapacidadVarias: 'De los días disponibles, {dias} son por incapacidad temporal (art. 38.3 del Estatuto) y no caducan todos el mismo día:',
            diasPorIncapacidadBolsa: '· {dias} día(s), hasta {hasta}',

            // Lo que le falta al botón para poder pulsarse, dicho AL LADO del botón. Regla de
            // dirección del 05/10/2026 (§9 del CLAUDE.md del orquestador): un control que no se
            // puede usar dice por qué, quién lo desbloquea y dónde. Aquí lo desbloquea quien está
            // delante y se desbloquea en esta misma ventana, y eso es lo que dice «lo rellenas tú».
            faltaPara: 'Falta {que}. Lo rellenas tú, en esta ventana.',
            faltaDias: 'marcar al menos un día',
            faltaTipo: 'elegir el tipo de anulación',
            faltaMotivo: 'escribir el motivo',
            faltaTipos: 'que se puedan leer los tipos de anulación',
            faltaPorFallo: 'Falta {que}. La lista de tipos se reintenta con «Volver a intentarlo», ahí arriba; lo demás lo rellenas tú.',
            // El separador de la enumeración, aparte para no cablear la coma en el código.
            faltaY: ' y ',
            // Y por qué está apagado mientras la petición viaja: lo desbloquea el servidor al
            // contestar, y no hay nada que rellenar. Misma regla del 05/10/2026, otro motivo.
            enVuelo: 'Se está enviando. El botón vuelve en cuanto conteste el servidor.'
        },
        puestostrabajo: {
            titulo: 'Ajustes · Puestos de trabajo',
            recargar: 'Recargar',
            nuevo: 'Nuevo puesto',
            guardar: 'Guardar puesto',
            guardado: 'Puesto guardado',
            cancelar: 'Cancelar',
            editar: 'Editar',
            desactivar: 'Desactivar',
            reactivar: 'Reactivar',
            codigo: 'Código del puesto',
            abreviatura: 'Abreviatura',
            nombre: 'Nombre del puesto de trabajo',
            funciones: 'Funciones',
            personas: 'Personas',
            estado: 'Estado',
            acciones: 'Acciones',
            activo: 'Activo',
            inactivo: 'Inactivo',
            noAutorizado: 'No está autorizado para ver los puestos de trabajo (solo ADMIN y DIRECTOR)',
            sinResultados: 'Todavía no hay ningún puesto de trabajo',
            faltanDatos: 'Escriba el código, la abreviatura y el nombre del puesto',
            sinAbreviatura: 'sin asignar',
            pieAbreviatura: 'La abreviatura es lo que llevan dentro los códigos de las funciones del puesto: con DIR, sus funciones son F-DIR-01, F-DIR-02… No se puede repetir entre puestos. Cambiarla no renumera las funciones que ya cuelgan del puesto: las que existen conservan su código.',
            confirmaDesactivar: 'El puesto dejará de aparecer en los desplegables, pero se conserva con sus funciones y su histórico. ¿Desactivarlo?',
            pie: 'Un puesto con funciones o personas no se borra: se desactiva y se conserva en los históricos.',
            pieEjemplos: 'Por ejemplo: código «P10», nombre «Técnico/a de Calidad». El código se guarda en mayúsculas y no se puede repetir, tampoco con los puestos desactivados.',
            pieCodigoFijo: 'El código no se cambia una vez creado el puesto: queda escrito en los históricos. Si está mal, dé de alta el puesto correcto y desactive este.',
            errorCargando: 'No se han podido cargar los puestos de trabajo',
            errorGuardando: 'No se ha podido guardar el puesto',
            errorEstado: 'No se ha podido cambiar el estado del puesto'
        },
        funciones: {
            titulo: 'Ajustes · Funciones',
            recargar: 'Recargar',
            nueva: 'Nueva función',
            guardar: 'Guardar función',
            guardada: 'Función guardada',
            cancelar: 'Cancelar',
            editar: 'Editar',
            desactivar: 'Desactivar',
            reactivar: 'Reactivar',
            codigo: 'Código de la función',
            codigoInterno: 'Código interno',
            nombre: 'Nombre de la función',
            puesto: 'Puesto de la función',
            eligePuesto: 'Elija un puesto…',
            sinPuesto: 'Sin puesto',
            personasVigentes: 'Personas vigentes',
            estado: 'Estado',
            acciones: 'Acciones',
            activa: 'Activa',
            inactiva: 'Inactiva',
            noAutorizado: 'No está autorizado para ver las funciones (solo ADMIN y DIRECTOR)',
            sinResultados: 'Todavía no hay ninguna función',
            faltanDatos: 'Escriba el nombre y elija el puesto de la función',
            pieCodigoInterno: 'El código interno (FN-0001) lo pone la aplicación y no se puede cambiar: es con el que se enlazan las personas, el histórico y las reglas de coincidencia, así que cambiar el código de la función no rompe nada.',
            pieCodigoEditable: 'El código de la función se puede cambiar para reordenar el catálogo. No se puede repetir, tampoco con las desactivadas. Para intercambiar dos códigos hay que cambiarlos a la vez: eso lo hará el asesor IA (#484).',
            sinAbreviatura: 'Este puesto no tiene abreviatura, así que la aplicación no puede proponer el código. La asigna RRHH en Ajustes · Puestos de trabajo, editando el puesto.',
            errorSiguienteCodigo: 'No se ha podido proponer el código de la función',
            sinPuestos: 'No hay ningún puesto de trabajo activo: cree uno antes en Ajustes · Puestos de trabajo.',
            confirmaDesactivar: 'La función dejará de ofrecerse, pero se conserva con su histórico. ¿Desactivarla?',
            pie: 'Una función en uso no se borra: se desactiva y se conserva en los históricos.',
            pieEjemplos: 'Por ejemplo: código «F-CAL-02», nombre «Auditoría interna 17020». El código se guarda en mayúsculas y no se puede repetir, tampoco con las funciones desactivadas.',
            pieCodigoFijo: 'El código no se cambia una vez creada la función: lo guardan las reglas de coincidencia que la nombran. Si está mal, dé de alta la función correcta y desactive esta.',
            errorCargando: 'No se han podido cargar las funciones',
            errorGuardando: 'No se ha podido guardar la función',
            errorEstado: 'No se ha podido cambiar el estado de la función',
            avisos: {
                PUESTO_INACTIVO: 'Puesto desactivado'
            }
        },
        reglascoincidencia: {
            titulo: 'Reglas de coincidencia',
            nueva: 'Nueva regla',
            editar: 'Editar',
            editarPropuesta: 'Editar la propuesta de la IA',
            pedirIa: 'IA · Pedir nuevas propuestas',
            pieIa: 'El asistente IA propone reglas a partir de puestos, funciones vigentes y cualificaciones ENAC por materia. Solo se aplican las que RRHH acepta.',
            resultadoIa: 'Última tanda de propuestas',
            resultadoIaCuenta: '{nuevas} propuestas nuevas · {fuera} no reconocidas',
            modeloIa: 'modelo: {modelo}',
            seguirPidiendo: '¿Pedir más propuestas de todos modos?',
            iaApagada: 'El asistente de IA está apagado en este entorno.',
            propuestaSustituida: 'Regla creada. La propuesta queda descartada y marcada como sustituida.',
            sustituidaPor: 'sustituida por «{titulo}»',
            pieSustituir: 'Al guardar se crea una regla nueva, manual y ya aceptada. La propuesta de la IA no se modifica: queda descartada y marcada como sustituida por esta, para que se pueda ver qué propuso.',
            errorIa: 'No se han podido pedir propuestas a la IA',
            recargar: 'Recargar',
            cancelar: 'Cancelar',
            guardar: 'Guardar regla',
            guardada: 'Regla guardada',
            noAutorizado: 'No está autorizado para ver las reglas de coincidencia (solo ADMIN y DIRECTOR)',
            total: 'Total',
            tituloRegla: 'Título',
            tipoMiembros: 'Quiénes son',
            personas: 'Personas',
            materia: 'Materia ENAC',
            funciones: 'Funciones (separadas por comas)',
            minimoPresentes: 'Mínimo presentes',
            severidad: 'Severidad',
            estado: 'Estado',
            miembros: 'Miembros',
            explicacion: 'Por qué existe esta regla',
            motivo: 'Motivo del cambio',
            acciones: 'Acciones',
            aceptar: 'Aceptar',
            descartar: 'Descartar',
            reactivar: 'Reactivar',
            historico: 'Histórico',
            sinHistorico: 'Sin movimientos',
            sinResultados: 'Todavía no hay ninguna regla de coincidencia',
            // Con reglas en el catálogo pero ninguna del estado filtrado. Dice cuántas hay para
            // que no parezca que la pantalla las ha perdido: los contadores de arriba siguen
            // enseñando el catálogo entero.
            sinResultadosFiltro: 'Ninguna de las {total} reglas está en «{estado}».',
            verTodas: 'Ver todas',
            pideMotivo: 'Escriba el motivo del cambio. Queda registrado y no se puede borrar.',
            motivoObligatorio: 'Descartar o reactivar una regla exige un motivo',
            pieAlta: 'Una regla creada aquí nace aceptada y empieza a evaluarse al momento. Los miembros se recalculan en cada evaluación: quien deja la plantilla, o pierde la cualificación, sale solo de la regla.',
            avisoFunciones: 'Los miembros de una regla por funciones son quienes desempeñan esas funciones ahora mismo, según la tarjeta «Puesto y funciones» de su ficha. Si la regla sale sin miembros, es que no hay nadie con esas funciones asignadas.',
            comprobar: 'Comprobar fechas',
            comprobarBoton: 'Comprobar',
            persona: 'Persona',
            desde: 'Desde',
            hasta: 'Hasta',
            pieComprobar: 'Comprueba qué semáforo vería esa persona si pidiera esas fechas. No solicita ni aprueba nada: solo informa. Al pulsar una fecha alternativa se comprueba ese otro tramo.',
            motivoCopiado: 'Motivo copiado al portapapeles. Aquí no se aprueba nada: se usa al aprobar o denegar la solicitud.',
            motivoRedactado: 'Borrador de motivo',
            faltanDatosPrueba: 'Elija persona y las dos fechas',
            errorCargando: 'No se han podido cargar las reglas de coincidencia',
            errorGuardando: 'No se ha podido guardar la regla',
            errorEstado: 'No se ha podido cambiar el estado de la regla',
            errorEvaluando: 'No se ha podido comprobar esas fechas',
            tipos: {
                PERSONAS: 'Personas elegidas a mano',
                FUNCIONES: 'Por función',
                MATERIA_ENAC: 'Por materia ENAC en vigor'
            },
            estados: {
                ACEPTADA: 'Aceptada',
                PROPUESTA: 'Propuesta',
                DESCARTADA: 'Descartada'
            },
            origenes: {
                MANUAL: 'Alta manual',
                IA: 'Propuesta por la IA'
            },
            avisos: {
                SIN_MIEMBROS: 'Sin miembros',
                MINIMO_INALCANZABLE: 'Mínimo inalcanzable',
                FUNCIONES_PENDIENTES_51: 'Funciones pendientes',
                // Lo que la API no pudo terminar DESPUÉS de dejar el cambio escrito. No se
                // pintan en la tabla —no vienen del catálogo, sino de la respuesta a guardar o
                // a cambiar de estado—: salen en un aviso al terminar.
                ALTA_SIN_RASTRO: 'La regla está creada, pero no se ha podido dejar constancia en el registro de auditoría. Avisa a sistemas: el cambio sí consta en el histórico de la regla.',
                CAMBIO_SIN_RASTRO: 'El cambio está aplicado, pero no se ha podido dejar constancia en el registro de auditoría. Avisa a sistemas: el cambio sí consta en el histórico de la regla.',
                REGLA_SIN_FICHA: 'El cambio está aplicado, pero no se han podido cargar los miembros para mostrarlos. Recarga la pantalla para verla completa.',
                FUNCIONES_SIN_TRADUCIR: 'El cambio está aplicado, pero no se ha podido leer el catálogo de funciones: las funciones de esta regla se están enseñando por su código interno (FN-…), no por el que se ve en Ajustes · Funciones. Recarga la pantalla para verlas con el suyo.'
            },
            // Lo que no salió entero en una tanda de «Pedir propuestas a la IA» (#65). Van como
            // etiqueta encima del resultado: el titular. El `mensaje` que manda la API queda
            // debajo con el detalle —el error del servicio, los títulos afectados—, y por eso
            // estos textos resumen en vez de repetirlo. Namespace aparte del de las reglas:
            // `FUNCIONES_PENDIENTES_51` sale en los dos sitios y no dice lo mismo.
            avisosTanda: {
                IA_NO_DISPONIBLE: 'El asistente no ha respondido',
                RESPUESTA_NO_ENTENDIDA: 'La respuesta no se ha podido leer',
                SIN_PROPUESTAS: 'Ninguna propuesta nueva',
                // Este llega SIN mensaje y en todas las tandas hasta que entre la #51, así que
                // la etiqueta tiene que explicarse sola.
                FUNCIONES_PENDIENTES_51: 'Las reglas por función todavía no se pueden proponer: falta el catálogo de funciones',
                PROPUESTA_SIN_FICHA: 'Alguna propuesta se guardó sin completar su ficha',
                PROPUESTA_NO_GUARDADA: 'Alguna propuesta no se ha podido guardar',
                TANDA_SIN_RASTRO: 'Sin apunte en el registro de auditoría'
            },
            incidenciaEscritura: 'Hecho, pero con incidencias',
            acciones_audit: {
                ALTA_REGLA_COINCIDENCIA: 'Alta',
                EDICION_REGLA_COINCIDENCIA: 'Edición',
                ACEPTACION_REGLA_COINCIDENCIA: 'Aceptada',
                DESCARTE_REGLA_COINCIDENCIA: 'Descartada',
                REACTIVACION_REGLA_COINCIDENCIA: 'Reactivada',
                SUSTITUCION_PROPUESTA_IA: 'Sustituida al editarla'
            },
            // Por qué no se ha guardado una propuesta de la IA: «no reconocido» (#65).
            descartes: {
                TITULO_VACIO: 'Sin título',
                TIPO_DESCONOCIDO: 'No se entiende de quién habla',
                SEVERIDAD_DESCONOCIDA: 'Severidad desconocida',
                MINIMO_INVALIDO: 'Mínimo no válido',
                MINIMO_IMPOSIBLE: 'Mínimo imposible',
                PERSONAS_INEXISTENTES: 'Personas que no existen',
                FUNCIONES_INEXISTENTES: 'Funciones que no existen',
                FUNCIONES_PENDIENTES_51: 'Funciones pendientes',
                MATERIA_INEXISTENTE: 'Materia que no existe',
                SIN_MIEMBROS: 'No incluye a nadie',
                DUPLICADA: 'Ya existe esa regla',
                // Esta no es «no reconocida»: la propuesta estaba bien y lo que falló fue
                // guardarla. Sale en la misma lista porque es donde se dice, propuesta a
                // propuesta, qué no llegó al catálogo y por qué.
                NO_GUARDADA: 'No se ha podido guardar'
            }
        },
        explicacionia: {
            explicarAprobar: 'IA · Explicar y redactar motivo',
            explicarDenegar: 'IA · Borrador para denegar',
            borradorAprobar: 'Borrador de la justificación (editable)',
            borradorDenegar: 'Borrador del motivo de denegación (editable)',
            usarMotivo: 'Usar este motivo',
            motivoVacio: 'El motivo no puede quedar vacío',
            faltanDatos: 'Primero hay que comprobar unas fechas',
            // La fuente se dice por pieza: el sistema escribe el color, los días y las cifras, y el
            // asistente solo la prosa. Un único «Redactado por la IA» le atribuía las dos cosas.
            prosaDelAsistente: 'Párrafo redactado por el asistente de IA a partir de los datos de arriba · modelo: {modelo}',
            borradorConProsaIa: 'Borrador del sistema con la parte en prosa redactada por el asistente de IA · modelo: {modelo}',
            borradorPlantilla: 'Borrador del sistema: el asistente de IA no ha aportado texto',
            error: 'No se ha podido pedir la explicación',
            avisos: {
                IA_NO_DISPONIBLE: 'El asistente de IA no ha respondido. El semáforo y la aprobación funcionan igual; este texto es el del sistema.',
                RESPUESTA_NO_ENTENDIDA: 'La respuesta del asistente no se ha podido leer; se enseña solo el texto del sistema.',
                // Estos dos los manda la API y no tenían texto: se pintaban con el código crudo
                // («explicacionia.avisos.TRAMO_DE_LA_SOLICITUD») debajo de la explicación.
                TRAMO_DE_LA_SOLICITUD: 'Se explican las fechas que tiene guardadas la solicitud, que no son las que se han pedido.',
                EXPLICACION_SIN_RASTRO: 'El texto es válido, pero no se ha podido dejar constancia de la consulta en el registro de auditoría. Avisa a sistemas.'
            }
        },
        coincidencias: {
            diasLaborables: '{n} días laborables',
            sinConflictos: 'Sin conflictos con ninguna regla.',
            minimoDe: 'mínimo {n} presentes',
            exigeJustificacion: 'Aprobar estas fechas exige una justificación escrita, que queda registrada.',
            alternativasTitulo: 'Fechas alternativas sin conflicto',
            alternativaDetalle: '({dias} días laborables · a {distancia} días de las pedidas)',
            confirmadasDe: 'ya confirmado: {quienes}',
            pendientesDe: 'pendiente de aprobar: {quienes}',
            confirmadasAnonimas: 'otra persona de tu mismo grupo ya lo tiene confirmado | {n} personas de tu mismo grupo ya lo tienen confirmado',
            pendientesAnonimas: 'otra persona de tu mismo grupo lo tiene pendiente | {n} personas de tu mismo grupo lo tienen pendiente',
            semaforo: {
                VERDE: 'Sin conflictos',
                AMBAR: 'Puede haber conflicto',
                ROJO: 'Conflicto: se baja del mínimo'
            },
            severidades: {
                BLOQUEANTE: 'Bloqueante',
                AVISO: 'Aviso'
            }
        },
        restricciones: {
            titulo: 'Restricciones de planificación',
            configurados: 'Configurados',
            aMedias: 'A medias',
            sinConfigurar: 'Sin configurar',
            total: 'Total',
            // #376 · Desglose por campo duro. «A medias» tapaba en una palabra «no tiene base» y
            // «no tiene zona», que se arreglan de forma distinta, y el radio no salía en ningún sitio.
            camposDuros: 'Campos duros',
            completas: 'Completas',
            // #774 · «en la ficha»: ahora la pantalla enseña también la base resuelta, y un «Sin
            // base» a secas aquí diría lo contrario que «Base: CP exacto» en la misma fila.
            sinBase: 'Sin base en la ficha',
            sinRadio: 'Sin radio',
            sinZona: 'Sin zona',
            // Dos cosas que, sin decirlas, hacen que esta fila parezca contradecir la de arriba:
            // «Completas» cuenta el radio y el estado no, y las carencias no son excluyentes.
            notaCamposDuros: '«Completas» son las fichas que tienen base, radio y zona. El radio no '
                + 'cuenta para el estado de arriba, así que una ficha puede estar «Configurada» y '
                + 'aparecer aquí en «Sin radio»; y a la que le falten dos cosas se la cuenta en las dos.',
            falta: 'Falta en la ficha',
            campoDuro: {
                BASE: 'base',
                RADIO: 'radio',
                ZONA: 'zona'
            },
            inspectores: 'Inspectores',
            buscarInspector: 'Buscar inspector…',
            seleccioneInspector: 'Seleccione un inspector para ver o editar su ficha',
            noAutorizado: 'No está autorizado para acceder a las restricciones de planificación',
            duras: 'Restricciones duras',
            blandas: 'Preferencias',
            jornada: 'Jornada',
            notas: 'Notas',
            acuerdo: 'Acuerdo firmado',
            baseGeo: 'Base de salida',
            lat: 'Latitud',
            lon: 'Longitud',
            direccion: 'Dirección',
            pernoctaPermitida: 'Permite pernocta',
            maxNochesSeguidas: 'Máx. noches seguidas',
            diasSinPernocta: 'Días sin pernocta',
            zonasProvincias: 'Provincias que cubre',
            radioMaxKm: 'Radio máximo (km)',
            // #689 · Guardián del radio. Las tres cosas de §9 junto al campo: por qué avisa, quién
            // fija el valor bueno y dónde queda escrito. Y que se ha guardado: avisa, no decide.
            avisoRadio: {
                titulo: 'Guardado con {valor} km: supera el umbral de {umbral} km',
                porque: 'Con este radio la zona no se acota: la distancia habitual de la base a una '
                    + 'línea en España queda muy por debajo, así que es un valor sin calibrar.',
                quienYDonde: 'El radio de cada inspector lo fija Dirección y queda escrito en su '
                    + 'decisión por inspector (incidencia #684). La ficha se ha guardado igual.'
            },
            provinciasVetadas: 'Provincias vetadas',
            diaPreferidoInformes: 'Día preferido de informes',
            zonaPreferente: 'Zona preferente',
            topeHorasDiaOverride: 'Tope horas/día (override)',
            acuerdoFecha: 'Fecha del acuerdo',
            acuerdoDocumento: 'Referencia del documento',
            guardar: 'Guardar',
            fichaGuardada: 'Ficha guardada',
            // #774 · Base resuelta: de dónde sale la base de cada inspector. Una base aproximada
            // tiene que decir que lo es: la mediana de 513 km de SGG era una cifra creíble y falsa.
            baseResuelta: {
                titulo: 'Base resuelta',
                origen: {
                    FICHA_RESTRICCIONES: 'Ficha de restricciones',
                    CP_EXACTO: 'CP exacto',
                    CP_3_DIGITOS: 'CP 3 dígitos',
                    POBLACION: 'Población',
                    OFICINA_APROXIMADA: 'Oficina (aproximada)',
                    SIN_BASE: 'Sin base'
                },
                // Lo corto, para la lista de inspectores.
                corto: {
                    FICHA_RESTRICCIONES: 'Ficha',
                    CP_EXACTO: 'CP exacto',
                    CP_3_DIGITOS: 'CP 3 díg.',
                    POBLACION: 'Población',
                    OFICINA_APROXIMADA: 'Oficina ≈',
                    SIN_BASE: 'Sin base'
                },
                sinCalcular: 'Sin calcular',
                desactualizada: 'Desactualizada',
                recalcular: 'Recalcular bases',
                recalculadas: 'Bases recalculadas',
                fallidas: 'no se han podido recalcular',
                nota: 'La base resuelta es el punto de salida que el sistema ha podido situar para cada '
                    + 'inspector: la de esta ficha si la tiene y, si no, la «Dirección inicio jornada» de su '
                    + 'ficha de Empleados, situada por su código postal o su población. «CP 3 dígitos», '
                    + '«Población» y «Oficina» son aproximadas. «Falta en la ficha: base» solo dice que nadie '
                    + 'ha escrito la base a mano aquí. El planificador todavía no usa esta base.',
                notaSinCalcular: '«Sin calcular»: todavía no se ha calculado nunca. Se calcula sola al guardar '
                    + 'la ficha de Empleados o esta ficha, o para todos con «Recalcular bases».',
                notaSinCalcularSinPermiso: '«Sin calcular»: todavía no se ha calculado nunca. Se calcula sola '
                    + 'al guardar la ficha de Empleados o esta ficha; para calcular la de todos de una vez hace '
                    + 'falta permiso de escritura en Restricciones (ADMIN o DIRECTOR).',
                referencia: {
                    CP_EXACTO: 'CP {ref}',
                    CP_3_DIGITOS: 'CP {ref}xx, media de {n} códigos postales',
                    POBLACION: '{ref}, media de {n} códigos postales',
                    OFICINA_APROXIMADA: 'oficina de {ref}'
                },
                desde: 'a partir de',
                calculada: 'calculada el',
                motivo: {
                    SIN_DIRECCION: 'No tiene base en esta ficha ni «Dirección inicio jornada» en su ficha de Empleados.',
                    NO_RESUELVE: 'Su «Dirección inicio jornada» no trae ni un código postal ni una población que el sistema sepa situar.',
                    POBLACION_AMBIGUA: 'La población de su «Dirección inicio jornada» existe en varias provincias y no dice en cuál.'
                },
                comoArreglar: 'Se corrige en Empleados, en la ficha de la persona: añadir a la «Dirección inicio '
                    + 'jornada» el código postal y el municipio. O escribiendo aquí arriba la base de salida.',
                textoDesactualizada: 'Su ficha ha cambiado desde que se calculó: esta base ya no corresponde. '
                    + 'Se pone al día al guardar su ficha de Empleados o esta ficha, o con «Recalcular bases».'
            },
            dias: {
                LUN: 'Lunes',
                MAR: 'Martes',
                MIE: 'Miércoles',
                JUE: 'Jueves',
                VIE: 'Viernes',
                SAB: 'Sábado',
                DOM: 'Domingo'
            }
        },
        novedades: {
            titulo: 'Novedades',
            // Mismo criterio que en `historialCambiado`: lo que se afirma aquí tiene que valer para
            // TODO lo que se puede ver debajo. «Solo aparecen las versiones que ya están en
            // producción» no valía: una versión retirada sigue en el historial con su sello
            // «Retirada», y entonces la explicación de arriba contradecía el sello de abajo.
            explicacion: 'Qué mejoras y correcciones se han publicado, de la más reciente a la más '
                + 'antigua. Solo aparecen entregas que llegaron a producción; si alguna se retiró '
                + 'después, se queda aquí marcada como retirada.',
            cargando: 'Cargando novedades…',
            // Sin número de error ni nombre de servidor: esto lo lee cualquiera. Lo que necesita
            // saber quien lo ve es que no es cosa suya y que puede volver a intentarlo.
            errorCarga: 'No se han podido cargar las novedades. Puede volver a intentarlo.',
            errorMas: 'No se han podido cargar más novedades. Lo que ya se ve sigue siendo correcto.',
            // El historial ha cambiado mientras se miraba. No es un fallo, y por eso no se ofrece
            // reintentar nada: se explica por qué la lista no es la de antes de pulsar y que se
            // puede seguir pulsando.
            //
            // La causa se dice por lo que PASA EN LA LISTA y no enumerando operaciones. El historial
            // admite TRES —publicar, retirar y restaurar una retirada— y nombrar dos afirma una
            // causa falsa en la tercera: al restaurar una versión retirada el aviso saltaba igual
            // diciendo que se había publicado o retirado algo, y no era verdad. «Hay una versión más»
            // cubre la publicación y «alguna ha cambiado de estado» cubre las otras dos, así que no
            // hay forma de que el texto mienta por mucho que crezcan las operaciones.
            historialCambiado: 'El historial ha cambiado mientras lo consultaba —hay alguna versión '
                + 'más, o alguna de las que ya estaban ha cambiado de estado—, así que la lista se '
                + 'ha cargado otra vez desde el principio para no repetir ni omitir ninguna y para '
                + 'que «En producción» quede en la versión que lo está. Puede volver a pulsar «Ver '
                + 'novedades anteriores».',
            reintentar: 'Volver a intentarlo',
            // Primera instalación. No es un fallo, y decirlo evita que quien entre crea que la
            // pantalla está rota.
            sinNovedades: 'Todavía no se ha publicado ninguna novedad.',
            verMas: 'Ver novedades anteriores',
            mejoras: 'Mejoras',
            correcciones: 'Correcciones',
            // Lo que un lector de pantalla lee delante del número de la tarea de origen. No se ve en
            // pantalla —ahí la cápsula gris junto al texto ya se entiende—, pero «#58» a secas no
            // dice nada dicho en voz alta: el lector lee la almohadilla como un signo o se la salta.
            // Sin dos puntos ni mayúsculas: se lee seguido del número, «Tarea 58».
            tareaOrigen: 'Tarea',
            // Lo que separa una referencia de lo que va delante —del texto de la nota o de la
            // referencia anterior— SOLO para el lector de pantalla: en pantalla esa separación la
            // da el margen de la cápsula, que quien escucha no ve. Lleva coma y no un espacio a
            // secas porque un espacio en el borde de un elemento se puede perder al colapsar los
            // blancos, y entonces se oiría «Tarea 58Tarea 253».
            separadorTarea: ', ',
            vigente: 'En producción',
            retirada: 'Retirada',
            motivoRetirada: 'Motivo de la retirada'
        },
        normasvacaciones: {
            titulo: 'Ajustes · Normas de vacaciones',
            noAutorizado: 'No está autorizado para gestionar las normas de vacaciones',
            explicacion: 'Las ve cada persona al solicitar, y marca que las ha leído (queda '
                + 'registrada la versión). Solo pueden editarlas los roles ADMINISTRADOR y '
                + 'DIRECTOR. Contenido según el convenio.',
            version: 'Versión',
            sinVersion: 'Todavía no hay ninguna versión publicada',
            infoAria: 'Qué conviene saber de esta pantalla',
            infoTitulo: 'Sobre las normas de vacaciones',
            infoVersionesTitulo: 'Las versiones no se borran',
            infoVersionesTexto: 'Cada vez que se publica, se guarda una versión nueva con su fecha, '
                + 'su autor y su motivo, y las anteriores se conservan enteras. No hay forma de '
                + 'editar ni de borrar una versión ya publicada: corregir algo es publicar la '
                + 'siguiente. Así se puede enseñar qué normas había en una fecha concreta, que es '
                + 'lo que pide el sistema de gestión de calidad.',
            infoRedTitulo: 'Si se corta la conexión justo al publicar',
            infoRedTexto: 'Si la conexión se corta en el instante exacto de pulsar «Publicar nueva '
                + 'versión», esta pantalla puede dar por publicada una versión un momento antes de '
                + 'que lo esté, y dejar entrar una versión de más. Es poco probable y se ve en '
                + 'seguida: la versión de más aparece en el historial, se entiende mirando su '
                + 'motivo y se corrige publicando la buena.',
            infoRedNunca: 'Lo que no puede pasar: perderse ni cambiarse una versión ya publicada. '
                + 'El historial queda siempre completo.',
            infoRedPorQue: 'Está asumido por escrito por dirección el 02/10/2026. Cuando la '
                + 'respuesta no llega, saber si el cambio entró solo puede decirlo el servidor, y '
                + 'quitar esa duda del todo costaba varios días de trabajo para una pantalla que se '
                + 'usa una vez al año, cuando cambia el convenio.',
            normas: 'Normas (una por línea)',
            motivo: 'Motivo del cambio *',
            motivoPlaceholder: 'p. ej. Nuevo convenio publicado en el BOE',
            publicar: 'Publicar nueva versión',
            publicada: 'Versión publicada',
            faltaMotivo: 'Indique el motivo del cambio: sin motivo no se publica',
            faltanNormas: 'Escriba al menos una norma, una por línea',
            confirmarSinCambios: 'El texto no ha cambiado respecto a la versión vigente. '
                + '¿Publicar igualmente una versión nueva? No se podrá borrar.',
            conflicto: 'Mientras editaba, otra persona ha publicado la versión {version}. Lo que '
                + 'hay en el cuadro de texto parte de la versión anterior, así que publicarlo tal '
                + 'cual dejaría su cambio deshecho y no se podría recuperar. Mire la versión '
                + '{version}, añada aquí lo que le falte y después confirme que ya lo ha hecho.',
            conflictoDesconocido: 'La versión que tenía delante ya no es la vigente y no se ha '
                + 'podido saber cuál lo es. Cargue las normas otra vez antes de publicar: así no '
                + 'se pierde lo que haya publicado otra persona.',
            baseSinComprobar: 'No se ha podido comprobar qué versión está en vigor después del '
                + 'último intento de publicar. Hasta saberlo no se publica: volver a enviar lo '
                + 'mismo chocaría otra vez, o podría crear dos versiones iguales. Su texto y su '
                + 'motivo se conservan tal como los envió, y no se pueden editar mientras no se '
                + 'sepa en qué quedó.',
            desenlaceDesconocido: 'No se sabe todavía si la publicación que envió llegó a '
                + 'guardarse. Su texto y su motivo se conservan tal como los envió, y no se pueden '
                + 'editar ni volver a publicar mientras no se sepa: así no se pierde lo escrito ni '
                + 'se crean dos versiones iguales, que no se podrían borrar.',
            sinConfirmar: 'La conexión se cortó al publicar, así que su texto puede haberse '
                + 'guardado o no: desde aquí no se puede saber. Se conserva tal como lo envió, con '
                + 'su motivo, y no se puede editar mientras siga la duda. Vuelva a comprobarlo, o '
                + 'vuelva a publicarlo: si ya se había guardado, no se creará una segunda versión.',
            comprobando: 'Comprobando qué versión está en vigor…',
            comprobarOtraVez: 'Volver a comprobar qué versión está en vigor',
            publicarOtraVez: 'Volver a publicar este mismo texto',
            descartarSinConfirmar: 'Todavía no se sabe si lo que envió se guardó. Si lo descarta y '
                + 'acabara guardándose, quedará publicado como una versión más y no se podrá '
                + 'borrar. Antes de descartarlo, conviene comprobarlo otra vez. ¿Descartar igual?',
            conflictoVer: 'Ver la versión {version}',
            conflictoDescartar: 'Descartar mi texto y cargar lo vigente',
            conflictoAsumir: 'Ya he añadido su cambio: publicar sobre la versión {version}',
            conflictoConfirmar: 'Su texto pasará a publicarse como continuación de la versión '
                + '{version}. Si no ha añadido lo que esa versión cambió, se perderá. ¿Continuar?',
            historial: 'Historial de versiones',
            colVersion: 'Versión',
            colFecha: 'Fecha',
            colAutor: 'Autor',
            colMotivo: 'Motivo',
            ver: 'Ver',
            cargandoVersion: 'Cargando el texto de esta versión…',
            sinVersiones: 'Sin versiones publicadas',
            cargando: 'Cargando las normas…',
            errorCarga: 'No se han podido cargar las normas de vacaciones',
            actualizandoHistorial: 'Actualizando el historial…',
            errorHistorial: 'No se ha podido actualizar esta tabla; lo de arriba sí está al día',
            errorVersion: 'No se ha podido cargar el texto de esa versión',
            reintentar: 'Reintentar',
            pie: 'Cada versión se conserva (trazabilidad del sistema de gestión). Las solicitudes '
                + 'guardan la versión de normas que la persona leyó.'
        },
        festivos: {
            titulo: 'Ajustes · Festivos',
            // #1210 · El aviso del calendario sin cerrar: el indicador de la cabecera solo cuenta, y
            // el desglose por motivo vive en el bloque de avisos de esta pantalla.
            avisos: {
                tituloEnero: '{n} problema en el calendario de festivos de {anio} | {n} problemas en el calendario de festivos de {anio}',
                tituloOctubre: '{n} problema en los festivos de {anio} pendientes de validar | {n} problemas en los festivos de {anio} pendientes de validar',
                indicador: 'Festivos: {n} problema | Festivos: {n} problemas',
                indicadorTitulo: 'Calendario de festivos sin cerrar. Pulsa para ver el detalle en Ajustes · Festivos.',
                verDetalle: 'Ver detalle',
                ocultar: 'Ocultar',
                verQuienes: 'Ver quiénes',
                personasSinMunicipio: '{n} persona de la plantilla no tiene municipio | {n} personas de la plantilla no tienen municipio',
                cargandoPersonas: 'Cargando…',
                personasNoCargadas: 'No se ha podido cargar la lista.',
                noCargado: 'No se han podido calcular los avisos del calendario de festivos.',
                motivos: {
                    SIN_MUNICIPIO: 'Personas sin municipio',
                    OTROS_EJERCICIOS: 'Otros ejercicios',
                    CATALOGO: 'Nacionales y autonómicos'
                }
            },
            noAutorizado: 'No está autorizado para gestionar el calendario de festivos',
            municipiosEnUso: 'Municipios en uso',
            buscarMunicipio: 'Buscar municipio…',
            seleccioneMunicipio: 'Seleccione un municipio para ver sus festivos',
            sinMunicipios: 'Nadie de la plantilla tiene municipio en su domicilio todavía',
            // Lo que se dice mientras la tabla no ha llegado. Es un estado propio, distinto de
            // `sinMunicipios` (ya contestó y no hay nadie) y de `tablaSinCargar` (la petición
            // falló): la pantalla no puede afirmar un vacío que todavía no ha comprobado (#262).
            cargandoTabla: 'Cargando los municipios de la plantilla…',
            // Y el vacío del buscador tampoco es el de la plantilla: que no haya ningún municipio
            // que case con lo escrito no quiere decir que no haya nadie con municipio.
            sinCoincidencias: 'Ningún municipio coincide con lo que ha escrito',
            sinMunicipio: 'Personas sin municipio',
            sinFestivos: 'Sin festivos cargados para este año',
            sinFuente: 'Sin fuente',
            municipio: 'Municipio',
            municipioIne: 'Municipio (código INE)',
            personas: 'Personas',
            nac: 'Nac.',
            aut: 'Aut.',
            loc: 'Loc.',
            estado: 'Estado',
            nacionales: 'Nacionales validados',
            validar: 'Validar',
            validadoPor: 'Validado por',
            confirmarValidar: '¿Dar por buenos los festivos de {municipio} de {anio}?',
            // --- Qué le falta a este municipio, junto a los botones que lo arreglan ---
            // La chapa solo puede decir una cosa y gana la más grave, así que con varias ciertas a
            // la vez la pantalla callaba el resto. Y «Validar» no arregla ninguna de las que no
            // son «pendiente de validar»: se dice aquí, al lado del botón, porque un aviso al
            // principio de la pantalla no lo relaciona nadie con lo que acaba de pulsar
            // (§9 del CLAUDE.md del orquestador; abmsimecal-cloud, preview-2, 13/10/2026).
            loQueFalta: 'Qué falta para cerrar este calendario',
            falta: {
                NO_CARGADO: 'No hay ningún festivo cargado para este municipio en {anio}. '
                    + 'Cárguelos con «Nuevo festivo», arriba, y los suyos con «Nuevo festivo local».',
                PENDIENTE_VALIDAR: 'Quedan {sinValidar} festivo(s) sin dar por buenos. '
                    + 'Se validan con el botón «Validar» de aquí abajo.',
                // Días y filas son dos unidades, y en una sola frase se confunden: la primera
                // redacción decía «hay 11 de los 12 días que tiene el año (12 nacionales y 2
                // autonómicos)» y el paréntesis parecía desglosar el 11 cuando desglosa 14 filas
                // (abmsimecal-cloud, preview-3, 13/10/2026). Los tres números son ciertos, así que
                // no se quita ninguno: se dicen en frases distintas, cada una con su unidad
                // nombrada, y se explica por qué no tienen que coincidir.
                FALTAN_COMPARTIDOS: 'Entre nacionales y autonómicos cubre {compartidos} días '
                    + 'distintos de los {compartidosEsperados} que tiene el año. Cargados tiene '
                    + '{nacionales} nacionales y {autonomicos} autonómicos: ésas son filas de la '
                    + 'lista, y dos que caigan el mismo día son dos filas pero un solo día. Falta '
                    + 'cargar el día que falte con «Nuevo festivo», arriba: «Validar» no lo '
                    + 'arregla, porque lo que falta no está cargado.',
                SOBRAN_COMPARTIDOS: 'Entre nacionales y autonómicos cubre {compartidos} días '
                    + 'distintos y el año tiene {compartidosEsperados}: hay alguno cargado de más '
                    + 'o en el ámbito que no le toca. Cargados tiene {nacionales} nacionales y '
                    + '{autonomicos} autonómicos. Búsquelo en la lista de festivos de abajo y '
                    + 'corríjalo o bórrelo. Si es un nacional que su comunidad no aplica, no lo '
                    + 'borre: márquelo con «No aplica en…» en su fila, que se lo quita solo a esta '
                    + 'comunidad.',
                FALTAN_LOCALES: 'Sus festivos locales aportan {localesQueAportan} día(s) '
                    + 'distinto(s) de los {localesEsperados} que le tocan. Dados por buenos tiene '
                    + '{localesValidados} de {locales} local(es): uno que caiga en un día que ya '
                    + 'era nacional o autonómico sigue siendo una fila, pero no aporta día. '
                    + 'Cargue el que falte con «Nuevo festivo local» o, si el boletín no publicó '
                    + 'más, dé el municipio por completo con «Completo con los locales que hay».',
                SOBRAN_LOCALES: 'Sus festivos locales aportan {localesQueAportan} día(s) '
                    + 'distinto(s) y le tocan {localesEsperados}: hay alguno de más. Dados por '
                    + 'buenos tiene {localesValidados} de {locales} local(es). Búsquelo en la '
                    + 'lista de abajo y bórrelo.'
            },
            // El otro eje, el de la publicación: un municipio al que le falta un día del catálogo
            // sigue teniendo sus calendarios publicados, y la chapa —que dice lo más grave— lo
            // tapaba. Sin esto, borrar un nacional parecía haber deshecho la publicación.
            publicacionAlDia: 'Sus calendarios siguen publicados y al día. Lo de arriba es del '
                + 'catálogo de festivos: no ha deshecho la publicación.',
            publicacionDesactualizada: 'Sus calendarios están publicados, pero ya no son lo que se '
                + 'publicaría ahora. Arregle primero lo de arriba y vuelva a publicar.',
            publicacionNunca: 'Todavía no se ha publicado nada de este municipio en los calendarios.',
            // «Validar» deshabilitado: por qué, y dónde está lo que sí hay que hacer.
            validarSinNadaPendiente: 'Ya están los {validados} festivos de este municipio dados '
                + 'por buenos: «Validar» no tiene nada que hacer.',
            // Y lo que pasó al pulsar, que antes no se decía: la petición volvía sin error, la
            // pantalla recargaba y el estado se quedaba igual.
            validado: 'Validados {validados} festivos de {municipio}.',
            validadoSinCambios: 'No había ningún festivo pendiente de validar en {municipio}: '
                + 'nada que cambiar.',
            sigueIncompleto: 'El calendario de {municipio} sigue sin cuadrar: mire «Qué falta para '
                + 'cerrar este calendario» en su ficha.',
            calendarioCuadrado: 'El calendario de {municipio} ya cuadra.',
            marcadoCompleto: 'Municipio dado por completo con {locales} festivo(s) local(es).',
            marcadoDeshecho: 'Marcado deshecho: el municipio vuelve a pedir sus 2 festivos locales.',
            marcarCompleto: 'Completo con los locales que hay',
            deshacerCompleto: 'Deshacer «completo»',
            completoCon: 'Dado por completo con locales:',
            completoDesfasado: 'Ya no coincide con los festivos locales que hay: vuelva a marcarlo',
            motivoCompleto: 'Motivo para dar el municipio por completo con menos de 2 festivos locales',
            motivoDeshacer: 'Motivo para deshacer el marcado',
            motivoBorrado: 'Motivo del borrado',
            // --- Un nacional o un autonómico es un solo registro para muchos municipios (#1148) ---
            // El 30/10/2026 se borró el 12 de octubre desde la ficha de Alicante y desapareció de
            // los 24 municipios: la pantalla no decía que era compartido. Se dice junto a los
            // botones de la fila y otra vez antes de confirmar.
            compartido: {
                fila: 'compartido por {municipios} municipio(s) y {personas} persona(s)',
                tituloBorrar: 'Borrar un festivo compartido',
                tituloCorregir: 'Corregir un festivo compartido',
                borrar: '«{festivo}» es un festivo {ambito}: es un solo registro para {municipios} '
                    + 'municipio(s) y {personas} persona(s). Borrarlo lo quita de todos ellos, no '
                    + 'solo de {municipio}, y retira su tarea de festivo de sus calendarios. ¿Seguro '
                    + 'que quiere borrarlo para todos?',
                corregir: '«{festivo}» es un festivo {ambito}: es un solo registro para {municipios} '
                    + 'municipio(s) y {personas} persona(s). Corregirlo lo cambia en todos ellos, no '
                    + 'solo en {municipio}, y si cambia la fecha, el nombre, el ámbito o la fuente '
                    + 'vuelve a quedar pendiente de validar para todos.',
                pasado: 'Además es una fecha que ya ha pasado.',
                sugerirNoAplica: 'Si lo que pasa es que {comunidad} no lo aplica, no lo borre ni lo '
                    + 'corrija: use «No aplica en {comunidad}» en su fila.'
            },
            // --- «No aplica en esta comunidad» de un festivo nacional (#1148) ---
            noAplica: {
                boton: 'No aplica en {comunidad}',
                titulo: 'Festivo nacional que la comunidad no aplica',
                explicacion: '«{festivo}» dejará de ser festivo en los municipios de {comunidad}, y '
                    + 'se retirará su tarea de festivo de los calendarios de quien vive en ellos. '
                    + 'Para el resto de municipios no cambia nada, y en la ficha de los de '
                    + '{comunidad} seguirá saliendo, marcado, por si hay que deshacerlo.',
                motivo: 'Motivo',
                motivoEjemplo: 'El decreto de la comunidad no lo incluye',
                guardar: 'Marcar como que no aplica',
                faltaFuente: 'Indique de qué boletín sale: la referencia o el enlace',
                marca: 'No aplica en {comunidad} ({fuente})',
                noCuenta: 'No cuenta en el calendario de este municipio ni le pone tarea a nadie de aquí.',
                deshacer: 'Volver a aplicar',
                motivoDeshacer: 'Motivo para que «{festivo}» vuelva a ser festivo en {comunidad}',
                hecho: '«{festivo}» ya no aplica en {comunidad}: se han rehecho los calendarios de sus municipios.',
                deshecho: '«{festivo}» vuelve a aplicar en {comunidad}: se han rehecho los calendarios de sus municipios.'
            },
            faltaMotivo: 'El motivo es obligatorio',
            faltanDatos: 'La fecha y el nombre son obligatorios',
            fechaDeOtroAnio: 'La fecha tiene que ser de {anio}. Para ponerlo en otro año, cambie de año arriba y créelo allí',
            nuevo: 'Nuevo festivo',
            nuevoLocal: 'Nuevo festivo local',
            editar: 'Corregir festivo',
            guardar: 'Guardar',
            fecha: 'Fecha',
            nombre: 'Nombre',
            ambito: 'Ámbito',
            comunidad: 'Comunidad',
            seleccioneComunidad: 'Elija la comunidad',
            comunidadLocal: 'Comunidad del municipio',
            // Solo sale con un municipio del que no se puede deducir la comunidad: ya no está en
            // el maestro y no la guarda ni su ficha ni ningún festivo suyo.
            sinComunidad: 'No se sabe a qué comunidad pertenece este municipio, así que su '
                + 'calendario no puede incluir los festivos autonómicos. Indíquela al cargar un '
                + 'festivo local suyo.',
            faltaComunidadLocal: 'Indique la comunidad del municipio: sin ella su calendario se '
                + 'queda sin los festivos autonómicos',
            // Sale con el municipio que ya no está en el maestro: ahí la comunidad que se ve sale
            // de sus propios festivos, así que si se cargó mal solo se puede arreglar desde aquí.
            comunidadLocalAviso: 'Este municipio ya no está en el maestro: su comunidad es la que '
                + 'digan sus propios festivos. Corríjala aquí si no es la suya.',
            fuenteRef: 'Fuente (referencia del boletín)',
            fuenteUrl: 'Enlace al boletín',
            motivo: 'Motivo del cambio',
            errorCarga: 'No se han podido cargar los festivos',
            errorGuardar: 'No se ha podido guardar el festivo',
            tablaSinCargar: 'No se ha podido cargar la tabla de municipios',
            reintentar: 'Reintentar',
            ambitos: {
                NACIONAL: 'Nacional',
                AUTONOMICO: 'Autonómico',
                LOCAL: 'Local'
            },
            estados: {
                NO_CARGADO: 'No cargado',
                PENDIENTE_VALIDAR: 'Pendiente de validar',
                // Entre nacionales y autonómicos no llegan a los doce días que tiene un año
                // completo: las columnas Nac. y Aut. de la misma fila enseñan cuántos hay de cada.
                FALTAN_COMPARTIDOS: 'Calendario incompleto',
                // Y al revés: pasan de doce, así que hay un día cargado de más o en la capa que
                // no le toca. Publicarlo así regalaría un festivo a esa gente.
                SOBRAN_COMPARTIDOS: 'Sobran festivos',
                // El calendario no llega a los catorce días del año: o el municipio tiene menos de
                // dos fiestas locales, o alguna cae en un día que ya era nacional o autonómico.
                FALTAN_LOCALES: 'Faltan locales',
                // Y al revés: catorce días es el año entero, así que pasarse son locales de más.
                SOBRAN_LOCALES: 'Sobran locales',
                VALIDADO: 'Validado',
                // Publicado, pero lo que hay en los calendarios ya no es lo que se publicaría
                // ahora: cambió algo de lo que cuelgan las T0083 —el municipio de alguien, la
                // comunidad de un municipio en el maestro, un festivo— y hay que republicar.
                // Es informativo: no bloquea nada (JJCS, 30/09/2026).
                PUBLICADO_DESACTUALIZADO: 'Publicado · desactualizado',
                // Validado y además puesto en los calendarios (#54), y al día.
                PUBLICADO: 'Validado · publicado'
            },
            // --- Publicar en los calendarios (#54) ---
            publicar: 'Publicar',
            publicados: 'Publicados',
            desactualizados: 'Desactualizados',
            desactualizadoExplicacion: 'Los calendarios de este municipio ya no son lo que se '
                + 'publicaría ahora: algo ha cambiado desde la última publicación. Abre la vista '
                + 'previa para ver qué cambia y vuelve a publicar. No corre prisa: mientras tanto '
                + 'todo sigue funcionando igual.',
            generaTarea: '¿Genera tarea?',
            generaTareaSi: 'Sí · T0083',
            generaTareaNo: 'No',
            // --- El catálogo contra la extracción del boletín que cita (#255) ---
            // Avisa y no bloquea nada: ni la publicación, ni los estados, ni los festivos. El «por
            // qué» de cada aviso lo escribe el servidor, que es quien sabe qué boletines hay
            // leídos, cuándo y por quién; aquí solo están los rótulos.
            respaldo: {
                sinRespaldo: 'Sin respaldo',
                sinComprobar: 'Sin comprobar',
                noCargados: 'Faltan del boletín',
                sinCargar: 'No se ha podido comprobar el respaldo de los festivos',
                // La comprobación va por su propia petición, así que puede estar todavía en vuelo
                // cuando ya hay tabla —o cuando ya está abierta la vista previa—. Callar ahí deja
                // creer que está comprobado: ni «Sin respaldo: 0» ni la ventana en blanco.
                comprobando: 'Comprobando el respaldo de los festivos…',
                comprobandoEnVistaPrevia: 'La comprobación del respaldo todavía está en curso: '
                    + 'espera a que termine antes de publicar, o cierra y vuelve a abrir esta '
                    + 'ventana. Publicar no está bloqueado.',
                noBloquea: 'Estos avisos no bloquean nada: ni publicar, ni validar, ni los '
                    + 'festivos ya cargados. Son para que alguien los mire.',
                tituloNoCargados: 'El boletín leído trae estos festivos y no están cargados',
                sinNombre: 'sin nombre en la extracción del boletín',
                enVistaPrevia: 'Festivos que no cuadran con el boletín que citan',
                todoCuadra: 'El catálogo cuadra con los boletines leídos',
                // Sin ningún boletín leído no hay nada que comparar, y decirlo es información: la
                // pantalla no puede dar por revisado un catálogo que no ha comprobado.
                sinExtracciones: 'De {anio} no hay ningún boletín leído todavía, así que el '
                    + 'catálogo no se ha podido comparar con nada. Los boletines se leen en '
                    + '«Festivos · Boletines».',
                etiquetas: {
                    SIN_RESPALDO: 'Sin respaldo en el boletín que cita',
                    SIN_RESPALDO_COMPROBABLE: 'Sin respaldo comprobable',
                    NO_CARGADO: 'El boletín lo trae y no está cargado'
                }
            },
            vistaPrevia: {
                titulo: 'Vista previa · publicar festivos en calendarios',
                // Mientras se calcula el plan, la ventana se queda sin contadores y sin choques:
                // sin esto se abría en blanco y no se distinguía de «no hay nada que publicar».
                calculando: 'Calculando lo que se va a publicar…',
                calendarios: 'Calendarios',
                tareas: 'Tareas T0083 futuras',
                choques: 'Choques',
                yaExistentes: 'Ya existentes (no se duplican)',
                retiradas: 'Tareas que se retiran',
                // --- De dónde sale cada número (JJCS, 05/10/2026) ---
                // La ficha de un municipio decía «Personas: 1» y esta ventana «2 Calendarios», y
                // sin explicación los dos números parecen contradecirse. Son tres cosas distintas
                // y se dicen las tres, en escalera y con palabras.
                alcanceTitulo: 'De dónde salen estos números',
                alcanceTodos: 'Se publica el año {anio} entero y todos los municipios en uso, no '
                    + 'solo el municipio que tengas abierto en la tabla.',
                alcanceMunicipio: 'Se publica el año {anio} solo del municipio {municipio}.',
                alcanceEscalera: 'De {plantilla} persona(s) de la plantilla con municipio, '
                    + '{destinatarias} reciben festivos (son las que tienen marcado «Gestiona '
                    + 'vacaciones en este usuario»), y con esta publicación cambian '
                    + '{calendarios} calendario(s).',
                alcanceSinCheck: '{sinCheck} persona(s) con municipio no reciben ningún festivo '
                    + 'porque ninguna de sus cuentas tiene marcado «Gestiona vacaciones en este '
                    + 'usuario». Si alguna debiera recibirlos, márcalo en su ficha y vuelve a '
                    + 'abrir esta ventana.',
                alcanceSinMunicipio: '{sinMunicipio} persona(s) de la plantilla no tienen '
                    + 'municipio: no reciben ningún festivo, tampoco los nacionales.',
                alcanceUnidad: '«Calendarios» cuenta calendarios, no personas: quien tiene dos '
                    + 'cuentas vinculadas recibe sus festivos en la que gestiona vacaciones y '
                    + 'puede perder en la otra lo que se le quedó, y entonces son dos calendarios '
                    + 'de una sola persona.',
                alcanceManda: 'Lo que se escribe al publicar es exactamente lo que cuentan estos '
                    + 'tres números: salen del mismo plan. La columna «Personas» de la tabla de '
                    + 'municipios es informativa —dice quién vive allí— y no decide nada.',
                trabajoPlanificado: 'Trabajo planificado en un festivo',
                tiene: 'tiene',
                noSeBorra: 'No se borra: se avisa a planificación para reprogramarlo.',
                vacacionesNinguna: 'Vacaciones en festivo: ninguna',
                vacacionesExplicacion: 'Si un festivo nuevo cayera en unas vacaciones, ese día se '
                    + 'quita de la solicitud, vuelve al saldo y se avisa a la persona y a su aprobador.',
                vacaciones: 'Vacaciones en festivo',
                pie: 'Solo se crean días futuros. Si ya existe la tarea de ese festivo para esa '
                    + 'persona, no se duplica.',
                // El «i» de la ventana: el riesgo que se ha asumido a propósito, escrito donde lo
                // lee quien pulsa Publicar (JJCS, 01/10/2026, punto 2, opción b). No se disfraza de
                // garantía: si alguien está metiendo vacaciones a esa misma persona y ese mismo día
                // justo mientras se publica, el día puede quedar un instante con dos; se repasa al
                // terminar y se quita la que puso el módulo, y si el repaso fallara, volver a
                // publicar lo deja bien.
                pieConcurrencia: 'Si alguien está tocando las vacaciones de la misma persona y el '
                    + 'mismo día justo mientras se publica, ese día puede quedar un momento con dos '
                    + 'apuntes. Se revisa al terminar y se quita el que puso el sistema, nunca el '
                    + 'que puso una persona. Si quedara alguno, vuelve a pulsar Publicar.',
                sinNada: 'No hay ningún festivo futuro que publicar con lo que hay validado.',
                error: 'No se ha podido calcular la vista previa',
                errorPublicar: 'No se ha podido publicar',
                // Lo que ha pasado, no lo que decía la ventana que iba a pasar (JJCS, 01/10/2026,
                // punto 1): estos números los devuelve el publicado y son los de lo escrito.
                // Con los calendarios dentro: es el contador que la ventana enseña arriba, y sin
                // decirlo aquí los dos números de la misma unidad no se podían comparar —que es
                // justo lo que esta tarea arregla— (JJCS, 07/10/2026, caso de aceptación).
                publicado: 'Publicado: {creadas} tarea(s) creadas, {retiradas} retiradas, '
                    + 'en {calendarios} calendario(s).',
                // Y el reparto, solo cuando hay algo que repartir: en una primera publicación todo
                // es nuevo y decir «0 movidas, 0 rehechas» sería ruido.
                publicadoMovimientos: '{movidas} de ellas cambiaron de día y {rehechas} se '
                    + 'rehicieron en el mismo día.',
                publicadoVacaciones: '{diasDevueltos} día(s) de vacaciones volvieron al saldo y '
                    + '{diasRepuestos} volvieron a su solicitud.'
            }
        },
        empleadofunciones: {
            titulo: 'Puesto y funciones',
            ahora: 'Funciones que desempeña ahora',
            anadir: 'Añadir función',
            historico: 'Histórico de funciones',
            codigo: 'Código',
            funcion: 'Función',
            puesto: 'Puesto',
            desde: 'Desde',
            hasta: 'Hasta',
            hastaObligatorio: 'Hasta *',
            motivo: 'Motivo',
            motivoObligatorio: 'Motivo *',
            motivoAltaEtiqueta: 'Alta:',
            motivoBajaEtiqueta: 'Baja:',
            motivoEjemplo: 'Por ejemplo: «Nombramiento como supervisora técnica RITE». El motivo se guarda y se ve en el histórico.',
            registradoPor: 'Registrado por',
            principal: 'Principal',
            funcionPrincipal: 'Función principal',
            vigente: 'vigente',
            boton: 'Añadir',
            finalizar: 'Finalizar',
            finalizarTitulo: 'Finalizar función',
            cancelar: 'Cancelar',
            eligeFuncion: 'Elija una función…',
            anadida: 'Función añadida',
            finalizada: 'Función finalizada',
            sinVigentes: 'No desempeña ninguna función ahora mismo',
            sinHistorico: 'Todavía no se le ha asignado ninguna función',
            sinFunciones: 'No hay ninguna función activa en el catálogo: créela antes en Ajustes · Funciones.',
            faltaFuncion: 'Elija la función que va a desempeñar',
            faltaMotivoAlta: 'Escriba el motivo por el que se le asigna la función',
            faltaHasta: 'Indique hasta cuándo ha desempeñado la función',
            faltaMotivoBaja: 'Escriba el motivo por el que deja de desempeñar la función',
            cuentaCompartida: 'Esta persona tiene dos usuarios y unas solas funciones: se gestionan en el usuario',
            soloLectura: 'Sólo lectura',
            huerfana: 'fuera de su usuario',
            huerfanaAviso: 'Esta función está guardada en un usuario que no es donde se gestionan las funciones de esta persona, así que no cuenta en los listados de Ajustes. Para arreglarlo, marque «Gestiona vacaciones en este usuario» en el usuario que debe gestionarlas, o finalice la función.',
            noAutorizado: 'No está autorizado para ver las funciones de esta persona',
            sinCargar: 'No se han podido cargar las funciones de esta persona',
            reintentar: 'Reintentar',
            errorCarga: 'No se han podido cargar las funciones',
            errorAnadir: 'No se ha podido añadir la función',
            errorFinalizar: 'No se ha podido finalizar la función',
            // Ventana «Añadir funciones de un puesto…» (#485)
            desdePuesto: 'Añadir funciones de un puesto…',
            desdePuestoTitulo: 'Añadir funciones de un puesto',
            puestoObligatorio: 'Puesto *',
            desdeObligatorio: 'Desde *',
            motivoTodas: 'Motivo * (vale para todas)',
            eligePuesto: 'Elija un puesto…',
            marcarTodas: 'Marcar / desmarcar todas',
            yaDesempenaDesde: 'Ya la desempeña desde {fecha}',
            yaDesempenaVarias: '{n} ya las desempeña y no se pueden volver a añadir',
            marcadasDe: '{marcadas} de {total} marcadas',
            anadirN: 'Añadir {n} funciones',
            anadirUna: 'Añadir 1 función',
            // Los tres motivos por los que el botón de confirmar no se puede pulsar. Van JUNTO al
            // botón y no en la cabecera: quien lo pulsa no relaciona lo uno con lo otro (§9).
            noHayPuesto: 'Elija un puesto para ver sus funciones.',
            cargandoFunciones: 'Cargando las funciones del puesto…',
            puestoSinFunciones: 'El puesto no tiene funciones activas. Se dan de alta en Ajustes · Funciones (las crea el ADMINISTRADOR).',
            yaLasTieneTodas: 'Esta persona ya desempeña todas las funciones activas de {puesto}.',
            // Lo que falta se enumera entero en una sola frase: con un motivo por campo, quien
            // tiene dos sin rellenar rellena uno, vuelve a pulsar y se encuentra otro aviso (§9).
            faltaLote: 'Para poder añadirlas, falta {que}.',
            faltaItemMarcar: 'marcar al menos una función',
            faltaItemDesde: 'la fecha «Desde»',
            faltaItemMotivo: 'escribir el motivo',
            faltaY: ' y ',
            pieVentana: 'Se añade una línea al historial por cada función, con quién, cuándo, desde y motivo. Si falla una, no se añade ninguna.',
            anadidasN: '{n} funciones añadidas',
            anadidaUna: '1 función añadida',
            errorFuncionesPuesto: 'No se han podido cargar las funciones del puesto',
            errorAnadirPuesto: 'No se han podido añadir las funciones del puesto',
            pie: 'Una sola función principal vigente por persona (lo garantiza también la base de datos). Las funciones de una persona se gestionan en un solo usuario, el que tiene marcado «Gestiona vacaciones en este usuario»; al cambiarlo de usuario, las funciones vigentes se trasladan con él. Las funciones son organizativas: la cualificación ENAC por materia sigue en Personal cualificado, que no se toca.'
        },
        domicilio: {
            titulo: 'Domicilio y calendario laboral',
            direccion: 'Dirección',
            codigoPostal: 'Código postal',
            municipio: 'Municipio (INE)',
            provincia: 'Provincia',
            comunidad: 'Comunidad',
            otroMunicipio: 'Festivos de otro municipio',
            municipioFestivos: 'Municipio de festivos',
            motivoExcepcion: 'Motivo (obligatorio)',
            faltaMunicipioExcepcion: 'Elija el municipio de festivos o desmarque la excepción',
            faltaMotivo: 'Para cobrar los festivos de otro municipio hay que indicar el motivo',
            sugerencia: 'Municipio propuesto:',
            usarSugerencia: 'Usar',
            cuentaCompartida: 'Esta persona tiene dos usuarios y un solo domicilio: se guarda en el usuario',
            recargadoPorOtro: 'Otra persona ha cambiado este domicilio: la tarjeta se ha actualizado con lo que quedó guardado',
            recargadoPorCuentaGestora: 'Ha cambiado el usuario en el que se gestiona esta persona: la tarjeta se ha actualizado con el domicilio que hay guardado en ese usuario',
            festivosDe: 'Festivos de',
            sinMunicipio: 'Sin municipio: no se pueden calcular sus festivos',
            sinFestivos: 'Sin festivos cargados para su municipio en este año',
            guardar: 'Guardar',
            guardado: 'Domicilio guardado',
            noAutorizado: 'No está autorizado para ver el domicilio de esta persona',
            errorCarga: 'No se ha podido cargar el domicilio',
            sinCargar: 'No se ha podido cargar el domicilio y el calendario laboral de esta persona',
            reintentar: 'Reintentar',
            errorGuardar: 'No se ha podido guardar el domicilio'
        },
        municipios: {
            municipios: 'Municipios',
            municipio: 'Municipio',
            editar: 'Editar',
            nuevo: 'Nuevo',
            codigo: 'Código',
            cp: 'Código Postal',
            nombre: 'Nombre',
            poblacion: 'Población',
            municipio_guardado: 'Municipio guardado correctamente', 
            provincia: 'Provincia', 
            comunidad: 'Comunidad', 
            añadir: 'Añadir'
        },
        comunidades: {
            comunidades: 'Comunidades Autónomas',
            comunidad: 'Comunidad Autónoma',
            proveedor: 'Proveedor',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            provincias: 'Provincias',
            comunidad_guardada: 'Comunidad Autónoma guardada correctamente',
            servicioTasas: 'Servicio de Tasas',
            codCuentaMayorTasas: 'Código Cuenta Mayor Tasas',
            plazos: {
                tipo_plazo: 'Tipo de Plazo',
                tipo_inspeccion: 'Tipo de Inspección',
                plazo: 'Plazo (días)',
                materias: 'Materias',
                serviciosExcluir: 'Servicios a excluir',
                calificaciones_inspeccion: 'Calificaciones de Inspección',
            },
            calificacionesExcluir: 'Calificaciones a excluir de nuevas primeras'
        },
        paises: {
            paises: 'Paises',
            pais: 'País',
            editar: 'Editar',
            nuevo: 'Nueva',
            codigo: 'Código',
            nombre: 'Nombre',
            pais_guardado: 'País guardado correctamente'
        },
        tiposdocumentos: {
            tiposdocumentos: 'Tipos de documentos',
            tipodocumento: 'Tipo de documento',
            editar: 'Editar',
            nuevo: 'Nueva',
            tipo: 'Tipo',
            nombre: 'Nombre',
            tipodocumento_guardado: 'Tipo de documento guardado correctamente'
        },
        pedidos: {
            conforme: 'Conforme',
            reparto: 'Reparto',
            pedidos: 'Pedidos',
            contratacion: 'Contratación',
            terceros: 'Subc. + Com.',
            totalTasas: 'Total Tasas',
            lineaspedidos: 'Líneas de Pedidos',
            pedido: 'Pedido',
            numero: 'Número',
            nombre: 'Nombre',
            cliente: 'Cliente',
            codigo: 'Código',
            codigoCliente: 'Código Cliente',
            nombreCliente: 'Nombre Cliente',
            estado: 'Estado',
            estadoLinea: 'Estado Línea',
            estadoPedido: 'Estado Pedido',
            fechaPedido: 'Fecha Pedido',
            fechaContratacion: 'Fecha Contratación',
            fechaEjecucion: 'Fecha Ejecución',
            fechaPlanificacion: 'Fecha Planificación',
            editar: 'Editar Pedido',
            nuevo: 'Nuevo Pedido',
            empresa: 'Empresa',
            delegacion: 'Delegación',
            centrotrabajo: 'Centro de Trabajo',
            departamento: 'Departamento',
            lineaNegocio: 'Línea de Negocio',
            empleado: 'Empleado',
            usuarioEjecucion: 'Usuario Ejecución',
            tipoPedido: 'Tipo Pedido',
            moneda: 'Moneda',
            condicionPago: 'Condiciones de Pago',
            viaPago: 'Vía de Pago',
            lineas: 'Líneas',
            add: 'Añadir',
            creado: 'Creado',
            ejecucion: 'En Ejecución',
            planificado: 'Planificado',
            ejecutado: 'Ejecutado',
            facturado: 'Facturado',
            cancelado: 'Cancelado',
            cerrado: 'Cerrado',
            empleadoContratacion: 'Empleado Contratación',
            creada: 'Creada',
            abierta: 'Abierta',
            cerrada: 'Cerrada',
            cancelada: 'Cancelada',
            tipoLinea: 'Tipo de Línea',
            servicio: 'Servicio',
            instalacion: 'Instalación',
            item: 'Item',
            texto: 'Texto',
            precio: 'Precio Unitario',
            porcIVA: 'Porcentaje IVA',
            porcDescuento: 'Porcentaje Dto',
            porcSegunda: 'Porcentaje Segunda',
            importeSegunda: 'Importe Segunda',
            importe: 'Importe',
            cantidad: 'Cantidad',
            tiempoEstimadoOficina: 'Tiempo Estimado Oficina (Minutos)',
            tiempoEstimadoCampo: 'Tiempo Estimado Campo (Minutos)',
            tiempo: 'Tiempo (Minutos)',
            comentarios: 'Comentarios',
            comentariosLineaCerrada: 'Comentarios en línea cerrada',
            anyoEjecucion: 'Año Ejecución',
            numeroOferta: 'Número Oferta',
            codigoOferta: 'Código Oferta',
            subcontratacion: 'Subcontratación',
            comision: 'Comisión',
            proveedor: 'Proveedor',
            codigoOferta: 'Código Oferta',
            administrador: 'Administrador',
            instalador: 'Instalador',
            mantenedor: 'Mantenedor',
            asociacion: 'Asociación',
            codCuentaMayor: 'Código Cuenta Mayor',
            codNormaReparto: 'Código Norma Reparto',
            lineaEjecutable: 'Línea Ejecutable',
            totalSubcontratacion: 'Total Subcontratación',
            totalComision: 'Total Comisión',
            totalTerceros: 'Total Terceros',
            subtotal: 'Subtotal',
            totalIVA: 'IVA',
            totalSinIVA: 'Total sin IVA',
            total: 'Total',
            totales: 'Totales',
            datosLinea: 'Datos Línea',
            tasas: 'Tasas',
            num: 'Nº',
            seleccionar: 'Seleccionada',
            linea: 'Línea',
            inspector: 'Inspector',
            inspectorSupervisado: 'Inspector supervisado',
            supervisadoFormacion: 'Supervisado en formación',
            observador: 'Observador',
            supervisor: 'Supervisor',
            inspectores: 'Inspectores',
            observaciones: 'Observaciones',
            fecha_visita: 'Fecha Visita',
            hora_primera_visita: 'Hora Primera Visita',
            rol: 'Rol',
            direccionQuedar: 'Dirección donde quedar con el cliente',
            posicion: 'Posición',
            direccion: 'Dirección',
            descripcion: 'Descripción',
            hora_inicio: 'Hora Inicio',
            desde: 'Desde',
            hasta: 'Hasta',
            guardado_ok: 'Pedido guardado correctamente',
            siguiente: 'Siguiente',
            anterior: 'Anterior',
            cerrar: 'Cerrar',
            nuevaInstalacion: 'Nueva Instalación',
            nuevoItem: 'Nuevo Item',
            direccionInspeccion: 'Dirección Inspección',
            tiempos: 'Tiempos',
            importes: 'Importes',
            impuestos: 'Impuestos',
            colaboradores: 'Colaboradores',
            resumen: 'Resumen',
            planificar: 'Planificar Pedido',
            verOferta: 'Ver Oferta',
            eliminar: 'Borrar Pedido',
            gestionPlanificacion: 'Gestión Planificación',
            motivoNoPlanificable: 'Motivo No Planificable',
            historicoMotivos: 'Histórico de motivos',
            guardar: 'Guardar',
            segundas_ok: 'Línea de 2as creada correctamente',
            nuevaprimera_ok: 'Línea de 1as creada correctamente',
            vinculacion_ok: 'Línea vinculada correctamente',
            facturar: 'Facturar Pedido',
            enviarBC: 'Enviar a BC',
            verEnBC: 'Ver en BC',
            envio_bc_ok: 'Enviado a BC correctamente',
            notas: 'Comentarios',
            lineaspedido: {
                peticion_documentacion: 'Petición de Documentación',
                plantillaEmail: 'Plantilla Email',
                item: 'Item',
                formacrear: 'Donde crear la nueva línea',
                pedidoAsociar: 'Indicar el pedido al que se creará la nueva línea',
                pedidoNuevaPrimera: 'Pedido de nueva primera',
                numeroLineaNuevaPrimera: 'Número de línea de nueva primera',
                pedidoAnteriorNegativa: 'Pedido de anterior negativa',
                numeroLineaAnteriorNegativa: 'Número de línea de anterior negativa',
            }
        },
        ofertas: {
            contratacion: 'Contratación',
            terceros: 'Subc. + Com.',
            ofertas: 'Ofertas',
            telefono: 'Teléfono',
            telefonoMovil: 'Teléfono Móvil',
            aprobar: 'Aprobar Oferta',
            aprobadaOK: 'Oferta aprobada correctamente',
            oferta: 'Oferta',
            numero: 'Número',
            numeroSAP: 'Número SAP',
            resumen: 'Resumen',
            nuevoItem: 'Nuevo Item',
            adjuntarAceptacion: 'Adjuntar Aceptación',
            verAceptacion: 'Ver Documento Aceptación',
            contactocliente: 'Contacto del Cliente',
            emailcontacto: 'Email del Contacto',
            cambio_estado_ok: 'Se ha realizado el cambio de estado correctamente',
            guardado_public: 'Se han registrado correctamente sus comentarios.',
            formTitle: 'Formulario de aceptación de Oferta',
            enviar: 'Enviar Automáticamente',
            enviadaManual: 'Oferta ya enviada a cliente',
            comprobarFirmaCliente: 'Comprobar Firma de Cliente',
            finalizar: 'Finalizar',
            volverEditar: 'Volver a Edición',
            dni: 'DNI',
            iban: 'IBAN',
            imprimir: 'Imprimir',
            acciones: 'Acciones',
            descargar: 'Descargar',
            loading: 'Cargando Oferta... ',
            nuevaInstalacion: 'Nueva Instalación',
            aceptacionOferta: 'Aceptación de Oferta',
            seleccionar: 'Seleccionar',
            anterior: 'Anterior',
            siguiente: 'Siguiente',
            cerrar: 'Cerrar',
            guardar: 'Guardar',
            crearLinea: 'Añadir Línea',
            tiempos: 'Tiempos',
            importes: 'Importes',
            impuestos: 'Impuestos',
            direccionInspeccion: 'Dirección Inspeccion',
            colaboradores: 'Colaboradores',
            num: 'Nº',
            nombre: 'Nombre',
            cliente: 'Cliente',
            clouser: 'CLOUSER',
            codigo: 'Código',
            codigoCliente: 'Código Cliente',
            nombreCliente: 'Nombre Cliente',
            estado: 'Estado',
            fechaOferta: 'Fecha Oferta',
            fechaVencimiento: 'Fecha Vencimiento',
            editarOferta: 'Editar Oferta',
            editar: 'Editar',
            eliminar: 'Eliminar',
            crearPedido: 'Crear Pedido',
            nuevo: 'Nueva Oferta',
            empresa: 'Empresa',
            delegacion: 'Delegación',
            centrotrabajo: 'Centro de Trabajo',
            departamento: 'Departamento',
            lineaNegocio: 'Línea de Negocio',
            empleado: 'Empleado Contratación',
            tipoOferta: 'Tipo Oferta',
            moneda: 'Moneda',
            condicionPago: 'Condiciones de Pago',
            viaPago: 'Vía de Pago',
            cuenta: 'Cuenta',
            plazoDias: 'Plazo (días)',
            lineas: 'Líneas',
            linea: 'Línea',
            add: 'Añadir',
            creada: 'Creada',
            abierta: 'Abierta',
            cerrada: 'Cerrada',
            cancelada: 'Cancelada',
            tipoLinea: 'Tipo de Línea',
            servicio: 'Servicio',
            instalacion: 'Instalación',
            item: 'Item',
            texto: 'Texto',
            textos: 'Textos personalizados',
            orden: 'Orden de presentación del texto',
            titulo: 'Título del texto',
            html: 'Texto a mostrar en la oferta',
            precio: 'Precio Unitario',
            presupuestoConIVA: 'Generar presupuesto con IVA',
            porcIVA: 'Porcentaje IVA',
            porcDescuento: 'Porcentaje Dto',
            porcSegunda: 'Porcentaje Segunda',
            importeSegunda: 'Importe Segunda',
            tasas: 'Tasas por unidad',
            servicioTasas: 'Servicio de Tasas',
            importe: 'Importe Línea',
            cantidad: 'Cantidad',
            cantidadCrear: 'Cantidad Crear Pedido',
            tiempoEstimadoOficina: 'T. Est. Oficina (Minutos)',
            tiempoEstimadoCampo: 'T. Est. Campo (Minutos)',
            comentarios: 'Comentarios',
            verbal: 'Verbal',
            normalizada: 'Normalizada',
            ordinaria: 'Ordinaria',
            marco: 'MARCO',
            contrato: 'Contrato',
            tipo: 'Tipo Oferta',
            subcontratacion: 'Subcontratación',
            comision: 'Comisión',
            proveedor: 'Proveedor',
            codigoOferta: 'Código Oferta',
            administrador: 'Administrador',
            instalador: 'Instalador',
            mantenedor: 'Mantenedor',
            asociacion: 'Asociación',
            totalOferta: 'Total Oferta',
            totalSubcontratacion: 'Total Subcontratación',
            totalTerceros: 'Total Terceros',
            totalTasas: 'Total Tasas',
            totalComision: 'Total Comisión',
            subtotal: 'Subtotal',
            totalIVA: 'IVA',
            total: 'Total',
            totalSinIVA: 'Total sin IVA',
            totales: 'Totales',
            datosLinea: 'Datos Línea',
            instalacion_creada: 'Instalación creada',
            contacto_creado: 'Contacto creado',
            item_creado: 'Item creado',
            aceptacion_ok: 'Documentos de Aceptación Adjuntados',
            extension_ok: 'Oferta Extendida correctamente',
            guardado_ok: 'Oferta guardada correctamente',
            objeto: 'Objeto',
            alcance: 'Alcance',
            personalymedios: 'Personal y Médios',
            descripciontrabajo: 'Descripción del Trabajo',
            requisitosprevios: 'Requisitos previos',
            compromisosimecal: 'Compromiso Simecal',
            plazos: 'Plazos',
            condicionesespecificas: 'Condiciones específicas',
            subcontrataciontexto: 'Detalles de subcontratación',
            comisionproveedor: 'Proveedor Comisión',
            comisionunitaria: 'Comisión Unitaria',
            contratacion: 'Contratación',
            elegir_cliente_lineas: 'Elija un cliente para poder añadir líneas',
            elegir_cliente_condiciones_pago: 'Elija un cliente para poder seleccionar condiciones de pago',
            motivoRechazo: 'Motivo de rechazo',
            motivoCancelacion: 'Motivo de cancelación',
            extenderPlazo: 'Extender Plazo',
            precioUnitario: 'Precio Unitario',
            emailComunicaciones: 'Email comunicaciones',
            titular: 'Titular',
            popupRechazo: {
                title: 'Oferta rechazada por el cliente',
                rechazar: 'Marcar como rechazada',
                indicarMotivoRechazo: 'Indicar Motivo de rechazo'
            },
            popupCancelar: {
                title: 'Oferta cancelada',
                cancelar: 'Marcar como cancelada',
                indicarMotivoCancelacion: 'Indicar Motivo de cancelación',
                verMotivoCancelacion: 'Ver motivo de cancelación'
            },
            popuHistoricoEstados: {
                historicoEstados: 'Histórico de estados',
                usuario: 'Usuario',
                fecha: 'Fecha'
            },
            gastos: {
                previsionGastos: 'Previsión de gastos',
                kilometros: 'Kilómetros',
                peajes: 'Peajes',
                parking: 'Parking',
                desayuno: 'Desayuno',
                comida: 'Comida',
                cena: 'Cena',
                hotel: 'Hotel',
                finDeSemana: 'Fin de semana',
                horasNocturnas: 'Horas nocturnas',
            }
        },
        albaranes: {
            malo: 'Reportar error de sincronización',
            albaranes: 'Albaranes',
            new: 'Nuevo Albarán',
            codigo: 'Código',
            cliente: 'Cliente',
            expedientes: 'Expedientes',
            expedientes_incluir: 'Expedientes a incluir',
            fecha: 'Fecha',
            anterior: 'Anterior',
            siguiente: 'Siguiente',
            resumen: 'Resumen',
            guardar: 'Guardar',
            descargar: 'Descargar',
            eliminar: 'Eliminar',
            sincronizar: 'Sincronizar',
            sincronizado: 'Sincronizado',
            sin_albaranes: 'Sin Albaranes',
            numero_albaran: 'Nº de albarán',
            fecha_albaran: 'Fecha albarán',
            servicio: 'Servicio',
            domicilio: 'Domicilio',
            cantidad: 'Cantidad',
            firmado: 'Firmado',
            firmante: 'Firmante',
            nif: 'NIF',
            nombre: 'Nombre',
            provincia: 'Provincia',
            firmado: 'Firmado',
            cargar_albaran_firmado: 'Cargar albarán firmado',
            albaran_cargado: 'Albarán cargado',
        },
        inspeccionesOffline: {
            visualizar: 'Visualizar',
            imprimir: 'Imprimir',
            previsualizar: 'Previsualizar',
            eliminar: 'Eliminar',
            eliminarSeleccion: 'Eliminar selección',
            editar: 'Editar',
            inspeccionar: 'Realizar Inspección',
            sincronizar: 'Sincronizar',
            inspecciones_pendientes: 'Pendientes',
            inspecciones_anteriores: 'Sincronizados',
            guardar_cliente: 'Guardar cliente',
            nuevo_cliente_guardado: 'Cliente creado',
            documentacion: 'Ver Documentos del Pedido'
        },
        inspecciones: {
            inspecciones: {
                inspecciones: 'Expedientes',
                sin_cita: 'Sin cita',
                sin_inspecciones_anteriores: 'Sin expedientes anteriores',
                sin_inspecciones_pendientes: 'Sin expedientes pendientes',
                continuar_sin_pedido: 'Continuar sin pedido',
                malo: 'Reportar expediente',
                nuevo: 'Nuevo expediente manual'
            },
            inspeccion_form: {
                ya_inspeccionado: 'Expediente ya inspeccionado',
                auditoria: 'Auditar manualmente',
                aprobadoenvio: 'Aprobado paso a proceso de entrega',
                inspectores: 'Inspectores',
                add: 'Añadir',
                inspector: 'Inspector',
                rol: 'Rol',
                anyo: 'Año',
                albaran: 'Albarán',
                formato: 'Formato',
                codigoFormato: 'Código Formato',
                provincia: 'Provincia',
                usuario: 'Usuario',
                fecha: 'Fecha',
                cerrar: 'Cerrar',
                historicoEstados: 'Histórico Estado',
                fecha_inspeccion: 'Fecha',
                fecha_limite_correccion: 'Fecha límite de corrección',
                fecha_prox_inspeccion: 'Fecha de próxima inspección',
                fecha_renovacion: 'Fecha de renovación',
                inicio: 'Inicio',
                fin: 'Fin',
                hora_inicio: 'Hora inicio',
                hora_final: 'Hora final',
                sesiones_trabajo_automaticas: 'Sesiones de trabajo automáticas',
                sesiones_trabajo_manuales: 'Sesiones de trabajo',
                sesiones_tpi: 'Sesiones TPI',
                compatibilidad_titulo: 'Formato incompatible',
                compatibilidad_mensaje: 'No puede iniciar el trabajo de esta inspección ({formato}). Ya tiene una o más inspecciones con una sesión de trabajo abierta de un formato incompatible. Pause o finalice la(s) siguiente(s) antes de continuar:',
                compatibilidad_ir: 'Ir al expediente',
                hora_inicio_real: 'Hora inicio real',
                hora_final_real: 'Hora final real',
                direccion_inicio: 'Dirección inicio',
                direccion_fin: 'Dirección fin',
                editar_inspeccion: 'Editar Expediente',
                nueva_inspeccion: 'Nuevo Expediente',
                inspeccion_guardada: 'Expediente guardado con éxito',
                formato_asignado: 'Formato asignado a la inspección',
                inspeccion: 'Expediente',
                tipo_inspeccion: 'Tipo Expediente',
                conflictos: 'Incidencias',
                no_conflictos: 'Este Expediente no tiene Incidencias',
                justificantes: 'Justificantes',
                documentos: 'Documentos',
                codigo: 'Código',
                codigoExpAnterior: 'Código Expediente Anterior',
                codigoExpSiguiente: 'Código Expediente Siguiente',
                pedido: 'Pedido',
                cliente: 'Cliente',
                nif: "NIF",
                calificacion: 'Calificación',
                estado: 'Estado',
                descargarCertificado: 'Descargar certificado',
                descargarCertificadoBETA: 'Descargar certificado (Beta)',
                descargarHojaDatos: 'Descargar Hoja de Datos',
                descargarTomaDatos: 'Descargar hoja de toma de datos',
                fecha_solicitada: 'Fecha Solicitada',
                fecha_solicitada_desde: 'Fecha Solicitada Desde',
                fecha_solicitada_hasta: 'Fecha Solicitada Hasta',
                fecha_planificada: 'Fecha Planificada',
                fecha_visita: 'Fecha Visita',
                finalizar: 'Finalizar inspección',
                errorescorregidos: 'Errores corregidos',
                firmainspector: 'Firmar el certificado de inspección',
                adjuntadocumentosinfirma: 'Adjuntar certificado sin firma digital',
                adjuntadocumentofirmado: 'Adjuntar certificado con firma digital',
                autofirma: 'Autofirma',
                hora: 'Hora',
                fecha_inspeccion: 'Fecha Inspección',
                direccion: 'Dirección',
                cp: 'C.P.',
                poblacion: 'Población',
                pais: 'País',
                tipo_pedido: 'Tipo Pedido',
                comentario_inspector: 'Comentario Inspector',
                comentario_resolucion: 'Comentario Resolución',
                resolucion: 'Resolución',
                resultadosAuditoria: 'Ver errores de la auditoría',
                caracteristicas: 'Características',
                no_caracteristicas: 'No hay Características',
                comprobaciones: 'Comprobaciones',
                no_comprobaciones: 'No hay Comprobaciones',
                inspector: 'Inspector',
                con_conflictos: 'Con Incidencias',
                fecha_creacion: 'Fecha Creación Pedido',
                desde: 'Desde',
                hasta: 'Hasta',
                duracion_estimada: 'Duración estimada',
                duracion: 'Duración',
                importe: 'Importe',
                fecha_visita_new: 'Nueva Fecha Visita',
                inspector_new: 'Nuevo Inspector',
                hora_new: 'Nueva Hora',
                importe_new: 'Nuevo Importe',
                motivo: 'Motivo cambio fecha',
                motivo_rechazo: 'Motivo rechazo',
                confirmacion_aceptacion_justificantes: '¿Seguro que quiere aceptar los justificantes y marcar la cerfificación como buena?',
                tratamiento_ionizado: 'Tratamiento Ionizado',
                observaciones: 'Observaciones',
                equipos: 'Equipos',
                linea: 'Línea Pedido',
                sin_incidencias: 'Sin incidencias',
                refreshEnvio: 'Refrescar estado de firma',
                bloqueado: 'Expediente bloqueado',
                auditoria_manual: 'Con auditoría manual',
                tipoMedidaDefecto: 'Tipo de Medida a Adoptar',
                faltaMantenimiento: 'Falta de Mantenimiento',
                servicio: 'Servicio',
                item: 'Item',
                codigoPedido: 'Código pedido',
                numeroPedido: 'Número pedido',
                numeroLinea: 'Línea',
                materia: 'Materia',
                materiaCodExp: "Cod Exp Materia",
                forzarPrecargas: "Forzar precargas",
                sync: 'Sincronizar',
                comprobar_reglas: 'Auditar',
                horaIncorrecta: 'La configuración de la hora del dispositivo es incorrecta, vaya a la configuración y deje tanto la hora como la zona horaria en modo automático.',
            },
            popupauditoria: {
                erroresAuditoria: 'Lista de errores de auditoría',
                descripcionerror: 'Descripción del error detectado'
            },
            popup_certificado: {
                certificadofirmado: 'Adjuntar Certificado firmado por el inspector',
                certificadosinfirmar: 'Adjuntar Certificado sin firmar por el inspector',
                anadircertificadofirmado: 'Añadir certificado firmado',
                anadircertificadosinfirma: 'Añadir certificado'
            }
        },
        expediente_cambios: {
            menu: {
                title: 'Cambios en el expediente',
            },
            list: {
                title: 'Cambios en el expediente',
            },
        },
        conflictos: {
            conflictos: {
                conflictos: 'Incidencias'
            },
            conflicto_form: {
                editar_conflicto: 'Editar incidencia',
                nuevo_conflicto: 'Nueva incidencia',
                conflicto_guardado: 'Incidencia guardada con éxito',
                conflicto: 'Incidencia',
                codigoInspeccion: 'Código Expediente',
                tipo_conflicto: 'Tipo Incidencia',
                fecha_conflicto: 'Fecha Incidencia',
                fecha_resolucion: 'Fecha Resolución',
                cliente: 'Cliente',
                inspeccion: 'Expediente',
                resolucion: 'Resolución',
                comentarios: 'Comentarios inspector',
                comentarios_resolucion: 'Comentarios resolucion',
                comentarios_rechazo: 'Comentarios rechazo',
                matricula: 'Matrícula',
                bastidor: 'Bastidor',
                modelo: 'Modelo',
                marca: 'Marca',
                coche: 'Coche',
                estandar: 'Estándar',
                subestandar: 'Sub-Estándar',
                documentos_adjuntos: 'Documentos Adjuntos',
                desde: 'Desde',
                hasta: 'Hasta'
            }
        },
        coches: {
            coches: {
                coches: 'Coches'
            },
            coche_form: {
                matricula: 'Matrícula',
                bastidor: 'Bastidor',
                modelo: 'Modelo',
                marca: 'Marca',
                editar_coche: 'Editar coche',
                nuevo_coche: 'Nuevo coche',
                coche_guardado: 'Coche guardado',
                coche: 'Coche'
            }
        },
        marcas: {
            marcas: {
                marcas: 'Marcas'
            },
            marca_form: {
                nombre: 'Nombre',
                marca: 'Marca',
                editar_marca: 'Editar marca',
                nuevo_marca: 'Nueva marca',
                marca_guardada: 'Marca guardada',
                marca: 'Marca'
            }
        },
        modelos: {
            modelos: {
                modelos: 'Modelos'
            },
            modelo_form: {
                nombre: 'Nombre',
                modelo: 'Modelo',
                editar_modelo: 'Editar modelo',
                nuevo_modelo: 'Nuevo modelo',
                modelo_guardado: 'Modelo guardado',
                modelo: 'Modelo',
                marca: 'Marca'
            }
        },
        clientes: {
            codCliente: 'Cod. Cli.',
            clientes: 'Clientes',
            nombre: 'Nombre',
            codigo: 'Código',
            nif: 'NIF',
            tipoCliente: 'Tipo de cliente',
            ubicacion: 'Ubicación',
            eMail: 'Email',
            razonSocial: 'Razón Social',
            clientePadre: 'Cliente padre',
            codigo_postal: 'Código postal',
            direccion: 'Dirección',
            poblacion: 'Población',
            provincia: 'Provincia',
            pais: 'País',
            cliente: 'Cliente',
            editar_cliente: 'Editar cliente',
            nuevo_cliente: 'Nuevo cliente',
            cliente_guardado: 'Cliente guardado',
            hora_apertura: 'Hora Apertura',
            hora_cierre: 'Hora Cierre',
            direccion_facturacion: 'Dirección Facturación',
            direccion_envio: 'Dirección Envío',
            configuraciones: 'Configuraciones',
            tiempo: 'Tiempo defecto',
            precio: 'Precio',
            formato_factura: 'Formato en Factura',
            tipo_configuracion: 'Tipo Configuración',
            tipo_inspeccion: 'Tipo Expediente',
            valor: 'Valor',
            matricula: 'Matrícula',
            bastidor: 'Bastidor',
            certificacion_1: 'Certificaciones de 1as',
            certificacion_2: 'Certificaciones de 2as',
            certificacion_M: 'Certificaciones de Marca',
            imagen: 'Seleccionar Imagen',
            marcas: 'Marcas',
            add: 'Añadir',
            marca: 'Marca',
            alcance: 'Alcance',
            formato: 'Formato',
            tipo: 'Tipo',
            valor: 'Valor',
            telefono: 'Teléfono',
            telefono_movil: 'Teléfono Móvil',
            fax: 'Fax',
            email: 'Email',
            web: 'Web',
            alias: 'Alias',
            direcciones: 'Direcciones',
            enviar_a: 'ENVIO',
            apellidos: 'Apellidos',
            posicion: 'Posición',
            contactos: 'Contactos',
            activo: 'Activo',
            empresaMantenedora: 'Empresa Mantenedora',
            potencial: 'Cliente Potencial',
            acronimo: 'Acrónimo',
            grupocliente: 'Grupo Cliente',
            listaPrecios: 'Lista de Precios',
            condicionesPago: 'Condiciones de Pago',
            condicionPago: 'Condición de Pago',
            viaPago: 'Vía de Pago',
            viasPago: 'Vías de Pago',
            recargoEquivalencia: 'Recargo Equivalencia',
            impuestoDiferido: 'Impuesto Diferido',
            codigoOperacion347: 'Código Operación 347',
            operacionAseguradora347: 'Operación Aseguradora 347',
            impuestos: 'Impuestos',
            fechaCaptacion: 'Fecha Captación',
            comunidadAutonoma: 'Comunidad Autónoma',
            moneda: 'Moneda',
            contactoDefecto: 'Contacto Defecto',
            direccionDefectoFacturas: 'Direccion Facturación Defecto',
            direccionDefectoEnvio: 'Direccion Envío Defecto',
            viaPagoDefecto: 'Vía Pago Defecto',
            servicios: 'Servicios',
            servicio: 'Servicio',
            destinatario_factura: 'FACTURACION',
            canalescomunicacion: 'Canales de Comunicación',
            iban: 'IBAN',
            clienteIndirecto: 'Cliente Indirecto',
            responsable: 'Responsable',
            empleadoVentas: 'Empleado de ventas',
            fechasPago: 'Fechas de pago',
            cuentasContables: 'Cuentas contables',
            cuentaClientes: 'Cuenta Clientes',
            cuentaCompensacionAnticipos: 'Cuenta Compensación Anticipos',
            cuentaProvisionalAnticipo: 'Cuenta Provisional Anticipo',
            titular: {
                title: 'Datos del titular',
                nombre: 'Nombre',
                apellidos: 'Apellidos',
                nif: 'NIF'
            },
            contacto: {
                dni: 'DNI',
                nombre: 'Nombre',
                apellidos: 'Apellidos',
                posicion: 'Posición',
            }
        },
        proveedores: {
            proveedores: 'Proveedores',
            nombre: 'Nombre',
            codigo: 'Código',
            nif: 'NIF',
            tipoProveedor: 'Tipo de proveedor',
            ubicacion: 'Ubicación',
            eMail: 'Email',
            razonSocial: 'Razón social',
            clientePadre: 'Cliente padre',
            codigo_postal: 'Código postal',
            direccion: 'Dirección',
            poblacion: 'Población',
            provincia: 'Provincia',
            pais: 'País',
            proveedor: 'Proveedor',
            editar: 'Editar Proveedor',
            nuevo: 'Nuevo Proveedor',
            proveedor_guardado: 'Proveedor guardado',
            hora_apertura: 'Hora Apertura',
            hora_cierre: 'Hora Cierre',
            direccion_facturacion: 'Dirección Facturación',
            direccion_envio: 'Dirección Envío',
            configuraciones: 'Configuraciones',
            tiempo: 'Tiempo defecto',
            precio: 'Precio',
            formato_factura: 'Formato en Factura',
            tipo_configuracion: 'Tipo Configuración',
            tipo_inspeccion: 'Tipo Expediente',
            valor: 'Valor',
            matricula: 'Matrícula',
            bastidor: 'Bastidor',
            certificacion_1: 'Certificaciones de 1as',
            certificacion_2: 'Certificaciones de 2as',
            certificacion_M: 'Certificaciones de Marca',
            imagen: 'Seleccionar Imagen',
            marcas: 'Marcas',
            add: 'Añadir',
            marca: 'Marca',
            alcance: 'Alcance',
            formato: 'Formato',
            tipo: 'Tipo',
            valor: 'Valor',
            telefono: 'Teléfono',
            telefono_movil: 'Teléfono Móvil',
            fax: 'Fax',
            email: 'Email',
            web: 'Web',
            alias: 'Alias',
            direcciones: 'Direcciones',
            enviar_a: 'ENVIO',
            apellidos: 'Apellidos',
            posicion: 'Posición',
            contactos: 'Contactos',
            activo: 'Activo',
            empresaMantenedora: 'Empresa Mantenedora',
            potencial: 'Cliente Potencial',
            acronimo: 'Acrónimo',
            grupoproveedor: 'Grupo Proveedor',
            listaPrecios: 'Lista de Precios',
            condicionPago: 'Condición de Pago',
            viaPago: 'Vía de Pago',
            viasPago: 'Vías de Pago',
            recargoEquivalencia: 'Recargo Equivalencia',
            impuestoDiferido: 'Impuesto Diferido',
            codigoOperacion347: 'Código Operación 347',
            operacionAseguradora347: 'Operación Aseguradora 347',
            impuestos: 'Impuestos',
            fechaCaptacion: 'Fecha Captación',
            comunidadAutonoma: 'Comunidad Autónoma',
            moneda: 'Moneda',
            contactoDefecto: 'Contacto Defecto',
            direccionDefectoFacturas: 'Direccion Facturación Defecto',
            direccionDefectoEnvio: 'Direccion Envío Defecto',
            viaPagoDefecto: 'Vía Pago Defecto',
            servicios: 'Servicios',
            servicio: 'Servicio',
            destinatario_factura: 'FACTURACION',
            canalescomunicacion: 'Canales de Comunicación'
        },

        configuracion: {
            configuracion: 'Configuración',
            politica_privacidad: 'Política de privacidad',
            tema_oscuro: 'Tema oscuro',
            idioma: {
                idioma: 'Idioma',
                espanol: 'Español',
                ingles: 'Inglés'
            }
        },

        rlist: {
            pregunta_eliminar_registro: "¿Está seguro de que desea eliminar este registro?",
            pregunta_eliminar_registros: "¿Está seguro de que desea eliminar estos registros?",
            registro_eliminado: "Registro eliminado con éxito",
            n_registros_seleccionados: "{count} registro seleccionado | {count} registros seleccionados",
            n_registros: "{count} registro | {count} registros"
        },
        rform: {
            error_subiendo_archivos: "Error subiendo archivos",
            error_validacion_formulario: "Hay errores en el formulario"
        },
        repartos: {
            ejecucion: "Reparto de Ejecución",
            contratacion: "Reparto de Contratación",
            deshacerTodos: "Deshacer todos los cambios",
            deshacer: "Deshacer cambios en esta línea",
            duplicarArriba: "Copiar reparto a líneas anteriores",
            duplicarAbajo: "Copiar reparto a líneas posteriores",
            anadir: "Añadir línea de reparto",
            equitativo: "Repartir equitativamente",
            eliminar: "Eliminar línea de reparto",
            // Avisos al guardar el reparto de ejecución (#424). Los avisos en sí los redacta la API
            // con los datos del caso (nombres, porcentajes y fechas); aquí está solo lo que envuelve.
            avisos: {
                titulo: "Reparto de ejecución",
                linea: "Línea",
                encabezado: "El reparto de ejecución de estas líneas no cumple lo siguiente:",
                pie: "Hay casos legítimos para las tres cosas, así que se puede guardar igualmente: al continuar se pide un motivo —uno solo para todos los avisos— y queda en el histórico del reparto con tu usuario y la fecha.",
                cancelar: "Volver al pedido sin guardar",
                unir: "Unir las filas repetidas",
                continuar: "Guardar indicando el motivo",
                motivo: "Motivo (obligatorio). Queda en el histórico del reparto con tu usuario y la fecha:",
                faltaMotivo: "Hace falta escribir un motivo para guardar un reparto con avisos.",
                cancelado: "No se ha guardado nada.",
                noComprobado: "No se ha podido comprobar el reparto de ejecución. Se puede guardar igualmente: el descuadre queda anotado en el histórico del reparto.",
                canceladoSinComprobar: "No se ha guardado nada: el reparto de ejecución no se ha podido comprobar."
            },
            historico: {
                titulo: "Histórico del reparto de ejecución",
                vacio: "Sin entradas en el histórico.",
                sinMotivo: "Sin motivo"
            }
        },
        planificacion: {
            fechaPlanif: 'Fecha inspección'
        },
        incidencias: {
            titulo: 'Incidencias de planificación',
            subtitulo: 'Qué completar para rutas optimizadas',
            filtroEstado: 'Estado',
            filtroTipo: 'Tipo',
            todos: 'Todos',
            resolver: 'Resolver',
            resuelta: 'Incidencia resuelta',
            sinIncidencias: 'No hay incidencias',
            fechaDeteccion: 'Detectada',
            fechaResolucion: 'Resuelta el',
            inspector: 'Inspector',
            expediente: 'Expediente',
            servicio: 'Servicio',
            noAutorizado: 'No está autorizado para acceder a las incidencias de planificación',
            estado: {
                ABIERTA: 'Abierta',
                RESUELTA: 'Resuelta'
            },
            severidad: {
                INFO: 'Info',
                AVISO: 'Aviso',
                BLOQUEA_OPTIMIZACION: 'Bloquea optimización'
            },
            tipo: {
                SIN_COORDS: 'Sin coordenadas',
                DIRECCION_INCOMPLETA: 'Dirección incompleta',
                NO_RUTEABLE: 'No ruteable',
                GOOGLE_ERROR: 'Error de Google',
                MATRIZ_LIMITE: 'Límite de matriz'
            }
        },
        inspeccion_sin_pedido : {
            servicio: 'Servicio',
            fechaVisita: 'Fecha Visita',
            direccion: 'Dirección',
            comentariosPlanificacion: 'Comentarios planificación',
            tiempoEstimadoCampo: 'Tiempo Estimado Campo (Minutos)',
            cliente: 'Cliente'
        },
        informes: {
            title: 'Informes'
        },
        registroemail: {
            title: 'Registro de Emails',
            registroemail: 'Registro de Emails',
            fechaEnvio: 'Fecha Envío',
            from: 'De',
            to: 'Para',
            cc: 'CC',
            cco: 'CCO',
            subject: 'Asunto',
            body: 'Cuerpo',
            attachments: 'Adjuntos',
            codigoCampania: 'Código Campaña',
            codigoOportunidad: 'Código Oportunidad',
            codigoOferta: 'Código Oferta',
            numeroOferta: 'Número Oferta',
            codigoPedido: 'Código Pedido',
            numeroPedido: 'Número Pedido',
            numeroLinea: 'Número Línea',
            numeroFactura: 'Número Factura',
            codigoExpediente: 'Código Expediente',
            codigoTarea: 'Código Tarea',
            codigoCliente: 'Código Cliente',
            nombreCliente: 'Nombre Cliente',
            tipoEmail: 'Tipo Email',
            tipoFactura: 'Tipo Factura',
            factura: 'Factura',
            abono: 'Abono',
            estadoEnvio: 'Estado envío',
            error: 'Error',
            entrante: 'Entrante',
            pendienteEnvio: 'Pendiente de envio',
            envioplanificado: 'Envío planificado',
            enviado: 'Enviado',
            errorEstado: 'Error'
        },
        listadoCalendario: {
            calcularResumen: 'Calcular Resumen',
        },
        'Nuevo': 'Nuevo',
        'Editar': 'Editar',
        'Eliminar': 'Eliminar',
        'Tareas': 'Tareas',
        'e-Mails': 'e-Mails',
        'Ofertas': 'Ofertas',
        'Pedidos': 'Pedidos',
        'Número Pedido': 'Número Pedido',
        'Código Tarea': 'Código Tarea',
        'Estado': 'Estado',
        'Tipo Email': 'Tipo Email',
        'Generar oferta': 'Generar oferta',
        'Marcar como Perdida': 'Marcar como Perdida',
        'Enviar e-mail': 'Enviar e-mail',
        'Historico de cambios': 'Historico de cambios',
        'Nombre Campaña': 'Nombre Campaña',
        'Código Cliente': 'Código Cliente',
        'Empleado Ventas Cliente': 'Empleado Ventas Cliente',
        'Lin. Pedido': 'Lin. Pedido',
        'Nº Oferta': 'Nº Oferta',
        'Nombre Cliente': 'Nombre Cliente',
        'Responsable Cliente': 'Responsable Cliente',
    },
    // Traducir literales a inglés
}

export default messages;
